var configs = {
    dev: {
        env: 'dev',
        host: {
            tiger: 'https://backend-dev.codemao.cn',
            platform: 'https://dev-open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
    staging: {
        env: 'staging',
        host: {
            tiger: 'https://backend-test.codemao.cn',
            platform: 'https://staging-open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
    prod: {
        env: 'prod',
        host: {
            tiger: 'https://api.codemao.cn',
            platform: 'https://open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
    'api-test': {
        env: 'api-test',
        host: {
            tiger: 'https://test-api.codemao.cn',
            platform: 'https://test-open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
    test: {
        env: 'test',
        host: {
            tiger: 'https://test-api.codemao.cn',
            platform: 'https://test-open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
    press: {
        env: 'press',
        host: {
            tiger: 'https://press-api.codemao.cn',
            platform: 'https://press-open-service.codemao.cn',
        },
        domain: '.codemao.cn',
    },
};

/**
 * 业务逻辑错误信息集合。
 * 可以在接口的catch通过err.error_code获取到。
 */
var ERROR_TYPE;
(function (ERROR_TYPE) {
    /**
     *
     * 不符合要求的初始化参数
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_INIT_PARAMS"] = -1] = "INVALID_INIT_PARAMS";
    /**
     * Invalid phone number.
     * 不符合要求的电话号码。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_PHONE_NUMBER"] = 0] = "INVALID_PHONE_NUMBER";
    /**
     * Invalid captcha.
     * 不符合要求的短信验证码。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_CAPTCHA"] = 1] = "INVALID_CAPTCHA";
    /**
     * Invalid password.
     * 不符合要求的密码。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_PASSWORD"] = 2] = "INVALID_PASSWORD";
    /**
     * Invalid username.
     * 不符合要求的用户名。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_USERNAME"] = 3] = "INVALID_USERNAME";
    /**
     * Invalid nickname.
     * 不符合要求的昵称。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_NICKNAME"] = 4] = "INVALID_NICKNAME";
    /**
     * Invalid fullname.
     * 不符合要求的全名。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_FULLNAME"] = 5] = "INVALID_FULLNAME";
    /**
     * Invalid qq.
     * 不符合要求的qq号码。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_QQ"] = 6] = "INVALID_QQ";
    /**
     * Invalid description.
     * 不符合要求的个人描述。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_DESCRIPTION"] = 7] = "INVALID_DESCRIPTION";
    /**
     * Invalid sex.
     * 不符合要求的性别。
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_SEX"] = 8] = "INVALID_SEX";
    /**
     * Invalid birthday.
     * 不符合要求的生日时间戳。
     * 格林威治时间1970年01月01日00时00分00秒(北京时间1970年01月01日08时00分00秒)起至现在的
     * 总秒数, 如2018年1月1日，即birthday值为:1514736000
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_BIRTHDAY"] = 9] = "INVALID_BIRTHDAY";
    /**
     * Password not equals confirm password.
     * 密码与确认密码不一致。
     */
    ERROR_TYPE[ERROR_TYPE["PWD_IS_NOT_EQUAL_TO_CONFIRMED_PWD"] = 10] = "PWD_IS_NOT_EQUAL_TO_CONFIRMED_PWD";
    /**
     * No access token when request authorized api.
     * Token 已过期或者没有 token
     * 通常需要重新登录。
     */
    ERROR_TYPE[ERROR_TYPE["NO_TOKEN"] = 11] = "NO_TOKEN";
    /**
     * An error code only appears when the request timeout.
     * 当请求超时会出现的错误码。
     */
    ERROR_TYPE[ERROR_TYPE["REQUEST_TIMEOUT"] = 12] = "REQUEST_TIMEOUT";
    /**
     * An error code only appears when request.onerror ran.
     * 当request.onerror方法被触发时捕获到的错误。
     */
    ERROR_TYPE[ERROR_TYPE["REQUEST_ERROR"] = 13] = "REQUEST_ERROR";
    /**
     * 手机号已注册
     */
    ERROR_TYPE[ERROR_TYPE["PHONE_REGISTERED"] = 14] = "PHONE_REGISTERED";
    /**
     * 手机号暂未注册
     */
    ERROR_TYPE[ERROR_TYPE["PHONE_UNREGISTERED"] = 15] = "PHONE_UNREGISTERED";
    /**
     * 用户不存在或者密码错误
     */
    ERROR_TYPE[ERROR_TYPE["USER_NOT_EXIST_OR_PWD_WRONG"] = 16] = "USER_NOT_EXIST_OR_PWD_WRONG";
    /**
     * 用户不存在
     */
    ERROR_TYPE[ERROR_TYPE["USER_NOT_EXIST"] = 17] = "USER_NOT_EXIST";
    /**
     * 不能设置未来的日期
     */
    ERROR_TYPE[ERROR_TYPE["CANNOT_SET_FUTURE_DATE"] = 18] = "CANNOT_SET_FUTURE_DATE";
    /**
     * 不能重复设置用户名
     */
    ERROR_TYPE[ERROR_TYPE["CANNOT_SET_USERNAME_REPEATEDLY"] = 19] = "CANNOT_SET_USERNAME_REPEATEDLY";
    /**
     * 该用户名已经存在
     */
    ERROR_TYPE[ERROR_TYPE["USERNAME_EXIST"] = 20] = "USERNAME_EXIST";
    /**
     * 用户需要绑定手机
     */
    ERROR_TYPE[ERROR_TYPE["NEED_TO_BIND_PHONE"] = 21] = "NEED_TO_BIND_PHONE";
    /**
     * 需要用当前绑定手机发验证码
     */
    ERROR_TYPE[ERROR_TYPE["USE_BOUND_PHONE_TO_RECEIVE_CAPTCHA"] = 22] = "USE_BOUND_PHONE_TO_RECEIVE_CAPTCHA";
    /**
     * 错误的旧密码
     */
    ERROR_TYPE[ERROR_TYPE["WRONG_OLD_PWD"] = 23] = "WRONG_OLD_PWD";
    /**
     * 密码不一致
     */
    ERROR_TYPE[ERROR_TYPE["PWDS_DO_NOT_MATCH"] = 24] = "PWDS_DO_NOT_MATCH";
    /**
     * 初始密码只能设置一次
     */
    ERROR_TYPE[ERROR_TYPE["INIT_PWD_CAN_SET_ONLY_ONCE"] = 25] = "INIT_PWD_CAN_SET_ONLY_ONCE";
    /**
     * 需存在主账号(至少包含邮箱、用户名、手机其一)
     */
    ERROR_TYPE[ERROR_TYPE["NEED_PRIMARY_ACCOUNT"] = 26] = "NEED_PRIMARY_ACCOUNT";
    /**
     * 校验码验证失败
     */
    ERROR_TYPE[ERROR_TYPE["VERIFY_CAPTCHA_FAIL"] = 27] = "VERIFY_CAPTCHA_FAIL";
    /**
     * 用户已经绑定过手机
     */
    ERROR_TYPE[ERROR_TYPE["USER_PHONE_BOUND"] = 28] = "USER_PHONE_BOUND";
    /**
     * 原手机号不正确
     */
    ERROR_TYPE[ERROR_TYPE["OLD_PHONE_WRONG"] = 29] = "OLD_PHONE_WRONG";
    /**
     * 非法操作
     */
    ERROR_TYPE[ERROR_TYPE["ILLEGAL_OPERATION"] = 30] = "ILLEGAL_OPERATION";
    /**
     * 不能绑定原手机号
     */
    ERROR_TYPE[ERROR_TYPE["CANNOT_BIND_OLD_PHONE"] = 31] = "CANNOT_BIND_OLD_PHONE";
    /**
     * 不合法的oauth_ticket
     */
    ERROR_TYPE[ERROR_TYPE["ILLEGAL_OAUTH_TICKET"] = 32] = "ILLEGAL_OAUTH_TICKET";
    /**
     * 不合法的授权类别
     */
    ERROR_TYPE[ERROR_TYPE["ILLEGAL_AUTHORIZATION_CATEGORY"] = 33] = "ILLEGAL_AUTHORIZATION_CATEGORY";
    /**
     * 第三方授权账号已被绑定
     */
    ERROR_TYPE[ERROR_TYPE["THIRD_PARTY_ACCOUNT_BOUND"] = 34] = "THIRD_PARTY_ACCOUNT_BOUND";
    /**
     * 账号已经绑定同类型授权账号
     */
    ERROR_TYPE[ERROR_TYPE["AUTHORIZATION_ACCOUNT_BOUND"] = 35] = "AUTHORIZATION_ACCOUNT_BOUND";
    /**
     * 请先绑定手机或者设置用户名及密码
     */
    ERROR_TYPE[ERROR_TYPE["BIND_PHONE_OR_SET_USERNAME_AND_PWD"] = 36] = "BIND_PHONE_OR_SET_USERNAME_AND_PWD";
    /**
     * 发送验证码过于频繁
     */
    ERROR_TYPE[ERROR_TYPE["SEND_CAPTCHA_TOO_FRUQUENTLY"] = 37] = "SEND_CAPTCHA_TOO_FRUQUENTLY";
    /**
     * 不合法的pid
     */
    ERROR_TYPE[ERROR_TYPE["ILLEGAL_PID"] = 38] = "ILLEGAL_PID";
    /**
     * 已经存在相同的昵称
     */
    ERROR_TYPE[ERROR_TYPE["NICKNAME_EXIST"] = 39] = "NICKNAME_EXIST";
    /**
     * 该手机号已被其他帐号绑定
     */
    ERROR_TYPE[ERROR_TYPE["PHONE_BOUND_BY_OTHER_ACCOUNT"] = 40] = "PHONE_BOUND_BY_OTHER_ACCOUNT";
    /**
     * QQ登录错误
     */
    ERROR_TYPE[ERROR_TYPE["QQ_ERROR_RECEIVED"] = 41] = "QQ_ERROR_RECEIVED";
    /**
     * 微信登录错误
     */
    ERROR_TYPE[ERROR_TYPE["WECHAR_ERROR_RECEIVED"] = 42] = "WECHAR_ERROR_RECEIVED";
    /**
     * access token 不合法
     */
    ERROR_TYPE[ERROR_TYPE["TOKEN_INVALID"] = 43] = "TOKEN_INVALID";
    /**
     * refresh token 不合法
     */
    ERROR_TYPE[ERROR_TYPE["REFRESH_TOKEN_INVALID"] = 44] = "REFRESH_TOKEN_INVALID";
    /**
     * 错误的 ticket
     */
    ERROR_TYPE[ERROR_TYPE["WRONG_TICKET"] = 45] = "WRONG_TICKET";
    /**
     * 利用旧登录态的 cookie 去获取新登录态的 token的接口
     * 可能会出现的错误。
     */
    ERROR_TYPE[ERROR_TYPE["COOKIE_INVALID"] = 46] = "COOKIE_INVALID";
    ERROR_TYPE[ERROR_TYPE["Appid_NotFound"] = 47] = "Appid_NotFound";
    ERROR_TYPE[ERROR_TYPE["Default_CaptchaRule_NotFound"] = 48] = "Default_CaptchaRule_NotFound";
    ERROR_TYPE[ERROR_TYPE["TencentCaptcha_Exception"] = 49] = "TencentCaptcha_Exception";
    ERROR_TYPE[ERROR_TYPE["GeetestCaptcha_Exception"] = 50] = "GeetestCaptcha_Exception";
    /**
     * 邮箱校验错误
     */
    ERROR_TYPE[ERROR_TYPE["INVALID_EMAIL_ADDRESS"] = 51] = "INVALID_EMAIL_ADDRESS";
    /**
     * 邮箱应注册过了
     */
    ERROR_TYPE[ERROR_TYPE["EMAIL_HAS_REGISTERED"] = 52] = "EMAIL_HAS_REGISTERED";
    /**
     * 账号被黑名单限制
     */
    ERROR_TYPE[ERROR_TYPE["ACCOUNT_HAS_BLOCKED"] = 53] = "ACCOUNT_HAS_BLOCKED";
    /**
     * 账号被黑名单限制
     */
    ERROR_TYPE[ERROR_TYPE["RECEIVABLE_CAPTCHA_TIMES_LIMITTED"] = 54] = "RECEIVABLE_CAPTCHA_TIMES_LIMITTED";
    /**
     * 必须传入协议id
     */
    ERROR_TYPE[ERROR_TYPE["AGREEMENT_IDS"] = 55] = "AGREEMENT_IDS";
    /**
     * Invalid cipher phone
     * 不符合要求的加密手机号
     */
    ERROR_TYPE[ERROR_TYPE["Invalid_Cipher_Phone"] = 56] = "Invalid_Cipher_Phone";
})(ERROR_TYPE || (ERROR_TYPE = {}));

var version = "0.16.4";

// All Account 3.0 apis for web.
var Api = {
    REGISTER_SEND_CAPTCHA: '/tiger/v3/web/accounts/captcha/register/phone/with-agreement',
    REGISTER: '/tiger/v3/web/accounts/register/phone/with-agreement',
    LOGIN_CAPTCHA: '/tiger/v3/web/accounts/captcha/login/post-process',
    LOGIN_PHONE: '/tiger/v3/web/accounts/phone/login/post-process',
    LOGIN_ACCOUNT: '/tiger/v3/web/accounts/login',
    LOGIN_WECHAT: '/tiger/v3/web/accounts/oauth/wechat',
    LOGIN_QQ: '/tiger/v3/web/accounts/oauth/qq',
    BIND_PHONE_FOR_THIRD_PARTY: '/tiger/v3/web/accounts/captcha/oauth',
    CREATE_USER_FOR_THIRD_PARTY: '/tiger/v3/web/accounts/oauth/third-party',
    SET_USERNAME: '/tiger/v3/web/accounts/username',
    BIND_PHONE_CAPTCHA: '/tiger/v3/web/accounts/captcha/phone/bind',
    BIND_PHONE: '/tiger/v3/web/accounts/phone/bind',
    BIND_PHONE_CHECK: '/tiger/v3/web/accounts/phone/check',
    REBIND_PHONE_CAPTCHA: '/tiger/v3/web/accounts/captcha/phone/change',
    REBIND_PHONE: '/tiger/v3/web/accounts/phone/change',
    CHANGE_PWD_BY_OLD: '/tiger/v3/web/accounts/password',
    CHNAGE_PWD_BY_PHONE_CAPTCHA: '/tiger/v3/web/accounts/captcha/password/update',
    CHANGE_PWD_BY_PHONE: '/tiger/v3/web/accounts/password/phone',
    INIT_PASSWORD: '/tiger/v3/web/accounts/password/setting',
    RESET_PWD_CAPTCHA: '/tiger/v3/web/accounts/captcha/password/reset',
    RESET_PWD_TOKEN: '/tiger/v3/web/accounts/captcha/password/check',
    RESET_PWD: '/tiger/v3/web/accounts/password/reset',
    SET_PROFILE: '/tiger/v3/web/accounts/info',
    CHECK_BIND_FOR_THIRD_PARTY: '/tiger/v3/web/accounts/oauths',
    BIND_WECHAT: '/tiger/v3/web/accounts/oauth/wechat/bind',
    UNBIND_WECHAT: '/tiger/v3/web/accounts/oauth/wechat/unbind',
    BIND_QQ: '/tiger/v3/web/accounts/oauth/qq/bind',
    UNBIND_QQ: '/tiger/v3/web/accounts/oauth/qq/unbind',
    GET_PROFILE: '/tiger/v3/web/accounts/profile',
    GET_AUTH: '/tiger/v3/web/accounts/privacy',
    // 获取年级信息
    GET_GRADE_LIST: '/tiger/v3/web/accounts/grade-list',
    LOGOUT: '/tiger/v3/web/accounts/logout',
    SEND_UNIVERSAL_CAPTCHA: '/tiger/v3/web/accounts/captcha/common',
    VERIFY_UNIVERSAL_CAPTCHA: '/tiger/v3/web/accounts/captcha/common/check',
    LOGIN_CAPTCHA_SILENCE: '/tiger/v3/web/accounts/captcha/login/silence',
    LOGIN_PHONE_SILENCE: '/tiger/v3/web/accounts/phone/login/silence',
    LOGIN_ACCOUNT_TICKET: '/tiger/v3/web/accounts/login/security',
    // 获取公钥
    GET_PUBLIC_KEY: '/tiger/v3/web/accounts/rsa/public-key',
    // 邮箱验证码发送
    SEND_EMAIL_REGISTERATION_CAPTCHA: '/tiger/v3/web/accounts/email/captcha/send',
    // 验证邮箱验证码
    VERIFY_EMAIL_REGISTERATION_CAPTCHA: '/tiger/v3/web/accounts/email/captcha/check',
    // 邮箱注册
    REGISTER_BY_EMAIL: '/tiger/v3/web/accounts/email/register',
    // 获取协议列表
    GET_AGREEMENTS: '/tiger/v3/web/accounts/agreements',
    // 获取需签署的协议列表
    GET_AGREEMENTS_NEED_SIGN: '/tiger/v3/web/accounts/agreements/need-sign',
    // 签署协议列表
    SIGN_AGREEMENTS: '/tiger/v3/web/accounts/agreements/sign',
    // 语音验证码
    VOICE_CAPTCHA: '/tiger/v3/web/accounts/voice/captcha/send',
    // 查询最新协议-免登录开放接口
    FIND_LATEST_PROTOCOL_LIST: '/tiger/v3/web/accounts/protocol/list',
};
var TIGER_CAPTCHA_API = {
    GET_RULE: '/tiger/captcha/graph/rule',
    GET_GEETEST_PARAMS: '/tiger/captcha/graph/geetest/register_slide',
    CHECK_AND_GET_GEETEST_TICKET: '/tiger/captcha/graph/tickets/geetest',
    CHECK_AND_GET_WATERPROOFWALL_TICKET: '/tiger/captcha/graph/tickets/waterproof-wall',
};
var PLATFORM_CAPTCHA_API = {
    GET_RULE: '/captcha/rule/v3',
    GET_GEETEST_PARAMS: '/captcha/geetest/register',
    CHECK_AND_GET_GEETEST_TICKET: '/captcha/geetest/verify',
    CHECK_AND_GET_TENCENT_TICKET: '/captcha/tencent',
    CHECK_AND_GET_NEXTDATA_TICKET: '/captcha/nextdata',
    CHECK_AND_GET_NETEASE_TICKET: '/captcha/netease',
    CHECK_AND_GET_ALIYUN_TICKET: '/captcha/aliyun',
};
var TIGER_TOKEN_API = {
    REFRESH_TOKEN: '/tiger/v3/web/accounts/tokens/refresh',
    DELETE_TOKEN: '/tiger/v3/web/accounts/tokens',
    GET_TOKEN_FROM_OLD_COOKIE: '/tiger/v3/web/accounts/tokens/convert',
};
var PUBLIC_HEADERS = {
    Net: navigator.connection
        ? navigator.connection.effectiveType
        : '',
    'SDK-Account-Version': version,
};

var api = /*#__PURE__*/Object.freeze({
__proto__: null,
Api: Api,
TIGER_CAPTCHA_API: TIGER_CAPTCHA_API,
PLATFORM_CAPTCHA_API: PLATFORM_CAPTCHA_API,
TIGER_TOKEN_API: TIGER_TOKEN_API,
PUBLIC_HEADERS: PUBLIC_HEADERS
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * This file is used to integrate error message.
 */
/**
 * 到底叫什么？¸
 * 原来 {string} error_msg  Error message.
 */
/**
 * Creates an instance of CodemaoError.
 *
 * @param {number} error_code Unique error code.
 *
 * @param {number} message Unique error code.
 *
 * @param {string} response   Error original body.
 */
var CodemaoError = /** @class */ (function (_super) {
    __extends(CodemaoError, _super);
    function CodemaoError(options) {
        var _this = _super.call(this, options.message) || this;
        var error_code = options.error_code, _a = options.error_origin_response, error_origin_response = _a === void 0 ? {
            error_code: error_code,
            error_message: options.message,
            error_number: error_code || null,
        } : _a;
        if (options.error_code !== undefined) {
            _this.error_code = error_code;
        }
        if (options.error_body) {
            _this.error_body = options.error_body;
        }
        _this.response = error_origin_response;
        return _this;
    }
    return CodemaoError;
}(Error));
var CodemaoConsoleError = /** @class */ (function () {
    function CodemaoConsoleError(message) {
        console.error("Iris SDK error: " + message);
    }
    return CodemaoConsoleError;
}());
// Map the back-end error to iris error.
var BackendError = {
    AC3_0: {
        error_code: ERROR_TYPE.PHONE_REGISTERED,
        message: 'Phone number is registered.',
    },
    AC3_1: {
        error_code: ERROR_TYPE.PHONE_UNREGISTERED,
        message: 'Phone number is unregistered.',
    },
    AC3_2: {
        error_code: ERROR_TYPE.USER_NOT_EXIST_OR_PWD_WRONG,
        message: 'User doesn\'t exist or password is wrong.',
    },
    AC3_3: {
        error_code: ERROR_TYPE.USER_NOT_EXIST,
        message: 'User doesn\'t exist.',
    },
    AC3_4: {
        error_code: ERROR_TYPE.CANNOT_SET_FUTURE_DATE,
        message: 'Cannot set a future date.',
    },
    AC3_5: {
        error_code: ERROR_TYPE.CANNOT_SET_USERNAME_REPEATEDLY,
        message: 'Cannot set the username repeatedly.',
    },
    AC3_6: {
        error_code: ERROR_TYPE.USERNAME_EXIST,
        message: 'Username is already existed.',
    },
    AC3_7: {
        error_code: ERROR_TYPE.NEED_TO_BIND_PHONE,
        message: 'User need to bind a phone.',
    },
    AC3_8: {
        error_code: ERROR_TYPE.USE_BOUND_PHONE_TO_RECEIVE_CAPTCHA,
        message: 'Need to use the bound phone to receive the captcha.',
    },
    AC3_9: {
        error_code: ERROR_TYPE.WRONG_OLD_PWD,
        message: 'Wrong old password.',
    },
    AC3_10: {
        error_code: ERROR_TYPE.PWDS_DO_NOT_MATCH,
        message: 'Passwords do not match.',
    },
    AC3_11: {
        error_code: ERROR_TYPE.INIT_PWD_CAN_SET_ONLY_ONCE,
        message: 'Init-password can be set only once.',
    },
    AC3_12: {
        error_code: ERROR_TYPE.NEED_PRIMARY_ACCOUNT,
        message: 'Primary account should exist.(one of email, username and phone number).',
    },
    AC3_13: {
        error_code: ERROR_TYPE.VERIFY_CAPTCHA_FAIL,
        message: 'Fail when verifying the captcha.',
    },
    AC3_14: {
        error_code: ERROR_TYPE.USER_PHONE_BOUND,
        message: 'User has bound a phone.',
    },
    AC3_15: {
        error_code: ERROR_TYPE.OLD_PHONE_WRONG,
        message: 'Old phone number is wrong.',
    },
    AC3_16: {
        error_code: ERROR_TYPE.ILLEGAL_OPERATION,
        message: 'Operation is illegal.',
    },
    AC3_17: {
        error_code: ERROR_TYPE.CANNOT_BIND_OLD_PHONE,
        message: 'Cannot bind phone with a old phone number.',
    },
    AC3_18: {
        error_code: ERROR_TYPE.ILLEGAL_OAUTH_TICKET,
        message: 'Oauth_ticket is illegal.',
    },
    AC3_19: {
        error_code: ERROR_TYPE.ILLEGAL_AUTHORIZATION_CATEGORY,
        message: 'Authorization category is illegal.',
    },
    AC3_20: {
        error_code: ERROR_TYPE.THIRD_PARTY_ACCOUNT_BOUND,
        message: 'Third-party account has been bound.',
    },
    AC3_21: {
        error_code: ERROR_TYPE.AUTHORIZATION_ACCOUNT_BOUND,
        message: 'Account has been bound with the the same authorization account.',
    },
    AC3_22: {
        error_code: ERROR_TYPE.BIND_PHONE_OR_SET_USERNAME_AND_PWD,
        message: 'Please bind a phone or set the username.',
    },
    AC3_23: {
        error_code: ERROR_TYPE.SEND_CAPTCHA_TOO_FRUQUENTLY,
        message: 'Request captchas too fruquently.',
    },
    AC3_24: {
        error_code: ERROR_TYPE.ILLEGAL_PID,
        message: 'Pid is illegal.',
    },
    AC3_25: {
        error_code: ERROR_TYPE.NICKNAME_EXIST,
        message: 'Nickname is already existed.',
    },
    AC3_26: {
        error_code: ERROR_TYPE.PHONE_BOUND_BY_OTHER_ACCOUNT,
        message: 'Phone has been bound by other account.',
    },
    AC3_27: {
        error_code: ERROR_TYPE.WRONG_TICKET,
        message: 'Ticket is wrong.',
    },
    AC3_44: {
        error_code: ERROR_TYPE.ACCOUNT_HAS_BLOCKED,
        message: 'Account has blocked in blacklist.',
    },
    AC3_48: {
        error_code: ERROR_TYPE.RECEIVABLE_CAPTCHA_TIMES_LIMITTED,
        message: 'Reached the specified limitation of sending times.',
    },
    AC3_61: {
        error_code: ERROR_TYPE.EMAIL_HAS_REGISTERED,
        message: 'Email has registered.',
    },
    C_1: {
        error_code: ERROR_TYPE.QQ_ERROR_RECEIVED,
        message: 'Receive error from QQ when login with it.',
    },
    C_2: {
        error_code: ERROR_TYPE.WECHAR_ERROR_RECEIVED,
        message: 'Receive error from WeChat when login with it.',
    },
    GCAP_1: {
        error_code: ERROR_TYPE.INVALID_CAPTCHA,
        message: 'Invalid Ticket.',
    },
    '10000000': {
        error_code: ERROR_TYPE.TOKEN_INVALID,
        message: 'Access token is invalid.',
    },
    '10000001': {
        error_code: ERROR_TYPE.REFRESH_TOKEN_INVALID,
        message: 'Refresh token is invalid.',
    },
    '10000002': {
        error_code: ERROR_TYPE.COOKIE_INVALID,
        message: 'Fail to convert cookie to token.',
    },
    '10017001': {
        error_code: ERROR_TYPE.Appid_NotFound,
        message: 'AppidNotFoundException',
    },
    '10017002': {
        error_code: ERROR_TYPE.Default_CaptchaRule_NotFound,
        message: 'DefaultCaptchaRuleNotFoundException',
    },
    '10017003': {
        error_code: ERROR_TYPE.TencentCaptcha_Exception,
        message: 'TencentCaptchaException',
    },
    '10017004': {
        error_code: ERROR_TYPE.GeetestCaptcha_Exception,
        message: 'GeetestCaptchaException',
    },
};
var initParamsRuleAlias = {
    pid: {
        required: true,
        types: ['string'],
    },
    appid: {
        required: true,
        types: ['string', 'number'],
    },
    product_code: {
        required: true,
        types: ['string', 'number'],
    },
};
var initParamsValidateHelper = function ($config) {
    if (!$config) {
        throw new Error('you should specify a config to init Iris auth module');
    }
    Object.keys(initParamsRuleAlias).forEach(function (rule_key) {
        if (rule_key !== 'platform') {
            var value = $config[rule_key];
            if (initParamsRuleAlias[rule_key].required && !value && value !== '') {
                throw new CodemaoError({
                    error_code: ERROR_TYPE.INVALID_INIT_PARAMS,
                    message: rule_key + " is required,but got null or undefined",
                });
            }
            var type = typeof $config[rule_key];
            if (!initParamsRuleAlias[rule_key].types.includes(type)) {
                throw new CodemaoError({
                    error_code: ERROR_TYPE.INVALID_INIT_PARAMS,
                    message: rule_key + " should be type of " + initParamsRuleAlias[rule_key].type.join(' or ') + ",but got " + type,
                });
            }
        }
    });
    return true;
};

// IrisInitParams;
var _initParams = {};
var getInitParams = function () { return _initParams; };
var setInitParams = function (initParams) {
    _initParams = initParams;
};
// IrisConfig
var _config = configs['prod'];
var getConfig = function () { return _config; };
var setConfig = function (config) {
    _config = config;
};
// AuthConfig
var _authConfig;
var getAuthConfig = function () { return _authConfig; };
var setAuthConfig = function (config) {
    _authConfig = config;
};

/**
 * Request module to send request.
 */
var CodemaoRequest = /** @class */ (function () {
    function CodemaoRequest(config) {
        this.hostType = (config && config.hostType) || 'tiger';
        this.timeout = (config && config.timeout) || 20000;
        this.public_headers = config && config.public_headers;
    }
    CodemaoRequest.prototype.get_complete_url = function (url, params) {
        var params_str = Object.keys(params)
            .filter(function (key) { return params[key]; })
            .map(function (key) { return key + "=" + params[key]; })
            .join('&');
        return Object.keys(params).length === 0
            ? "" + getConfig().host[this.hostType] + url
            : "" + getConfig().host[this.hostType] + url + "?" + params_str;
    };
    CodemaoRequest.prototype.dispatch_request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = options.url, method = options.method, data = options.data, without_base_url = options.without_base_url;
                        var params = options.params || {};
                        var compatibleHeaders = {};
                        if (getInitParams().auth_version) {
                            compatibleHeaders['Auth-Version'] = getInitParams().auth_version;
                        }
                        if (getInitParams().client_id) {
                            compatibleHeaders['Client-ID'] = getInitParams().client_id;
                        }
                        var headers = __assign(__assign(__assign({}, _this.public_headers), options.headers), compatibleHeaders);
                        var request_url = without_base_url
                            ? url
                            : _this.get_complete_url(url, params);
                        // [client_id和auth_version] 由 body 修改到 headers 中，所以删了原有assign逻辑❗️
                        var request = new XMLHttpRequest(); // 低版本IE？Nodejs？小程序？还是只考虑web端？
                        request.open(method.toUpperCase(), request_url, true);
                        // Data will be sent with json Content-Type
                        data &&
                            request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
                        request.timeout = getInitParams().requestTimeout || _this.timeout;
                        request.withCredentials = true;
                        request.onreadystatechange = function handle_loaded() {
                            var _a;
                            if (!request || request.readyState !== 4) {
                                return;
                            }
                            // The request errored out and we didn't get a response, this will be
                            // handled by onerror instead
                            // With one exception: request that using file: protocol, most browsers
                            // will return status as 0 even though it's a successful request
                            if (request.status === 0 &&
                                !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                                return;
                            }
                            if (request.status >= 200 && request.status <= 300) {
                                var response = request.response;
                                if (response) {
                                    // status
                                    resolve({
                                        status: request.status,
                                        statusText: request.statusText,
                                        data: JSON.parse(response),
                                    });
                                }
                                else {
                                    resolve({
                                        status: request.status,
                                        statusText: request.statusText,
                                        data: null,
                                    });
                                }
                            }
                            else {
                                try {
                                    var response = JSON.parse(request.response);
                                    // contains iris's error & request_with_token() back-end error.
                                    var error = BackendError[response.error_code];
                                    if (error) {
                                        reject(new CodemaoError(__assign(__assign({}, error), { error_origin_response: response })));
                                    }
                                    else {
                                        reject(new CodemaoError({
                                            error_code: response.error_code,
                                            error_body: ((_a = response.catastrophe) === null || _a === void 0 ? void 0 : _a.error) || response,
                                            error_origin_response: response,
                                            message: "Get error from " + request_url + ".",
                                        }));
                                    }
                                }
                                catch (error) {
                                    reject(error);
                                }
                            }
                            // Clean up request.
                            // request = null;
                        };
                        // Handle low level network errors
                        request.onerror = function () {
                            // Real errors are hidden from us by the browser
                            // onerror should only fire if it's a network error
                            reject(new CodemaoError({
                                error_code: ERROR_TYPE.REQUEST_ERROR,
                                message: 'Network error.',
                            }));
                            // Clean up request.
                            // request = null;
                        };
                        // Handle timeout
                        request.ontimeout = function () {
                            reject(new CodemaoError({
                                error_code: ERROR_TYPE.REQUEST_TIMEOUT,
                                message: "ECONNABORTED:timeout of " + request.timeout + " ms exceeded.",
                            }));
                            // Clean up request.
                            // request = null;
                        };
                        try {
                            if ('setRequestHeader' in request) {
                                Object.keys(headers).forEach(function (val) {
                                    request.setRequestHeader(val, headers[val]);
                                });
                            }
                        }
                        catch (error) {
                            console.error(error);
                            console.log('headers is ', headers);
                            throw new Error('Iris Error: 设置请求头时出错，请检查请求头，不能含有中文');
                        }
                        if (data) {
                            request.send(JSON.stringify(data));
                        }
                        else {
                            request.send();
                        }
                    })];
            });
        });
    };
    return CodemaoRequest;
}());
var TigerApi = new CodemaoRequest();
var PlatformApi = new CodemaoRequest({
    hostType: 'platform',
});

// Function to check if input params' properties are valid.
function check_input_existence(obj, check_properties) {
    if (obj) {
        Object.keys(obj).map(function (property) {
            if (check_properties.indexOf(property) === -1) {
                new CodemaoConsoleError("\u8BF7\u786E\u8BA4 " + property + " \u53C2\u6570\u662F\u5426\u5408\u6CD5");
            }
        });
    }
}
// All RegExp for validation
var phone_number_pattern = /^1[3456789]\d{9}$/;
var captcha_pattern = /^\d{6}$/;
var password_pattern = /^[a-zA-Z0-9\_\-@#?!~$^&\*\(\)\/%<>,\.;:"+=|\\{}\[\]]{6,20}$/;
var username_pattern = /^[a-zA-Z]{1}\w{5,29}$/;
// eslint-disable-next-line no-misleading-character-class
var nickname_pattern = /^[^\s☀☁☂ϟ☉☼☾☽♁♨❄❅❆☃☁✉℡℻☎☏✂✄✆✎✏✐✑✒✇℗©®🅏🆏⚐⚑⚆⚇⚈⚉⚞⚟⚠⚬⚭⚮⚯☊㋀㋁㋂㋃㋄㋅㋆㋇㋈㋉㋊㋋㏠㏡㏢㏣㏤㏥㏦㏧㏨㏩ ㏪㏫㏬㏭㏮㏯㏰㏱㏲㏳㏴㏵㏶㏷㏸㏹㏺㏻㏼㏽㏾㍘㍙㍚㍛㍜㍝㍞㍟㍠㍡㍢㍣㍤㍥㍦㍧㍨㍩㍪㍫㍬㍭㍮㍯㍰㏂㏘♳♴♵♶♷♸♹♺♲♻♼♽⚀⚁⚂⚃⚄⚅]{1,20}$/;
var fullname_pattern = /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z](\s?[a-zA-Z]){3,29})$/;
var qq_pattern = /^\d{5,20}$/;
var email_address_pattern = /^\w+@[a-z0-9]+\.[a-z]{2,4}/;
//
function check(property_name, pattern, error_code) {
    return function (property_value) {
        if (!pattern.test(property_value)) {
            throw new CodemaoError({
                error_code: error_code,
                message: "Invalid " + property_name + " \"" + property_value + "\", it should match the RegExp " + pattern + ".",
            });
        }
    };
}
// Function to check phone number
var check_phone_number = check('phone_number', phone_number_pattern, ERROR_TYPE.INVALID_PHONE_NUMBER);
//
var validate_email_address = check('email_address', email_address_pattern, ERROR_TYPE.INVALID_EMAIL_ADDRESS);
// Function to check captcha
var check_captcha = check('captcha', captcha_pattern, ERROR_TYPE.INVALID_CAPTCHA);
// Function to check password
var check_password = check('password', password_pattern, ERROR_TYPE.INVALID_PASSWORD);
// Function to check username
var check_username = check('username', username_pattern, ERROR_TYPE.INVALID_USERNAME);
// Function to check nickname
var check_nickname = check('nickname', nickname_pattern, ERROR_TYPE.INVALID_NICKNAME);
// Function to check fullname
var check_fullname = check('fullname', fullname_pattern, ERROR_TYPE.INVALID_FULLNAME);
// Function to check qq
var check_qq = check('qq', qq_pattern, ERROR_TYPE.INVALID_QQ);
// Function to check description
function check_description(description) {
    if (description.length > 50) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.INVALID_DESCRIPTION,
            message: 'Invalid description, it should contains only 0 - 50 characters.',
        });
    }
}
// Function to check sex
function check_sex(sex) {
    if (sex !== 0 && sex !== 1) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.INVALID_SEX,
            message: "Invalid sex \"" + sex + "\", it should be 0 or 1.",
        });
    }
}
// Function to check birthday
function check_birthday(birthday) {
    if (!Number.isInteger(birthday)) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.INVALID_BIRTHDAY,
            message: "Invalid birthday \"" + birthday + "\", it should be a integer number.",
        });
    }
}
/**
 * Function to check register options.
 *
 * @export
 * @param {RegisterOptions} options
 */
function check_register_options(options) {
    var phone_number = options.phone_number, password = options.password, captcha = options.captcha, agreement_ids = options.agreement_ids;
    check_phone_number(phone_number);
    check_password(password);
    check_captcha(captcha);
    check_agreement_ids(agreement_ids);
}
function check_register_encrypt_options(options) {
    var cipherPhone = options.cipherPhone, password = options.password, captcha = options.captcha, agreement_ids = options.agreement_ids;
    check_cipher_phone(cipherPhone);
    check_password(password);
    check_captcha(captcha);
    check_agreement_ids(agreement_ids);
}
function check_cipher_phone(value) {
    if (!(typeof value === 'string')) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.Invalid_Cipher_Phone,
            message: "Invalid cipherPhone \"" + value + "\", it should be string.",
        });
    }
}
/**
 *
 * @param profile
 */
function check_agreement_ids(ids) {
    if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.AGREEMENT_IDS,
            message: 'agreement_ids should not be an empty array.',
        });
    }
}
/**
 * Function to check user profilr for set_profile.
 *
 * @export
 * @param {UserProfile} profile
 */
function check_profile(profile) {
    var birthday = profile.birthday, sex = profile.sex, fullname = profile.fullname, nickname = profile.nickname, qq = profile.qq, description = profile.description;
    if (birthday) {
        check_birthday(birthday);
    }
    if (sex) {
        check_sex(sex);
    }
    if (fullname) {
        check_fullname(fullname);
    }
    if (nickname) {
        check_nickname(nickname);
    }
    if (qq) {
        check_qq(qq);
    }
    if (description) {
        check_description(description);
    }
}
/**
 * Functio to check if password equals confirm password.
 *
 * @export
 * @param {string} pwd
 * @param {string} pwd_confirm
 */
function check_if_pwd_equals_confirmed_pwd(pwd, pwd_confirm) {
    if (pwd !== pwd_confirm) {
        throw new CodemaoError({
            error_code: ERROR_TYPE.PWD_IS_NOT_EQUAL_TO_CONFIRMED_PWD,
            message: 'Password is not equal to confirmed password.',
        });
    }
}
/**
 * Function to retry a promise for retries times.
 *
 * @export
 * @param {number} retries
 * @param {Function} fn
 * @returns {Promise<any>}
 */
function retry(retries, fn) {
    return __awaiter(this, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 2:
                    err_1 = _a.sent();
                    if (retries > 1) {
                        return [2 /*return*/, retry(retries - 1, fn)];
                    }
                    else {
                        throw new CodemaoError({
                            message: 'Get geetest init params fail, please reload the page or try again later.',
                        });
                    }
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Function to set cookie with options.
function set_cookie(options) {
    var name = options.name, value = options.value, domain = options.domain, max_age = options.max_age;
    var cookieString = name + "=" + value + "; domain=" + domain + "; max-age=" + max_age + "; path=/;";
    var sameSiteCookie = cookieString + " samesite=none; secure";
    document.cookie = cookieString;
    document.cookie = sameSiteCookie;
}
// Function to get cookie by name.
function get_cookie(name) {
    var cookies = {};
    document.cookie.split(';').forEach(function (cookie) {
        var first_equal_mark_position = cookie.indexOf('=');
        var key = cookie.slice(0, first_equal_mark_position);
        var value = cookie.slice(first_equal_mark_position + 1);
        cookies[key.trim()] = value;
    });
    return cookies[name];
}
// Function to clear cookie by setting max-age to negative number.
function clear_cookie(name, domain) {
    set_cookie({
        name: name,
        value: '',
        domain: domain,
        max_age: -999999,
    });
}
// Function to generate the cookie name according to the env.
function get_cookie_name(type) {
    var env = getConfig().env;
    var prefix = env === 'prod' ? '' : env + "-";
    if (type === 'token_type') {
        /**
         * All possible result
         * 1. prod -- token-type
         * 2. dev -- dev-token-type
         * 3. staging -- staging-token-type
         * 4. api-test -- api-test-token-type
         */
        return prefix + "token-type";
    }
    /**
     * All possible result
     * 1. prod -- ${type}-token
     * 2. dev -- dev-${type}-token
     * 3. staging -- staging-${type}-token
     * 4. api-test -- api-test-${type}-token
     */
    return "" + prefix + type + "-token";
}
function is_cookie_exist(cookie) {
    return cookie && cookie !== 'undefined' && cookie !== '' ? true : false;
}
function load_script(url, id, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (!document.getElementById(id)) {
                        var timer_1;
                        if (timeout) {
                            timer_1 = setTimeout(function () {
                                resolve();
                                clearTimeout(timer_1);
                            }, timeout * 1000);
                        }
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.onload = function () {
                            resolve();
                            if (timer_1) {
                                clearTimeout(timer_1);
                            }
                        };
                        script.id = id;
                        script.src = url;
                        script.setAttribute('defer', '');
                        document.getElementsByTagName('head')[0].appendChild(script);
                    }
                    else {
                        resolve();
                    }
                })];
        });
    });
}
function hasProperty(key, object) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
function appendDomNode(domNodeType, opts, style) {
    return new Promise(function (resolve, reject) {
        var node = document.createElement(domNodeType);
        node.onload = function () {
            resolve(!!1);
        };
        node.onerror = function () {
            reject(!!0);
        };
        opts &&
            Object.keys(opts).forEach(function (keyname) {
                var value = opts[keyname];
                keyname !== 'innerHTML' &&
                    keyname !== 'style' &&
                    node.setAttribute(keyname, typeof value !== 'string' ? JSON.stringify(value) : value);
            });
        node.innerHTML = opts.innerHTML;
        node.setAttribute('style', style || '');
        document.body.appendChild(node);
        resolve(!!1);
    });
}
function simpleHash(tag) {
    var timestamp = "" + new Date().getTime() / 1000;
    return "iris-" + tag + "-" + parseInt(timestamp, 10);
}

var utils = /*#__PURE__*/Object.freeze({
__proto__: null,
check_input_existence: check_input_existence,
check_phone_number: check_phone_number,
validate_email_address: validate_email_address,
check_captcha: check_captcha,
check_password: check_password,
check_username: check_username,
check_nickname: check_nickname,
check_fullname: check_fullname,
check_qq: check_qq,
check_description: check_description,
check_sex: check_sex,
check_birthday: check_birthday,
check_register_options: check_register_options,
check_register_encrypt_options: check_register_encrypt_options,
check_cipher_phone: check_cipher_phone,
check_agreement_ids: check_agreement_ids,
check_profile: check_profile,
check_if_pwd_equals_confirmed_pwd: check_if_pwd_equals_confirmed_pwd,
retry: retry,
set_cookie: set_cookie,
get_cookie: get_cookie,
clear_cookie: clear_cookie,
get_cookie_name: get_cookie_name,
is_cookie_exist: is_cookie_exist,
load_script: load_script,
hasProperty: hasProperty,
appendDomNode: appendDomNode,
simpleHash: simpleHash
});

var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
function int2char(n) {
    return BI_RM.charAt(n);
}
//#region BIT_OPERATIONS
// (public) this & a
function op_and(x, y) {
    return x & y;
}
// (public) this | a
function op_or(x, y) {
    return x | y;
}
// (public) this ^ a
function op_xor(x, y) {
    return x ^ y;
}
// (public) this & ~a
function op_andnot(x, y) {
    return x & ~y;
}
// return index of lowest 1-bit in x, x < 2^31
function lbit(x) {
    if (x == 0) {
        return -1;
    }
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) {
        ++r;
    }
    return r;
}
// return number of 1 bits in x
function cbit(x) {
    var r = 0;
    while (x != 0) {
        x &= x - 1;
        ++r;
    }
    return r;
}
//#endregion BIT_OPERATIONS

var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var b64pad = "=";
function hex2b64(h) {
    var i;
    var c;
    var ret = "";
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    }
    else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
        ret += b64pad;
    }
    return ret;
}
// convert a base64 string to hex
function b64tohex(s) {
    var ret = "";
    var i;
    var k = 0; // b64 state, 0-3
    var slop = 0;
    for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) == b64pad) {
            break;
        }
        var v = b64map.indexOf(s.charAt(i));
        if (v < 0) {
            continue;
        }
        if (k == 0) {
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 1;
        }
        else if (k == 1) {
            ret += int2char((slop << 2) | (v >> 4));
            slop = v & 0xf;
            k = 2;
        }
        else if (k == 2) {
            ret += int2char(slop);
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 3;
        }
        else {
            ret += int2char((slop << 2) | (v >> 4));
            ret += int2char(v & 0xf);
            k = 0;
        }
    }
    if (k == 1) {
        ret += int2char(slop << 2);
    }
    return ret;
}

// Hex JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder;
var Hex = {
    decode: function (a) {
        var i;
        if (decoder === undefined) {
            var hex = "0123456789ABCDEF";
            var ignore = " \f\n\r\t\u00A0\u2028\u2029";
            decoder = {};
            for (i = 0; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            hex = hex.toLowerCase();
            for (i = 10; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 2) {
                out[out.length] = bits;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 4;
            }
        }
        if (char_count) {
            throw new Error("Hex encoding incomplete: 4 bits missing");
        }
        return out;
    }
};

// Base64 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder$1;
var Base64 = {
    decode: function (a) {
        var i;
        if (decoder$1 === undefined) {
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var ignore = "= \f\n\r\t\u00A0\u2028\u2029";
            decoder$1 = Object.create(null);
            for (i = 0; i < 64; ++i) {
                decoder$1[b64.charAt(i)] = i;
            }
            decoder$1['-'] = 62; //+
            decoder$1['_'] = 63; //-
            for (i = 0; i < ignore.length; ++i) {
                decoder$1[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder$1[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 4) {
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                out[out.length] = bits & 0xFF;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 6;
            }
        }
        switch (char_count) {
            case 1:
                throw new Error("Base64 encoding incomplete: at least 2 bits missing");
            case 2:
                out[out.length] = (bits >> 10);
                break;
            case 3:
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                break;
        }
        return out;
    },
    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
    unarmor: function (a) {
        var m = Base64.re.exec(a);
        if (m) {
            if (m[1]) {
                a = m[1];
            }
            else if (m[2]) {
                a = m[2];
            }
            else {
                throw new Error("RegExp out of sync");
            }
        }
        return Base64.decode(a);
    }
};

// Big integer base-10 printing library
// Copyright (c) 2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var max = 10000000000000; // biggest integer that can still fit 2^53 when multiplied by 256
var Int10 = /** @class */ (function () {
    function Int10(value) {
        this.buf = [+value || 0];
    }
    Int10.prototype.mulAdd = function (m, c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] * m + c;
            if (t < max) {
                c = 0;
            }
            else {
                c = 0 | (t / max);
                t -= c * max;
            }
            b[i] = t;
        }
        if (c > 0) {
            b[i] = c;
        }
    };
    Int10.prototype.sub = function (c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] - c;
            if (t < 0) {
                t += max;
                c = 1;
            }
            else {
                c = 0;
            }
            b[i] = t;
        }
        while (b[b.length - 1] === 0) {
            b.pop();
        }
    };
    Int10.prototype.toString = function (base) {
        if ((base || 10) != 10) {
            throw new Error("only base 10 is supported");
        }
        var b = this.buf;
        var s = b[b.length - 1].toString();
        for (var i = b.length - 2; i >= 0; --i) {
            s += (max + b[i]).toString().substring(1);
        }
        return s;
    };
    Int10.prototype.valueOf = function () {
        var b = this.buf;
        var v = 0;
        for (var i = b.length - 1; i >= 0; --i) {
            v = v * max + b[i];
        }
        return v;
    };
    Int10.prototype.simplify = function () {
        var b = this.buf;
        return (b.length == 1) ? b[0] : this;
    };
    return Int10;
}());

// ASN.1 JavaScript decoder
var ellipsis = "\u2026";
var reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
var reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function stringCut(str, len) {
    if (str.length > len) {
        str = str.substring(0, len) + ellipsis;
    }
    return str;
}
var Stream = /** @class */ (function () {
    function Stream(enc, pos) {
        this.hexDigits = "0123456789ABCDEF";
        if (enc instanceof Stream) {
            this.enc = enc.enc;
            this.pos = enc.pos;
        }
        else {
            // enc should be an array or a binary string
            this.enc = enc;
            this.pos = pos;
        }
    }
    Stream.prototype.get = function (pos) {
        if (pos === undefined) {
            pos = this.pos++;
        }
        if (pos >= this.enc.length) {
            throw new Error("Requesting byte offset ".concat(pos, " on a stream of length ").concat(this.enc.length));
        }
        return ("string" === typeof this.enc) ? this.enc.charCodeAt(pos) : this.enc[pos];
    };
    Stream.prototype.hexByte = function (b) {
        return this.hexDigits.charAt((b >> 4) & 0xF) + this.hexDigits.charAt(b & 0xF);
    };
    Stream.prototype.hexDump = function (start, end, raw) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
            if (raw !== true) {
                switch (i & 0xF) {
                    case 0x7:
                        s += "  ";
                        break;
                    case 0xF:
                        s += "\n";
                        break;
                    default:
                        s += " ";
                }
            }
        }
        return s;
    };
    Stream.prototype.isASCII = function (start, end) {
        for (var i = start; i < end; ++i) {
            var c = this.get(i);
            if (c < 32 || c > 176) {
                return false;
            }
        }
        return true;
    };
    Stream.prototype.parseStringISO = function (start, end) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += String.fromCharCode(this.get(i));
        }
        return s;
    };
    Stream.prototype.parseStringUTF = function (start, end) {
        var s = "";
        for (var i = start; i < end;) {
            var c = this.get(i++);
            if (c < 128) {
                s += String.fromCharCode(c);
            }
            else if ((c > 191) && (c < 224)) {
                s += String.fromCharCode(((c & 0x1F) << 6) | (this.get(i++) & 0x3F));
            }
            else {
                s += String.fromCharCode(((c & 0x0F) << 12) | ((this.get(i++) & 0x3F) << 6) | (this.get(i++) & 0x3F));
            }
        }
        return s;
    };
    Stream.prototype.parseStringBMP = function (start, end) {
        var str = "";
        var hi;
        var lo;
        for (var i = start; i < end;) {
            hi = this.get(i++);
            lo = this.get(i++);
            str += String.fromCharCode((hi << 8) | lo);
        }
        return str;
    };
    Stream.prototype.parseTime = function (start, end, shortYear) {
        var s = this.parseStringISO(start, end);
        var m = (shortYear ? reTimeS : reTimeL).exec(s);
        if (!m) {
            return "Unrecognized time: " + s;
        }
        if (shortYear) {
            // to avoid querying the timer, use the fixed range [1970, 2069]
            // it will conform with ITU X.400 [-10, +40] sliding window until 2030
            m[1] = +m[1];
            m[1] += (+m[1] < 70) ? 2000 : 1900;
        }
        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
        if (m[5]) {
            s += ":" + m[5];
            if (m[6]) {
                s += ":" + m[6];
                if (m[7]) {
                    s += "." + m[7];
                }
            }
        }
        if (m[8]) {
            s += " UTC";
            if (m[8] != "Z") {
                s += m[8];
                if (m[9]) {
                    s += ":" + m[9];
                }
            }
        }
        return s;
    };
    Stream.prototype.parseInteger = function (start, end) {
        var v = this.get(start);
        var neg = (v > 127);
        var pad = neg ? 255 : 0;
        var len;
        var s = "";
        // skip unuseful bits (not allowed in DER)
        while (v == pad && ++start < end) {
            v = this.get(start);
        }
        len = end - start;
        if (len === 0) {
            return neg ? -1 : 0;
        }
        // show bit length of huge integers
        if (len > 4) {
            s = v;
            len <<= 3;
            while (((+s ^ pad) & 0x80) == 0) {
                s = +s << 1;
                --len;
            }
            s = "(" + len + " bit)\n";
        }
        // decode the integer
        if (neg) {
            v = v - 256;
        }
        var n = new Int10(v);
        for (var i = start + 1; i < end; ++i) {
            n.mulAdd(256, this.get(i));
        }
        return s + n.toString();
    };
    Stream.prototype.parseBitString = function (start, end, maxLength) {
        var unusedBit = this.get(start);
        var lenBit = ((end - start - 1) << 3) - unusedBit;
        var intro = "(" + lenBit + " bit)\n";
        var s = "";
        for (var i = start + 1; i < end; ++i) {
            var b = this.get(i);
            var skip = (i == end - 1) ? unusedBit : 0;
            for (var j = 7; j >= skip; --j) {
                s += (b >> j) & 1 ? "1" : "0";
            }
            if (s.length > maxLength) {
                return intro + stringCut(s, maxLength);
            }
        }
        return intro + s;
    };
    Stream.prototype.parseOctetString = function (start, end, maxLength) {
        if (this.isASCII(start, end)) {
            return stringCut(this.parseStringISO(start, end), maxLength);
        }
        var len = end - start;
        var s = "(" + len + " byte)\n";
        maxLength /= 2; // we work in bytes
        if (len > maxLength) {
            end = start + maxLength;
        }
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
        }
        if (len > maxLength) {
            s += ellipsis;
        }
        return s;
    };
    Stream.prototype.parseOID = function (start, end, maxLength) {
        var s = "";
        var n = new Int10();
        var bits = 0;
        for (var i = start; i < end; ++i) {
            var v = this.get(i);
            n.mulAdd(128, v & 0x7F);
            bits += 7;
            if (!(v & 0x80)) { // finished
                if (s === "") {
                    n = n.simplify();
                    if (n instanceof Int10) {
                        n.sub(80);
                        s = "2." + n.toString();
                    }
                    else {
                        var m = n < 80 ? n < 40 ? 0 : 1 : 2;
                        s = m + "." + (n - m * 40);
                    }
                }
                else {
                    s += "." + n.toString();
                }
                if (s.length > maxLength) {
                    return stringCut(s, maxLength);
                }
                n = new Int10();
                bits = 0;
            }
        }
        if (bits > 0) {
            s += ".incomplete";
        }
        return s;
    };
    return Stream;
}());
var ASN1 = /** @class */ (function () {
    function ASN1(stream, header, length, tag, sub) {
        if (!(tag instanceof ASN1Tag)) {
            throw new Error("Invalid tag value.");
        }
        this.stream = stream;
        this.header = header;
        this.length = length;
        this.tag = tag;
        this.sub = sub;
    }
    ASN1.prototype.typeName = function () {
        switch (this.tag.tagClass) {
            case 0: // universal
                switch (this.tag.tagNumber) {
                    case 0x00:
                        return "EOC";
                    case 0x01:
                        return "BOOLEAN";
                    case 0x02:
                        return "INTEGER";
                    case 0x03:
                        return "BIT_STRING";
                    case 0x04:
                        return "OCTET_STRING";
                    case 0x05:
                        return "NULL";
                    case 0x06:
                        return "OBJECT_IDENTIFIER";
                    case 0x07:
                        return "ObjectDescriptor";
                    case 0x08:
                        return "EXTERNAL";
                    case 0x09:
                        return "REAL";
                    case 0x0A:
                        return "ENUMERATED";
                    case 0x0B:
                        return "EMBEDDED_PDV";
                    case 0x0C:
                        return "UTF8String";
                    case 0x10:
                        return "SEQUENCE";
                    case 0x11:
                        return "SET";
                    case 0x12:
                        return "NumericString";
                    case 0x13:
                        return "PrintableString"; // ASCII subset
                    case 0x14:
                        return "TeletexString"; // aka T61String
                    case 0x15:
                        return "VideotexString";
                    case 0x16:
                        return "IA5String"; // ASCII
                    case 0x17:
                        return "UTCTime";
                    case 0x18:
                        return "GeneralizedTime";
                    case 0x19:
                        return "GraphicString";
                    case 0x1A:
                        return "VisibleString"; // ASCII subset
                    case 0x1B:
                        return "GeneralString";
                    case 0x1C:
                        return "UniversalString";
                    case 0x1E:
                        return "BMPString";
                }
                return "Universal_" + this.tag.tagNumber.toString();
            case 1:
                return "Application_" + this.tag.tagNumber.toString();
            case 2:
                return "[" + this.tag.tagNumber.toString() + "]"; // Context
            case 3:
                return "Private_" + this.tag.tagNumber.toString();
        }
    };
    ASN1.prototype.content = function (maxLength) {
        if (this.tag === undefined) {
            return null;
        }
        if (maxLength === undefined) {
            maxLength = Infinity;
        }
        var content = this.posContent();
        var len = Math.abs(this.length);
        if (!this.tag.isUniversal()) {
            if (this.sub !== null) {
                return "(" + this.sub.length + " elem)";
            }
            return this.stream.parseOctetString(content, content + len, maxLength);
        }
        switch (this.tag.tagNumber) {
            case 0x01: // BOOLEAN
                return (this.stream.get(content) === 0) ? "false" : "true";
            case 0x02: // INTEGER
                return this.stream.parseInteger(content, content + len);
            case 0x03: // BIT_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseBitString(content, content + len, maxLength);
            case 0x04: // OCTET_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseOctetString(content, content + len, maxLength);
            // case 0x05: // NULL
            case 0x06: // OBJECT_IDENTIFIER
                return this.stream.parseOID(content, content + len, maxLength);
            // case 0x07: // ObjectDescriptor
            // case 0x08: // EXTERNAL
            // case 0x09: // REAL
            // case 0x0A: // ENUMERATED
            // case 0x0B: // EMBEDDED_PDV
            case 0x10: // SEQUENCE
            case 0x11: // SET
                if (this.sub !== null) {
                    return "(" + this.sub.length + " elem)";
                }
                else {
                    return "(no elem)";
                }
            case 0x0C: // UTF8String
                return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
            case 0x12: // NumericString
            case 0x13: // PrintableString
            case 0x14: // TeletexString
            case 0x15: // VideotexString
            case 0x16: // IA5String
            // case 0x19: // GraphicString
            case 0x1A: // VisibleString
                // case 0x1B: // GeneralString
                // case 0x1C: // UniversalString
                return stringCut(this.stream.parseStringISO(content, content + len), maxLength);
            case 0x1E: // BMPString
                return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
            case 0x17: // UTCTime
            case 0x18: // GeneralizedTime
                return this.stream.parseTime(content, content + len, (this.tag.tagNumber == 0x17));
        }
        return null;
    };
    ASN1.prototype.toString = function () {
        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + ((this.sub === null) ? "null" : this.sub.length) + "]";
    };
    ASN1.prototype.toPrettyString = function (indent) {
        if (indent === undefined) {
            indent = "";
        }
        var s = indent + this.typeName() + " @" + this.stream.pos;
        if (this.length >= 0) {
            s += "+";
        }
        s += this.length;
        if (this.tag.tagConstructed) {
            s += " (constructed)";
        }
        else if ((this.tag.isUniversal() && ((this.tag.tagNumber == 0x03) || (this.tag.tagNumber == 0x04))) && (this.sub !== null)) {
            s += " (encapsulates)";
        }
        s += "\n";
        if (this.sub !== null) {
            indent += "  ";
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                s += this.sub[i].toPrettyString(indent);
            }
        }
        return s;
    };
    ASN1.prototype.posStart = function () {
        return this.stream.pos;
    };
    ASN1.prototype.posContent = function () {
        return this.stream.pos + this.header;
    };
    ASN1.prototype.posEnd = function () {
        return this.stream.pos + this.header + Math.abs(this.length);
    };
    ASN1.prototype.toHexString = function () {
        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    ASN1.decodeLength = function (stream) {
        var buf = stream.get();
        var len = buf & 0x7F;
        if (len == buf) {
            return len;
        }
        // no reason to use Int10, as it would be a huge buffer anyways
        if (len > 6) {
            throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
        }
        if (len === 0) {
            return null;
        } // undefined
        buf = 0;
        for (var i = 0; i < len; ++i) {
            buf = (buf * 256) + stream.get();
        }
        return buf;
    };
    /**
     * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
     * @returns {string}
     * @public
     */
    ASN1.prototype.getHexStringValue = function () {
        var hexString = this.toHexString();
        var offset = this.header * 2;
        var length = this.length * 2;
        return hexString.substr(offset, length);
    };
    ASN1.decode = function (str) {
        var stream;
        if (!(str instanceof Stream)) {
            stream = new Stream(str, 0);
        }
        else {
            stream = str;
        }
        var streamStart = new Stream(stream);
        var tag = new ASN1Tag(stream);
        var len = ASN1.decodeLength(stream);
        var start = stream.pos;
        var header = start - streamStart.pos;
        var sub = null;
        var getSub = function () {
            var ret = [];
            if (len !== null) {
                // definite length
                var end = start + len;
                while (stream.pos < end) {
                    ret[ret.length] = ASN1.decode(stream);
                }
                if (stream.pos != end) {
                    throw new Error("Content size is not correct for container starting at offset " + start);
                }
            }
            else {
                // undefined length
                try {
                    for (;;) {
                        var s = ASN1.decode(stream);
                        if (s.tag.isEOC()) {
                            break;
                        }
                        ret[ret.length] = s;
                    }
                    len = start - stream.pos; // undefined lengths are represented as negative values
                }
                catch (e) {
                    throw new Error("Exception while decoding undefined length content: " + e);
                }
            }
            return ret;
        };
        if (tag.tagConstructed) {
            // must have valid content
            sub = getSub();
        }
        else if (tag.isUniversal() && ((tag.tagNumber == 0x03) || (tag.tagNumber == 0x04))) {
            // sometimes BitString and OctetString are used to encapsulate ASN.1
            try {
                if (tag.tagNumber == 0x03) {
                    if (stream.get() != 0) {
                        throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
                    }
                }
                sub = getSub();
                for (var i = 0; i < sub.length; ++i) {
                    if (sub[i].tag.isEOC()) {
                        throw new Error("EOC is not supposed to be actual content.");
                    }
                }
            }
            catch (e) {
                // but silently ignore when they don't
                sub = null;
            }
        }
        if (sub === null) {
            if (len === null) {
                throw new Error("We can't skip over an invalid tag with undefined length at offset " + start);
            }
            stream.pos = start + Math.abs(len);
        }
        return new ASN1(streamStart, header, len, tag, sub);
    };
    return ASN1;
}());
var ASN1Tag = /** @class */ (function () {
    function ASN1Tag(stream) {
        var buf = stream.get();
        this.tagClass = buf >> 6;
        this.tagConstructed = ((buf & 0x20) !== 0);
        this.tagNumber = buf & 0x1F;
        if (this.tagNumber == 0x1F) { // long tag
            var n = new Int10();
            do {
                buf = stream.get();
                n.mulAdd(128, buf & 0x7F);
            } while (buf & 0x80);
            this.tagNumber = n.simplify();
        }
    }
    ASN1Tag.prototype.isUniversal = function () {
        return this.tagClass === 0x00;
    };
    ASN1Tag.prototype.isEOC = function () {
        return this.tagClass === 0x00 && this.tagNumber === 0x00;
    };
    return ASN1Tag;
}());

// Copyright (c) 2005  Tom Wu
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = ((canary & 0xffffff) == 0xefcafe);
//#region
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
//#endregion
// (public) Constructor
var BigInteger = /** @class */ (function () {
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) {
                this.fromNumber(a, b, c);
            }
            else if (b == null && "string" != typeof a) {
                this.fromString(a, 256);
            }
            else {
                this.fromString(a, b);
            }
        }
    }
    //#region PUBLIC
    // BigInteger.prototype.toString = bnToString;
    // (public) return string representation in given radix
    BigInteger.prototype.toString = function (b) {
        if (this.s < 0) {
            return "-" + this.negate().toString(b);
        }
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            return this.toRadix(b);
        }
        var km = (1 << k) - 1;
        var d;
        var m = false;
        var r = "";
        var i = this.t;
        var p = this.DB - (i * this.DB) % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while (i >= 0) {
                if (p < k) {
                    d = (this[i] & ((1 << p) - 1)) << (k - p);
                    d |= this[--i] >> (p += this.DB - k);
                }
                else {
                    d = (this[i] >> (p -= k)) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) {
                    m = true;
                }
                if (m) {
                    r += int2char(d);
                }
            }
        }
        return m ? r : "0";
    };
    // BigInteger.prototype.negate = bnNegate;
    // (public) -this
    BigInteger.prototype.negate = function () {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    };
    // BigInteger.prototype.abs = bnAbs;
    // (public) |this|
    BigInteger.prototype.abs = function () {
        return (this.s < 0) ? this.negate() : this;
    };
    // BigInteger.prototype.compareTo = bnCompareTo;
    // (public) return + if this > a, - if this < a, 0 if equal
    BigInteger.prototype.compareTo = function (a) {
        var r = this.s - a.s;
        if (r != 0) {
            return r;
        }
        var i = this.t;
        r = i - a.t;
        if (r != 0) {
            return (this.s < 0) ? -r : r;
        }
        while (--i >= 0) {
            if ((r = this[i] - a[i]) != 0) {
                return r;
            }
        }
        return 0;
    };
    // BigInteger.prototype.bitLength = bnBitLength;
    // (public) return the number of bits in "this"
    BigInteger.prototype.bitLength = function () {
        if (this.t <= 0) {
            return 0;
        }
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
    };
    // BigInteger.prototype.mod = bnMod;
    // (public) this mod a
    BigInteger.prototype.mod = function (a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            a.subTo(r, r);
        }
        return r;
    };
    // BigInteger.prototype.modPowInt = bnModPowInt;
    // (public) this^e % m, 0 <= e < 2^32
    BigInteger.prototype.modPowInt = function (e, m) {
        var z;
        if (e < 256 || m.isEven()) {
            z = new Classic(m);
        }
        else {
            z = new Montgomery(m);
        }
        return this.exp(e, z);
    };
    // BigInteger.prototype.clone = bnClone;
    // (public)
    BigInteger.prototype.clone = function () {
        var r = nbi();
        this.copyTo(r);
        return r;
    };
    // BigInteger.prototype.intValue = bnIntValue;
    // (public) return value as integer
    BigInteger.prototype.intValue = function () {
        if (this.s < 0) {
            if (this.t == 1) {
                return this[0] - this.DV;
            }
            else if (this.t == 0) {
                return -1;
            }
        }
        else if (this.t == 1) {
            return this[0];
        }
        else if (this.t == 0) {
            return 0;
        }
        // assumes 16 < DB < 32
        return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
    };
    // BigInteger.prototype.byteValue = bnByteValue;
    // (public) return value as byte
    BigInteger.prototype.byteValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 24) >> 24;
    };
    // BigInteger.prototype.shortValue = bnShortValue;
    // (public) return value as short (assumes DB>=16)
    BigInteger.prototype.shortValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 16) >> 16;
    };
    // BigInteger.prototype.signum = bnSigNum;
    // (public) 0 if this == 0, 1 if this > 0
    BigInteger.prototype.signum = function () {
        if (this.s < 0) {
            return -1;
        }
        else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
            return 0;
        }
        else {
            return 1;
        }
    };
    // BigInteger.prototype.toByteArray = bnToByteArray;
    // (public) convert to bigendian byte array
    BigInteger.prototype.toByteArray = function () {
        var i = this.t;
        var r = [];
        r[0] = this.s;
        var p = this.DB - (i * this.DB) % 8;
        var d;
        var k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) {
                r[k++] = d | (this.s << (this.DB - p));
            }
            while (i >= 0) {
                if (p < 8) {
                    d = (this[i] & ((1 << p) - 1)) << (8 - p);
                    d |= this[--i] >> (p += this.DB - 8);
                }
                else {
                    d = (this[i] >> (p -= 8)) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) {
                    d |= -256;
                }
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) {
                    ++k;
                }
                if (k > 0 || d != this.s) {
                    r[k++] = d;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.equals = function (a) {
        return (this.compareTo(a) == 0);
    };
    // BigInteger.prototype.min = bnMin;
    BigInteger.prototype.min = function (a) {
        return (this.compareTo(a) < 0) ? this : a;
    };
    // BigInteger.prototype.max = bnMax;
    BigInteger.prototype.max = function (a) {
        return (this.compareTo(a) > 0) ? this : a;
    };
    // BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.and = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    };
    // BigInteger.prototype.or = bnOr;
    BigInteger.prototype.or = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    };
    // BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.xor = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    };
    // BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.andNot = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    };
    // BigInteger.prototype.not = bnNot;
    // (public) ~this
    BigInteger.prototype.not = function () {
        var r = nbi();
        for (var i = 0; i < this.t; ++i) {
            r[i] = this.DM & ~this[i];
        }
        r.t = this.t;
        r.s = ~this.s;
        return r;
    };
    // BigInteger.prototype.shiftLeft = bnShiftLeft;
    // (public) this << n
    BigInteger.prototype.shiftLeft = function (n) {
        var r = nbi();
        if (n < 0) {
            this.rShiftTo(-n, r);
        }
        else {
            this.lShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.shiftRight = bnShiftRight;
    // (public) this >> n
    BigInteger.prototype.shiftRight = function (n) {
        var r = nbi();
        if (n < 0) {
            this.lShiftTo(-n, r);
        }
        else {
            this.rShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    // (public) returns index of lowest 1-bit (or -1 if none)
    BigInteger.prototype.getLowestSetBit = function () {
        for (var i = 0; i < this.t; ++i) {
            if (this[i] != 0) {
                return i * this.DB + lbit(this[i]);
            }
        }
        if (this.s < 0) {
            return this.t * this.DB;
        }
        return -1;
    };
    // BigInteger.prototype.bitCount = bnBitCount;
    // (public) return number of set bits
    BigInteger.prototype.bitCount = function () {
        var r = 0;
        var x = this.s & this.DM;
        for (var i = 0; i < this.t; ++i) {
            r += cbit(this[i] ^ x);
        }
        return r;
    };
    // BigInteger.prototype.testBit = bnTestBit;
    // (public) true iff nth bit is set
    BigInteger.prototype.testBit = function (n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) {
            return (this.s != 0);
        }
        return ((this[j] & (1 << (n % this.DB))) != 0);
    };
    // BigInteger.prototype.setBit = bnSetBit;
    // (public) this | (1<<n)
    BigInteger.prototype.setBit = function (n) {
        return this.changeBit(n, op_or);
    };
    // BigInteger.prototype.clearBit = bnClearBit;
    // (public) this & ~(1<<n)
    BigInteger.prototype.clearBit = function (n) {
        return this.changeBit(n, op_andnot);
    };
    // BigInteger.prototype.flipBit = bnFlipBit;
    // (public) this ^ (1<<n)
    BigInteger.prototype.flipBit = function (n) {
        return this.changeBit(n, op_xor);
    };
    // BigInteger.prototype.add = bnAdd;
    // (public) this + a
    BigInteger.prototype.add = function (a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    };
    // BigInteger.prototype.subtract = bnSubtract;
    // (public) this - a
    BigInteger.prototype.subtract = function (a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    };
    // BigInteger.prototype.multiply = bnMultiply;
    // (public) this * a
    BigInteger.prototype.multiply = function (a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    };
    // BigInteger.prototype.divide = bnDivide;
    // (public) this / a
    BigInteger.prototype.divide = function (a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    };
    // BigInteger.prototype.remainder = bnRemainder;
    // (public) this % a
    BigInteger.prototype.remainder = function (a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    };
    // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    // (public) [this/a,this%a]
    BigInteger.prototype.divideAndRemainder = function (a) {
        var q = nbi();
        var r = nbi();
        this.divRemTo(a, q, r);
        return [q, r];
    };
    // BigInteger.prototype.modPow = bnModPow;
    // (public) this^e % m (HAC 14.85)
    BigInteger.prototype.modPow = function (e, m) {
        var i = e.bitLength();
        var k;
        var r = nbv(1);
        var z;
        if (i <= 0) {
            return r;
        }
        else if (i < 18) {
            k = 1;
        }
        else if (i < 48) {
            k = 3;
        }
        else if (i < 144) {
            k = 4;
        }
        else if (i < 768) {
            k = 5;
        }
        else {
            k = 6;
        }
        if (i < 8) {
            z = new Classic(m);
        }
        else if (m.isEven()) {
            z = new Barrett(m);
        }
        else {
            z = new Montgomery(m);
        }
        // precomputation
        var g = [];
        var n = 3;
        var k1 = k - 1;
        var km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while (n <= km) {
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1;
        var w;
        var is1 = true;
        var r2 = nbi();
        var t;
        i = nbits(e[j]) - 1;
        while (j >= 0) {
            if (i >= k1) {
                w = (e[j] >> (i - k1)) & km;
            }
            else {
                w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i);
                if (j > 0) {
                    w |= e[j - 1] >> (this.DB + i - k1);
                }
            }
            n = k;
            while ((w & 1) == 0) {
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) { // ret == 1, don't bother squaring or multiplying it
                g[w].copyTo(r);
                is1 = false;
            }
            else {
                while (n > 1) {
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) {
                    z.sqrTo(r, r2);
                }
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while (j >= 0 && (e[j] & (1 << i)) == 0) {
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.modInverse = bnModInverse;
    // (public) 1/this % m (HAC 14.61)
    BigInteger.prototype.modInverse = function (m) {
        var ac = m.isEven();
        if ((this.isEven() && ac) || m.signum() == 0) {
            return BigInteger.ZERO;
        }
        var u = m.clone();
        var v = this.clone();
        var a = nbv(1);
        var b = nbv(0);
        var c = nbv(0);
        var d = nbv(1);
        while (u.signum() != 0) {
            while (u.isEven()) {
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                }
                else if (!b.isEven()) {
                    b.subTo(m, b);
                }
                b.rShiftTo(1, b);
            }
            while (v.isEven()) {
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                }
                else if (!d.isEven()) {
                    d.subTo(m, d);
                }
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) {
                    a.subTo(c, a);
                }
                b.subTo(d, b);
            }
            else {
                v.subTo(u, v);
                if (ac) {
                    c.subTo(a, c);
                }
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) {
            return BigInteger.ZERO;
        }
        if (d.compareTo(m) >= 0) {
            return d.subtract(m);
        }
        if (d.signum() < 0) {
            d.addTo(m, d);
        }
        else {
            return d;
        }
        if (d.signum() < 0) {
            return d.add(m);
        }
        else {
            return d;
        }
    };
    // BigInteger.prototype.pow = bnPow;
    // (public) this^e
    BigInteger.prototype.pow = function (e) {
        return this.exp(e, new NullExp());
    };
    // BigInteger.prototype.gcd = bnGCD;
    // (public) gcd(this,a) (HAC 14.54)
    BigInteger.prototype.gcd = function (a) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            return x;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while (x.signum() > 0) {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) {
            y.lShiftTo(g, y);
        }
        return y;
    };
    // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // (public) test primality with certainty >= 1-.5^t
    BigInteger.prototype.isProbablePrime = function (t) {
        var i;
        var x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for (i = 0; i < lowprimes.length; ++i) {
                if (x[0] == lowprimes[i]) {
                    return true;
                }
            }
            return false;
        }
        if (x.isEven()) {
            return false;
        }
        i = 1;
        while (i < lowprimes.length) {
            var m = lowprimes[i];
            var j = i + 1;
            while (j < lowprimes.length && m < lplim) {
                m *= lowprimes[j++];
            }
            m = x.modInt(m);
            while (i < j) {
                if (m % lowprimes[i++] == 0) {
                    return false;
                }
            }
        }
        return x.millerRabin(t);
    };
    //#endregion PUBLIC
    //#region PROTECTED
    // BigInteger.prototype.copyTo = bnpCopyTo;
    // (protected) copy this to r
    BigInteger.prototype.copyTo = function (r) {
        for (var i = this.t - 1; i >= 0; --i) {
            r[i] = this[i];
        }
        r.t = this.t;
        r.s = this.s;
    };
    // BigInteger.prototype.fromInt = bnpFromInt;
    // (protected) set from integer value x, -DV <= x < DV
    BigInteger.prototype.fromInt = function (x) {
        this.t = 1;
        this.s = (x < 0) ? -1 : 0;
        if (x > 0) {
            this[0] = x;
        }
        else if (x < -1) {
            this[0] = x + this.DV;
        }
        else {
            this.t = 0;
        }
    };
    // BigInteger.prototype.fromString = bnpFromString;
    // (protected) set from string and radix
    BigInteger.prototype.fromString = function (s, b) {
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 256) {
            k = 8;
            /* byte array */
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length;
        var mi = false;
        var sh = 0;
        while (--i >= 0) {
            var x = (k == 8) ? (+s[i]) & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") {
                    mi = true;
                }
                continue;
            }
            mi = false;
            if (sh == 0) {
                this[this.t++] = x;
            }
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
                this[this.t++] = (x >> (this.DB - sh));
            }
            else {
                this[this.t - 1] |= x << sh;
            }
            sh += k;
            if (sh >= this.DB) {
                sh -= this.DB;
            }
        }
        if (k == 8 && ((+s[0]) & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) {
                this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
            }
        }
        this.clamp();
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.clamp = bnpClamp;
    // (protected) clamp off excess high words
    BigInteger.prototype.clamp = function () {
        var c = this.s & this.DM;
        while (this.t > 0 && this[this.t - 1] == c) {
            --this.t;
        }
    };
    // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    // (protected) r = this << n*DB
    BigInteger.prototype.dlShiftTo = function (n, r) {
        var i;
        for (i = this.t - 1; i >= 0; --i) {
            r[i + n] = this[i];
        }
        for (i = n - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r.t = this.t + n;
        r.s = this.s;
    };
    // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    // (protected) r = this >> n*DB
    BigInteger.prototype.drShiftTo = function (n, r) {
        for (var i = n; i < this.t; ++i) {
            r[i - n] = this[i];
        }
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    };
    // BigInteger.prototype.lShiftTo = bnpLShiftTo;
    // (protected) r = this << n
    BigInteger.prototype.lShiftTo = function (n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB);
        var c = (this.s << bs) & this.DM;
        for (var i = this.t - 1; i >= 0; --i) {
            r[i + ds + 1] = (this[i] >> cbs) | c;
            c = (this[i] & bm) << bs;
        }
        for (var i = ds - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    };
    // BigInteger.prototype.rShiftTo = bnpRShiftTo;
    // (protected) r = this >> n
    BigInteger.prototype.rShiftTo = function (n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for (var i = ds + 1; i < this.t; ++i) {
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) {
            r[this.t - ds - 1] |= (this.s & bm) << cbs;
        }
        r.t = this.t - ds;
        r.clamp();
    };
    // BigInteger.prototype.subTo = bnpSubTo;
    // (protected) r = this - a
    BigInteger.prototype.subTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c < -1) {
            r[i++] = this.DV + c;
        }
        else if (c > 0) {
            r[i++] = c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyTo = function (a, r) {
        var x = this.abs();
        var y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < y.t; ++i) {
            r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        }
        r.s = 0;
        r.clamp();
        if (this.s != a.s) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.squareTo = bnpSquareTo;
    // (protected) r = this^2, r != this (HAC 14.16)
    BigInteger.prototype.squareTo = function (r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < x.t - 1; ++i) {
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) {
            r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        }
        r.s = 0;
        r.clamp();
    };
    // BigInteger.prototype.divRemTo = bnpDivRemTo;
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    BigInteger.prototype.divRemTo = function (m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) {
            return;
        }
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) {
                q.fromInt(0);
            }
            if (r != null) {
                this.copyTo(r);
            }
            return;
        }
        if (r == null) {
            r = nbi();
        }
        var y = nbi();
        var ts = this.s;
        var ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        }
        else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) {
            return;
        }
        var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt;
        var d2 = (1 << this.F1) / yt;
        var e = 1 << this.F2;
        var i = r.t;
        var j = i - ys;
        var t = (q == null) ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while (y.t < ys) {
            y[y.t++] = 0;
        }
        while (--j >= 0) {
            // Estimate quotient digit
            var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while (r[i] < --qd) {
                    r.subTo(t, r);
                }
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) {
                BigInteger.ZERO.subTo(q, q);
            }
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) {
            r.rShiftTo(nsh, r);
        } // Denormalize remainder
        if (ts < 0) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.invDigit = bnpInvDigit;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    BigInteger.prototype.invDigit = function () {
        if (this.t < 1) {
            return 0;
        }
        var x = this[0];
        if ((x & 1) == 0) {
            return 0;
        }
        var y = x & 3; // y == 1/x mod 2^2
        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return (y > 0) ? this.DV - y : -y;
    };
    // BigInteger.prototype.isEven = bnpIsEven;
    // (protected) true iff this is even
    BigInteger.prototype.isEven = function () {
        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0;
    };
    // BigInteger.prototype.exp = bnpExp;
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    BigInteger.prototype.exp = function (e, z) {
        if (e > 0xffffffff || e < 1) {
            return BigInteger.ONE;
        }
        var r = nbi();
        var r2 = nbi();
        var g = z.convert(this);
        var i = nbits(e) - 1;
        g.copyTo(r);
        while (--i >= 0) {
            z.sqrTo(r, r2);
            if ((e & (1 << i)) > 0) {
                z.mulTo(r2, g, r);
            }
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.chunkSize = bnpChunkSize;
    // (protected) return x s.t. r^x < DV
    BigInteger.prototype.chunkSize = function (r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    };
    // BigInteger.prototype.toRadix = bnpToRadix;
    // (protected) convert to radix string
    BigInteger.prototype.toRadix = function (b) {
        if (b == null) {
            b = 10;
        }
        if (this.signum() == 0 || b < 2 || b > 36) {
            return "0";
        }
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a);
        var y = nbi();
        var z = nbi();
        var r = "";
        this.divRemTo(d, y, z);
        while (y.signum() > 0) {
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    };
    // BigInteger.prototype.fromRadix = bnpFromRadix;
    // (protected) convert from radix string
    BigInteger.prototype.fromRadix = function (s, b) {
        this.fromInt(0);
        if (b == null) {
            b = 10;
        }
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs);
        var mi = false;
        var j = 0;
        var w = 0;
        for (var i = 0; i < s.length; ++i) {
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) {
                    mi = true;
                }
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.fromNumber = bnpFromNumber;
    // (protected) alternate constructor
    BigInteger.prototype.fromNumber = function (a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    // force MSB set
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                } // force odd
                while (!this.isProbablePrime(b)) {
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) {
                        this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                    }
                }
            }
        }
        else {
            // new BigInteger(int,RNG)
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    // (protected) r = this op a (bitwise)
    BigInteger.prototype.bitwiseTo = function (a, op, r) {
        var i;
        var f;
        var m = Math.min(a.t, this.t);
        for (i = 0; i < m; ++i) {
            r[i] = op(this[i], a[i]);
        }
        if (a.t < this.t) {
            f = a.s & this.DM;
            for (i = m; i < this.t; ++i) {
                r[i] = op(this[i], f);
            }
            r.t = this.t;
        }
        else {
            f = this.s & this.DM;
            for (i = m; i < a.t; ++i) {
                r[i] = op(f, a[i]);
            }
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    };
    // BigInteger.prototype.changeBit = bnpChangeBit;
    // (protected) this op (1<<n)
    BigInteger.prototype.changeBit = function (n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    };
    // BigInteger.prototype.addTo = bnpAddTo;
    // (protected) r = this + a
    BigInteger.prototype.addTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c > 0) {
            r[i++] = c;
        }
        else if (c < -1) {
            r[i++] = this.DV + c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.dMultiply = bnpDMultiply;
    // (protected) this *= n, this >= 0, 1 < n < DV
    BigInteger.prototype.dMultiply = function (n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    };
    // BigInteger.prototype.dAddOffset = bnpDAddOffset;
    // (protected) this += n << w words, this >= 0
    BigInteger.prototype.dAddOffset = function (n, w) {
        if (n == 0) {
            return;
        }
        while (this.t <= w) {
            this[this.t++] = 0;
        }
        this[w] += n;
        while (this[w] >= this.DV) {
            this[w] -= this.DV;
            if (++w >= this.t) {
                this[this.t++] = 0;
            }
            ++this[w];
        }
    };
    // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyLowerTo = function (a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while (i > 0) {
            r[--i] = 0;
        }
        for (var j = r.t - this.t; i < j; ++i) {
            r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        }
        for (var j = Math.min(a.t, n); i < j; ++i) {
            this.am(0, a[i], r, i, 0, n - i);
        }
        r.clamp();
    };
    // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyUpperTo = function (a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
            r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        }
        r.clamp();
        r.drShiftTo(1, r);
    };
    // BigInteger.prototype.modInt = bnpModInt;
    // (protected) this % n, n < 2^26
    BigInteger.prototype.modInt = function (n) {
        if (n <= 0) {
            return 0;
        }
        var d = this.DV % n;
        var r = (this.s < 0) ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) {
                r = this[0] % n;
            }
            else {
                for (var i = this.t - 1; i >= 0; --i) {
                    r = (d * r + this[i]) % n;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.millerRabin = bnpMillerRabin;
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    BigInteger.prototype.millerRabin = function (t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) {
            return false;
        }
        var r = n1.shiftRight(k);
        t = (t + 1) >> 1;
        if (t > lowprimes.length) {
            t = lowprimes.length;
        }
        var a = nbi();
        for (var i = 0; i < t; ++i) {
            // Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while (j++ < k && y.compareTo(n1) != 0) {
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) {
                        return false;
                    }
                }
                if (y.compareTo(n1) != 0) {
                    return false;
                }
            }
        }
        return true;
    };
    // BigInteger.prototype.square = bnSquare;
    // (public) this^2
    BigInteger.prototype.square = function () {
        var r = nbi();
        this.squareTo(r);
        return r;
    };
    //#region ASYNC
    // Public API method
    BigInteger.prototype.gcda = function (a, callback) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            callback(x);
            return;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
        var gcda1 = function () {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
            if (!(x.signum() > 0)) {
                if (g > 0) {
                    y.lShiftTo(g, y);
                }
                setTimeout(function () { callback(y); }, 0); // escape
            }
            else {
                setTimeout(gcda1, 0);
            }
        };
        setTimeout(gcda1, 10);
    };
    // (protected) alternate constructor
    BigInteger.prototype.fromNumberAsync = function (a, b, c, callback) {
        if ("number" == typeof b) {
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                }
                var bnp_1 = this;
                var bnpfn1_1 = function () {
                    bnp_1.dAddOffset(2, 0);
                    if (bnp_1.bitLength() > a) {
                        bnp_1.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp_1);
                    }
                    if (bnp_1.isProbablePrime(b)) {
                        setTimeout(function () { callback(); }, 0); // escape
                    }
                    else {
                        setTimeout(bnpfn1_1, 0);
                    }
                };
                setTimeout(bnpfn1_1, 0);
            }
        }
        else {
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    return BigInteger;
}());
//#region REDUCERS
//#region NullExp
var NullExp = /** @class */ (function () {
    function NullExp() {
    }
    // NullExp.prototype.convert = nNop;
    NullExp.prototype.convert = function (x) {
        return x;
    };
    // NullExp.prototype.revert = nNop;
    NullExp.prototype.revert = function (x) {
        return x;
    };
    // NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
    };
    // NullExp.prototype.sqrTo = nSqrTo;
    NullExp.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
    };
    return NullExp;
}());
// Modular reduction using "classic" algorithm
var Classic = /** @class */ (function () {
    function Classic(m) {
        this.m = m;
    }
    // Classic.prototype.convert = cConvert;
    Classic.prototype.convert = function (x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) {
            return x.mod(this.m);
        }
        else {
            return x;
        }
    };
    // Classic.prototype.revert = cRevert;
    Classic.prototype.revert = function (x) {
        return x;
    };
    // Classic.prototype.reduce = cReduce;
    Classic.prototype.reduce = function (x) {
        x.divRemTo(this.m, null, x);
    };
    // Classic.prototype.mulTo = cMulTo;
    Classic.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Classic.prototype.sqrTo = cSqrTo;
    Classic.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Classic;
}());
//#endregion
//#region Montgomery
// Montgomery reduction
var Montgomery = /** @class */ (function () {
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << (m.DB - 15)) - 1;
        this.mt2 = 2 * m.t;
    }
    // Montgomery.prototype.convert = montConvert;
    // xR mod m
    Montgomery.prototype.convert = function (x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            this.m.subTo(r, r);
        }
        return r;
    };
    // Montgomery.prototype.revert = montRevert;
    // x/R mod m
    Montgomery.prototype.revert = function (x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    };
    // Montgomery.prototype.reduce = montReduce;
    // x = x/R mod m (HAC 14.32)
    Montgomery.prototype.reduce = function (x) {
        while (x.t <= this.mt2) {
            // pad x so am has enough room later
            x[x.t++] = 0;
        }
        for (var i = 0; i < this.m.t; ++i) {
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while (x[j] >= x.DV) {
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Montgomery.prototype.mulTo = montMulTo;
    // r = "xy/R mod m"; x,y != r
    Montgomery.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Montgomery.prototype.sqrTo = montSqrTo;
    // r = "x^2/R mod m"; x != r
    Montgomery.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Montgomery;
}());
//#endregion Montgomery
//#region Barrett
// Barrett modular reduction
var Barrett = /** @class */ (function () {
    function Barrett(m) {
        this.m = m;
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
    }
    // Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.convert = function (x) {
        if (x.s < 0 || x.t > 2 * this.m.t) {
            return x.mod(this.m);
        }
        else if (x.compareTo(this.m) < 0) {
            return x;
        }
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    };
    // Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.revert = function (x) {
        return x;
    };
    // Barrett.prototype.reduce = barrettReduce;
    // x = x mod m (HAC 14.42)
    Barrett.prototype.reduce = function (x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while (x.compareTo(this.r2) < 0) {
            x.dAddOffset(1, this.m.t + 1);
        }
        x.subTo(this.r2, x);
        while (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Barrett.prototype.mulTo = barrettMulTo;
    // r = x*y mod m; x,y != r
    Barrett.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Barrett.prototype.sqrTo = barrettSqrTo;
    // r = x^2 mod m; x != r
    Barrett.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Barrett;
}());
//#endregion
//#endregion REDUCERS
// return new, unset BigInteger
function nbi() { return new BigInteger(null); }
function parseBigInt(str, r) {
    return new BigInteger(str, r);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    BigInteger.prototype.am = function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff;
        var xh = x >> 15;
        while (--n >= 0) {
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    };
    dbits = 30;
}
else if (inBrowser && j_lm && (navigator.appName != "Netscape")) {
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    BigInteger.prototype.am = function am1(i, x, w, j, c, n) {
        while (--n >= 0) {
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    };
    dbits = 26;
}
else { // Mozilla/Netscape seems to prefer am3
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    BigInteger.prototype.am = function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff;
        var xh = x >> 14;
        while (--n >= 0) {
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    };
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = ((1 << dbits) - 1);
BigInteger.prototype.DV = (1 << dbits);
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RC = [];
var rr;
var vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return (c == null) ? -1 : c;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

// prng4.js - uses Arcfour as a PRNG
var Arcfour = /** @class */ (function () {
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = [];
    }
    // Arcfour.prototype.init = ARC4init;
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    Arcfour.prototype.init = function (key) {
        var i;
        var j;
        var t;
        for (i = 0; i < 256; ++i) {
            this.S[i] = i;
        }
        j = 0;
        for (i = 0; i < 256; ++i) {
            j = (j + this.S[i] + key[i % key.length]) & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    };
    // Arcfour.prototype.next = ARC4next;
    Arcfour.prototype.next = function () {
        var t;
        this.i = (this.i + 1) & 255;
        this.j = (this.j + this.S[this.i]) & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[(t + this.S[this.i]) & 255];
    };
    return Arcfour;
}());
// Plug in your RNG constructor here
function prng_newstate() {
    return new Arcfour();
}
// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize = 256;

// Random number generator - requires a PRNG backend, e.g. prng4.js
var rng_state;
var rng_pool = null;
var rng_pptr;
// Initialize the pool with junk if needed.
if (rng_pool == null) {
    rng_pool = [];
    rng_pptr = 0;
    var t = void 0;
    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        // Extract entropy (2048 bits) from RNG if available
        var z = new Uint32Array(256);
        window.crypto.getRandomValues(z);
        for (t = 0; t < z.length; ++t) {
            rng_pool[rng_pptr++] = z[t] & 255;
        }
    }
    // Use mouse events for entropy, if we do not have enough entropy by the time
    // we need it, entropy will be generated by Math.random.
    var count = 0;
    var onMouseMoveListener_1 = function (ev) {
        count = count || 0;
        if (count >= 256 || rng_pptr >= rng_psize) {
            if (window.removeEventListener) {
                window.removeEventListener("mousemove", onMouseMoveListener_1, false);
            }
            else if (window.detachEvent) {
                window.detachEvent("onmousemove", onMouseMoveListener_1);
            }
            return;
        }
        try {
            var mouseCoordinates = ev.x + ev.y;
            rng_pool[rng_pptr++] = mouseCoordinates & 255;
            count += 1;
        }
        catch (e) {
            // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
        }
    };
    if (typeof window !== 'undefined') {
        if (window.addEventListener) {
            window.addEventListener("mousemove", onMouseMoveListener_1, false);
        }
        else if (window.attachEvent) {
            window.attachEvent("onmousemove", onMouseMoveListener_1);
        }
    }
}
function rng_get_byte() {
    if (rng_state == null) {
        rng_state = prng_newstate();
        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
        while (rng_pptr < rng_psize) {
            var random = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = random & 255;
        }
        rng_state.init(rng_pool);
        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
            rng_pool[rng_pptr] = 0;
        }
        rng_pptr = 0;
    }
    // TODO: allow reseeding after first request
    return rng_state.next();
}
var SecureRandom = /** @class */ (function () {
    function SecureRandom() {
    }
    SecureRandom.prototype.nextBytes = function (ba) {
        for (var i = 0; i < ba.length; ++i) {
            ba[i] = rng_get_byte();
        }
    };
    return SecureRandom;
}());

// Depends on jsbn.js and rng.js
// function linebrk(s,n) {
//   var ret = "";
//   var i = 0;
//   while(i + n < s.length) {
//     ret += s.substring(i,i+n) + "\n";
//     i += n;
//   }
//   return ret + s.substring(i,s.length);
// }
// function byte2Hex(b) {
//   if(b < 0x10)
//     return "0" + b.toString(16);
//   else
//     return b.toString(16);
// }
function pkcs1pad1(s, n) {
    if (n < s.length + 22) {
        console.error("Message too long for RSA");
        return null;
    }
    var len = n - s.length - 6;
    var filler = "";
    for (var f = 0; f < len; f += 2) {
        filler += "ff";
    }
    var m = "0001" + filler + "00" + s;
    return parseBigInt(m, 16);
}
// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
    if (n < s.length + 11) { // TODO: fix for utf-8
        console.error("Message too long for RSA");
        return null;
    }
    var ba = [];
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        var c = s.charCodeAt(i--);
        if (c < 128) { // encode using utf-8
            ba[--n] = c;
        }
        else if ((c > 127) && (c < 2048)) {
            ba[--n] = (c & 63) | 128;
            ba[--n] = (c >> 6) | 192;
        }
        else {
            ba[--n] = (c & 63) | 128;
            ba[--n] = ((c >> 6) & 63) | 128;
            ba[--n] = (c >> 12) | 224;
        }
    }
    ba[--n] = 0;
    var rng = new SecureRandom();
    var x = [];
    while (n > 2) { // random non-zero pad
        x[0] = 0;
        while (x[0] == 0) {
            rng.nextBytes(x);
        }
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new BigInteger(ba);
}
// "empty" RSA key constructor
var RSAKey = /** @class */ (function () {
    function RSAKey() {
        this.n = null;
        this.e = 0;
        this.d = null;
        this.p = null;
        this.q = null;
        this.dmp1 = null;
        this.dmq1 = null;
        this.coeff = null;
    }
    //#region PROTECTED
    // protected
    // RSAKey.prototype.doPublic = RSADoPublic;
    // Perform raw public operation on "x": return x^e (mod n)
    RSAKey.prototype.doPublic = function (x) {
        return x.modPowInt(this.e, this.n);
    };
    // RSAKey.prototype.doPrivate = RSADoPrivate;
    // Perform raw private operation on "x": return x^d (mod n)
    RSAKey.prototype.doPrivate = function (x) {
        if (this.p == null || this.q == null) {
            return x.modPow(this.d, this.n);
        }
        // TODO: re-calculate any missing CRT params
        var xp = x.mod(this.p).modPow(this.dmp1, this.p);
        var xq = x.mod(this.q).modPow(this.dmq1, this.q);
        while (xp.compareTo(xq) < 0) {
            xp = xp.add(this.p);
        }
        return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
    };
    //#endregion PROTECTED
    //#region PUBLIC
    // RSAKey.prototype.setPublic = RSASetPublic;
    // Set the public key fields N and e from hex strings
    RSAKey.prototype.setPublic = function (N, E) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
        }
        else {
            console.error("Invalid RSA public key");
        }
    };
    // RSAKey.prototype.encrypt = RSAEncrypt;
    // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
    RSAKey.prototype.encrypt = function (text) {
        var maxLength = (this.n.bitLength() + 7) >> 3;
        var m = pkcs1pad2(text, maxLength);
        if (m == null) {
            return null;
        }
        var c = this.doPublic(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        var length = h.length;
        // fix zero before result
        for (var i = 0; i < maxLength * 2 - length; i++) {
            h = "0" + h;
        }
        return h;
    };
    // RSAKey.prototype.setPrivate = RSASetPrivate;
    // Set the private key fields N, e, and d from hex strings
    RSAKey.prototype.setPrivate = function (N, E, D) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
            this.d = parseBigInt(D, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
    // Set the private key fields N, e, d and CRT params from hex strings
    RSAKey.prototype.setPrivateEx = function (N, E, D, P, Q, DP, DQ, C) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
            this.d = parseBigInt(D, 16);
            this.p = parseBigInt(P, 16);
            this.q = parseBigInt(Q, 16);
            this.dmp1 = parseBigInt(DP, 16);
            this.dmq1 = parseBigInt(DQ, 16);
            this.coeff = parseBigInt(C, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.generate = RSAGenerate;
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generate = function (B, E) {
        var rng = new SecureRandom();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new BigInteger(E, 16);
        for (;;) {
            for (;;) {
                this.p = new BigInteger(B - qs, 1, rng);
                if (this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) {
                    break;
                }
            }
            for (;;) {
                this.q = new BigInteger(qs, 1, rng);
                if (this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) {
                    break;
                }
            }
            if (this.p.compareTo(this.q) <= 0) {
                var t = this.p;
                this.p = this.q;
                this.q = t;
            }
            var p1 = this.p.subtract(BigInteger.ONE);
            var q1 = this.q.subtract(BigInteger.ONE);
            var phi = p1.multiply(q1);
            if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
                this.n = this.p.multiply(this.q);
                this.d = ee.modInverse(phi);
                this.dmp1 = this.d.mod(p1);
                this.dmq1 = this.d.mod(q1);
                this.coeff = this.q.modInverse(this.p);
                break;
            }
        }
    };
    // RSAKey.prototype.decrypt = RSADecrypt;
    // Return the PKCS#1 RSA decryption of "ctext".
    // "ctext" is an even-length hex string and the output is a plain string.
    RSAKey.prototype.decrypt = function (ctext) {
        var c = parseBigInt(ctext, 16);
        var m = this.doPrivate(c);
        if (m == null) {
            return null;
        }
        return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
    };
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generateAsync = function (B, E, callback) {
        var rng = new SecureRandom();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new BigInteger(E, 16);
        var rsa = this;
        // These functions have non-descript names because they were originally for(;;) loops.
        // I don't know about cryptography to give them better names than loop1-4.
        var loop1 = function () {
            var loop4 = function () {
                if (rsa.p.compareTo(rsa.q) <= 0) {
                    var t = rsa.p;
                    rsa.p = rsa.q;
                    rsa.q = t;
                }
                var p1 = rsa.p.subtract(BigInteger.ONE);
                var q1 = rsa.q.subtract(BigInteger.ONE);
                var phi = p1.multiply(q1);
                if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
                    rsa.n = rsa.p.multiply(rsa.q);
                    rsa.d = ee.modInverse(phi);
                    rsa.dmp1 = rsa.d.mod(p1);
                    rsa.dmq1 = rsa.d.mod(q1);
                    rsa.coeff = rsa.q.modInverse(rsa.p);
                    setTimeout(function () { callback(); }, 0); // escape
                }
                else {
                    setTimeout(loop1, 0);
                }
            };
            var loop3 = function () {
                rsa.q = nbi();
                rsa.q.fromNumberAsync(qs, 1, rng, function () {
                    rsa.q.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.q.isProbablePrime(10)) {
                            setTimeout(loop4, 0);
                        }
                        else {
                            setTimeout(loop3, 0);
                        }
                    });
                });
            };
            var loop2 = function () {
                rsa.p = nbi();
                rsa.p.fromNumberAsync(B - qs, 1, rng, function () {
                    rsa.p.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.p.isProbablePrime(10)) {
                            setTimeout(loop3, 0);
                        }
                        else {
                            setTimeout(loop2, 0);
                        }
                    });
                });
            };
            setTimeout(loop2, 0);
        };
        setTimeout(loop1, 0);
    };
    RSAKey.prototype.sign = function (text, digestMethod, digestName) {
        var header = getDigestHeader(digestName);
        var digest = header + digestMethod(text).toString();
        var m = pkcs1pad1(digest, this.n.bitLength() / 4);
        if (m == null) {
            return null;
        }
        var c = this.doPrivate(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        if ((h.length & 1) == 0) {
            return h;
        }
        else {
            return "0" + h;
        }
    };
    RSAKey.prototype.verify = function (text, signature, digestMethod) {
        var c = parseBigInt(signature, 16);
        var m = this.doPublic(c);
        if (m == null) {
            return null;
        }
        var unpadded = m.toString(16).replace(/^1f+00/, "");
        var digest = removeDigestHeader(unpadded);
        return digest == digestMethod(text).toString();
    };
    return RSAKey;
}());
// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
        ++i;
    }
    if (b.length - i != n - 1 || b[i] != 2) {
        return null;
    }
    ++i;
    while (b[i] != 0) {
        if (++i >= b.length) {
            return null;
        }
    }
    var ret = "";
    while (++i < b.length) {
        var c = b[i] & 255;
        if (c < 128) { // utf-8 decode
            ret += String.fromCharCode(c);
        }
        else if ((c > 191) && (c < 224)) {
            ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
            ++i;
        }
        else {
            ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
            i += 2;
        }
    }
    return ret;
}
// https://tools.ietf.org/html/rfc3447#page-43
var DIGEST_HEADERS = {
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    ripemd160: "3021300906052b2403020105000414"
};
function getDigestHeader(name) {
    return DIGEST_HEADERS[name] || "";
}
function removeDigestHeader(str) {
    for (var name_1 in DIGEST_HEADERS) {
        if (DIGEST_HEADERS.hasOwnProperty(name_1)) {
            var header = DIGEST_HEADERS[name_1];
            var len = header.length;
            if (str.substr(0, len) == header) {
                return str.substr(len);
            }
        }
    }
    return str;
}
// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
// function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
// }
// public
// RSAKey.prototype.encrypt_b64 = RSAEncryptB64;

/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
var YAHOO = {};
YAHOO.lang = {
    /**
     * Utility to set up the prototype, constructor and superclass properties to
     * support an inheritance strategy that can chain constructors and methods.
     * Static members will not be inherited.
     *
     * @method extend
     * @static
     * @param {Function} subc   the object to modify
     * @param {Function} superc the object to inherit
     * @param {Object} overrides  additional properties/methods to add to the
     *                              subclass prototype.  These will override the
     *                              matching items obtained from the superclass
     *                              if present.
     */
    extend: function (subc, superc, overrides) {
        if (!superc || !subc) {
            throw new Error("YAHOO.lang.extend failed, please check that " +
                "all dependencies are included.");
        }
        var F = function () { };
        F.prototype = superc.prototype;
        subc.prototype = new F();
        subc.prototype.constructor = subc;
        subc.superclass = superc.prototype;
        if (superc.prototype.constructor == Object.prototype.constructor) {
            superc.prototype.constructor = superc;
        }
        if (overrides) {
            var i;
            for (i in overrides) {
                subc.prototype[i] = overrides[i];
            }
            /*
             * IE will not enumerate native functions in a derived object even if the
             * function was overridden.  This is a workaround for specific functions
             * we care about on the Object prototype.
             * @property _IEEnumFix
             * @param {Function} r  the object to receive the augmentation
             * @param {Function} s  the object that supplies the properties to augment
             * @static
             * @private
             */
            var _IEEnumFix = function () { }, ADD = ["toString", "valueOf"];
            try {
                if (/MSIE/.test(navigator.userAgent)) {
                    _IEEnumFix = function (r, s) {
                        for (i = 0; i < ADD.length; i = i + 1) {
                            var fname = ADD[i], f = s[fname];
                            if (typeof f === 'function' && f != Object.prototype[fname]) {
                                r[fname] = f;
                            }
                        }
                    };
                }
            }
            catch (ex) { }
            _IEEnumFix(subc.prototype, overrides);
        }
    }
};

/* asn1-1.0.13.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
 */
/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version asn1 1.0.13 (2017-Jun-02)
 * @since jsrsasign 2.1
 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
 */
/**
 * kjur's class library name space
 * <p>
 * This name space provides following name spaces:
 * <ul>
 * <li>{@link KJUR.asn1} - ASN.1 primitive hexadecimal encoder</li>
 * <li>{@link KJUR.asn1.x509} - ASN.1 structure for X.509 certificate and CRL</li>
 * <li>{@link KJUR.crypto} - Java Cryptographic Extension(JCE) style MessageDigest/Signature
 * class and utilities</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
 * @name KJUR
 * @namespace kjur's class library name space
 */
var KJUR = {};
/**
 * kjur's ASN.1 class library name space
 * <p>
 * This is ITU-T X.690 ASN.1 DER encoder class library and
 * class structure and methods is very similar to
 * org.bouncycastle.asn1 package of
 * well known BouncyCaslte Cryptography Library.
 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
 * Here are ASN.1 DER primitive classes.
 * <ul>
 * <li>0x01 {@link KJUR.asn1.DERBoolean}</li>
 * <li>0x02 {@link KJUR.asn1.DERInteger}</li>
 * <li>0x03 {@link KJUR.asn1.DERBitString}</li>
 * <li>0x04 {@link KJUR.asn1.DEROctetString}</li>
 * <li>0x05 {@link KJUR.asn1.DERNull}</li>
 * <li>0x06 {@link KJUR.asn1.DERObjectIdentifier}</li>
 * <li>0x0a {@link KJUR.asn1.DEREnumerated}</li>
 * <li>0x0c {@link KJUR.asn1.DERUTF8String}</li>
 * <li>0x12 {@link KJUR.asn1.DERNumericString}</li>
 * <li>0x13 {@link KJUR.asn1.DERPrintableString}</li>
 * <li>0x14 {@link KJUR.asn1.DERTeletexString}</li>
 * <li>0x16 {@link KJUR.asn1.DERIA5String}</li>
 * <li>0x17 {@link KJUR.asn1.DERUTCTime}</li>
 * <li>0x18 {@link KJUR.asn1.DERGeneralizedTime}</li>
 * <li>0x30 {@link KJUR.asn1.DERSequence}</li>
 * <li>0x31 {@link KJUR.asn1.DERSet}</li>
 * </ul>
 * <h4>OTHER ASN.1 CLASSES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.ASN1Object}</li>
 * <li>{@link KJUR.asn1.DERAbstractString}</li>
 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
 * </ul>
 * <h4>SUB NAME SPACES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.cades} - CAdES long term signature format</li>
 * <li>{@link KJUR.asn1.cms} - Cryptographic Message Syntax</li>
 * <li>{@link KJUR.asn1.csr} - Certificate Signing Request (CSR/PKCS#10)</li>
 * <li>{@link KJUR.asn1.tsp} - RFC 3161 Timestamping Protocol Format</li>
 * <li>{@link KJUR.asn1.x509} - RFC 5280 X.509 certificate and CRL</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace.
 * This caused by a bug of jsdoc2.
 * @name KJUR.asn1
 * @namespace
 */
if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1)
    KJUR.asn1 = {};
/**
 * ASN1 utilities class
 * @name KJUR.asn1.ASN1Util
 * @class ASN1 utilities class
 * @since asn1 1.0.2
 */
KJUR.asn1.ASN1Util = new function () {
    this.integerToByteHex = function (i) {
        var h = i.toString(16);
        if ((h.length % 2) == 1)
            h = '0' + h;
        return h;
    };
    this.bigIntToMinTwosComplementsHex = function (bigIntegerValue) {
        var h = bigIntegerValue.toString(16);
        if (h.substr(0, 1) != '-') {
            if (h.length % 2 == 1) {
                h = '0' + h;
            }
            else {
                if (!h.match(/^[0-7]/)) {
                    h = '00' + h;
                }
            }
        }
        else {
            var hPos = h.substr(1);
            var xorLen = hPos.length;
            if (xorLen % 2 == 1) {
                xorLen += 1;
            }
            else {
                if (!h.match(/^[0-7]/)) {
                    xorLen += 2;
                }
            }
            var hMask = '';
            for (var i = 0; i < xorLen; i++) {
                hMask += 'f';
            }
            var biMask = new BigInteger(hMask, 16);
            var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
            h = biNeg.toString(16).replace(/^-/, '');
        }
        return h;
    };
    /**
     * get PEM string from hexadecimal data and header string
     * @name getPEMStringFromHex
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {String} dataHex hexadecimal string of PEM body
     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
     * @return {String} PEM formatted string of input data
     * @description
     * This method converts a hexadecimal string to a PEM string with
     * a specified header. Its line break will be CRLF("\r\n").
     * @example
     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
     * // value of pem will be:
     * -----BEGIN PRIVATE KEY-----
     * YWFh
     * -----END PRIVATE KEY-----
     */
    this.getPEMStringFromHex = function (dataHex, pemHeader) {
        return hextopem(dataHex, pemHeader);
    };
    /**
     * generate ASN1Object specifed by JSON parameters
     * @name newObject
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return {KJUR.asn1.ASN1Object} generated object
     * @since asn1 1.0.3
     * @description
     * generate any ASN1Object specified by JSON param
     * including ASN.1 primitive or structured.
     * Generally 'param' can be described as follows:
     * <blockquote>
     * {TYPE-OF-ASNOBJ: ASN1OBJ-PARAMETER}
     * </blockquote>
     * 'TYPE-OF-ASN1OBJ' can be one of following symbols:
     * <ul>
     * <li>'bool' - DERBoolean</li>
     * <li>'int' - DERInteger</li>
     * <li>'bitstr' - DERBitString</li>
     * <li>'octstr' - DEROctetString</li>
     * <li>'null' - DERNull</li>
     * <li>'oid' - DERObjectIdentifier</li>
     * <li>'enum' - DEREnumerated</li>
     * <li>'utf8str' - DERUTF8String</li>
     * <li>'numstr' - DERNumericString</li>
     * <li>'prnstr' - DERPrintableString</li>
     * <li>'telstr' - DERTeletexString</li>
     * <li>'ia5str' - DERIA5String</li>
     * <li>'utctime' - DERUTCTime</li>
     * <li>'gentime' - DERGeneralizedTime</li>
     * <li>'seq' - DERSequence</li>
     * <li>'set' - DERSet</li>
     * <li>'tag' - DERTaggedObject</li>
     * </ul>
     * @example
     * newObject({'prnstr': 'aaa'});
     * newObject({'seq': [{'int': 3}, {'prnstr': 'aaa'}]})
     * // ASN.1 Tagged Object
     * newObject({'tag': {'tag': 'a1',
     *                    'explicit': true,
     *                    'obj': {'seq': [{'int': 3}, {'prnstr': 'aaa'}]}}});
     * // more simple representation of ASN.1 Tagged Object
     * newObject({'tag': ['a1',
     *                    true,
     *                    {'seq': [
     *                      {'int': 3},
     *                      {'prnstr': 'aaa'}]}
     *                   ]});
     */
    this.newObject = function (param) {
        var _KJUR = KJUR, _KJUR_asn1 = _KJUR.asn1, _DERBoolean = _KJUR_asn1.DERBoolean, _DERInteger = _KJUR_asn1.DERInteger, _DERBitString = _KJUR_asn1.DERBitString, _DEROctetString = _KJUR_asn1.DEROctetString, _DERNull = _KJUR_asn1.DERNull, _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier, _DEREnumerated = _KJUR_asn1.DEREnumerated, _DERUTF8String = _KJUR_asn1.DERUTF8String, _DERNumericString = _KJUR_asn1.DERNumericString, _DERPrintableString = _KJUR_asn1.DERPrintableString, _DERTeletexString = _KJUR_asn1.DERTeletexString, _DERIA5String = _KJUR_asn1.DERIA5String, _DERUTCTime = _KJUR_asn1.DERUTCTime, _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime, _DERSequence = _KJUR_asn1.DERSequence, _DERSet = _KJUR_asn1.DERSet, _DERTaggedObject = _KJUR_asn1.DERTaggedObject, _newObject = _KJUR_asn1.ASN1Util.newObject;
        var keys = Object.keys(param);
        if (keys.length != 1)
            throw "key of param shall be only one.";
        var key = keys[0];
        if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1)
            throw "undefined key: " + key;
        if (key == "bool")
            return new _DERBoolean(param[key]);
        if (key == "int")
            return new _DERInteger(param[key]);
        if (key == "bitstr")
            return new _DERBitString(param[key]);
        if (key == "octstr")
            return new _DEROctetString(param[key]);
        if (key == "null")
            return new _DERNull(param[key]);
        if (key == "oid")
            return new _DERObjectIdentifier(param[key]);
        if (key == "enum")
            return new _DEREnumerated(param[key]);
        if (key == "utf8str")
            return new _DERUTF8String(param[key]);
        if (key == "numstr")
            return new _DERNumericString(param[key]);
        if (key == "prnstr")
            return new _DERPrintableString(param[key]);
        if (key == "telstr")
            return new _DERTeletexString(param[key]);
        if (key == "ia5str")
            return new _DERIA5String(param[key]);
        if (key == "utctime")
            return new _DERUTCTime(param[key]);
        if (key == "gentime")
            return new _DERGeneralizedTime(param[key]);
        if (key == "seq") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSequence({ 'array': a });
        }
        if (key == "set") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSet({ 'array': a });
        }
        if (key == "tag") {
            var tagParam = param[key];
            if (Object.prototype.toString.call(tagParam) === '[object Array]' &&
                tagParam.length == 3) {
                var obj = _newObject(tagParam[2]);
                return new _DERTaggedObject({ tag: tagParam[0],
                    explicit: tagParam[1],
                    obj: obj });
            }
            else {
                var newParam = {};
                if (tagParam.explicit !== undefined)
                    newParam.explicit = tagParam.explicit;
                if (tagParam.tag !== undefined)
                    newParam.tag = tagParam.tag;
                if (tagParam.obj === undefined)
                    throw "obj shall be specified for 'tag'.";
                newParam.obj = _newObject(tagParam.obj);
                return new _DERTaggedObject(newParam);
            }
        }
    };
    /**
     * get encoded hexadecimal string of ASN1Object specifed by JSON parameters
     * @name jsonToASN1HEX
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return hexadecimal string of ASN1Object
     * @since asn1 1.0.4
     * @description
     * As for ASN.1 object representation of JSON object,
     * please see {@link newObject}.
     * @example
     * jsonToASN1HEX({'prnstr': 'aaa'});
     */
    this.jsonToASN1HEX = function (param) {
        var asn1Obj = this.newObject(param);
        return asn1Obj.getEncodedHex();
    };
};
/**
 * get dot noted oid number string from hexadecimal value of OID
 * @name oidHexToInt
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} hex hexadecimal value of object identifier
 * @return {String} dot noted string of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from hexadecimal string representation of
 * ASN.1 value of object identifier to oid number string.
 * @example
 * KJUR.asn1.ASN1Util.oidHexToInt('550406') &rarr; "2.5.4.6"
 */
KJUR.asn1.ASN1Util.oidHexToInt = function (hex) {
    var s = "";
    var i01 = parseInt(hex.substr(0, 2), 16);
    var i0 = Math.floor(i01 / 40);
    var i1 = i01 % 40;
    var s = i0 + "." + i1;
    var binbuf = "";
    for (var i = 2; i < hex.length; i += 2) {
        var value = parseInt(hex.substr(i, 2), 16);
        var bin = ("00000000" + value.toString(2)).slice(-8);
        binbuf = binbuf + bin.substr(1, 7);
        if (bin.substr(0, 1) == "0") {
            var bi = new BigInteger(binbuf, 2);
            s = s + "." + bi.toString(10);
            binbuf = "";
        }
    }
    return s;
};
/**
 * get hexadecimal value of object identifier from dot noted oid value
 * @name oidIntToHex
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} oidString dot noted string of object identifier
 * @return {String} hexadecimal value of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from object identifier value string.
 * to hexadecimal string representation of it.
 * @example
 * KJUR.asn1.ASN1Util.oidIntToHex("2.5.4.6") &rarr; "550406"
 */
KJUR.asn1.ASN1Util.oidIntToHex = function (oidString) {
    var itox = function (i) {
        var h = i.toString(16);
        if (h.length == 1)
            h = '0' + h;
        return h;
    };
    var roidtox = function (roid) {
        var h = '';
        var bi = new BigInteger(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7)
            padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++)
            bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7)
                b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    if (!oidString.match(/^[0-9.]+$/)) {
        throw "malformed oid string: " + oidString;
    }
    var h = '';
    var a = oidString.split('.');
    var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
    h += itox(i0);
    a.splice(0, 2);
    for (var i = 0; i < a.length; i++) {
        h += roidtox(a[i]);
    }
    return h;
};
// ********************************************************************
//  Abstract ASN.1 Classes
// ********************************************************************
// ********************************************************************
/**
 * base class for ASN.1 DER encoder object
 * @name KJUR.asn1.ASN1Object
 * @class base class for ASN.1 DER encoder object
 * @property {Boolean} isModified flag whether internal data was changed
 * @property {String} hTLV hexadecimal string of ASN.1 TLV
 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
 * @description
 */
KJUR.asn1.ASN1Object = function () {
    var hV = '';
    /**
     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
     * @name getLengthHexFromValue
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV length(L)
     */
    this.getLengthHexFromValue = function () {
        if (typeof this.hV == "undefined" || this.hV == null) {
            throw "this.hV is null or undefined.";
        }
        if (this.hV.length % 2 == 1) {
            throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
        }
        var n = this.hV.length / 2;
        var hN = n.toString(16);
        if (hN.length % 2 == 1) {
            hN = "0" + hN;
        }
        if (n < 128) {
            return hN;
        }
        else {
            var hNlen = hN.length / 2;
            if (hNlen > 15) {
                throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
            }
            var head = 128 + hNlen;
            return head.toString(16) + hN;
        }
    };
    /**
     * get hexadecimal string of ASN.1 TLV bytes
     * @name getEncodedHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV
     */
    this.getEncodedHex = function () {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
            //alert("first time: " + this.hTLV);
        }
        return this.hTLV;
    };
    /**
     * get hexadecimal string of ASN.1 TLV value(V) bytes
     * @name getValueHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
     */
    this.getValueHex = function () {
        this.getEncodedHex();
        return this.hV;
    };
    this.getFreshValueHex = function () {
        return '';
    };
};
// == BEGIN DERAbstractString ================================================
/**
 * base class for ASN.1 DER string classes
 * @name KJUR.asn1.DERAbstractString
 * @class base class for ASN.1 DER string classes
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @property {String} s internal string of value
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERAbstractString = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @return {String} string value of this string object
     */
    this.getString = function () {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newS value by a string to set
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };
    /**
     * set value by a hexadecimal string
     * @name setStringHex
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newHexString value by a hexadecimal string to set
     */
    this.setStringHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string") {
            this.setString(params);
        }
        else if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
// == END   DERAbstractString ================================================
// == BEGIN DERAbstractTime ==================================================
/**
 * base class for ASN.1 DER Generalized/UTCTime class
 * @name KJUR.asn1.DERAbstractTime
 * @class base class for ASN.1 DER Generalized/UTCTime class
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractTime = function (params) {
    KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
    // --- PRIVATE METHODS --------------------
    this.localDateToUTC = function (d) {
        utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        var utcDate = new Date(utc);
        return utcDate;
    };
    /*
     * format date string by Data object
     * @name formatDate
     * @memberOf KJUR.asn1.AbstractTime;
     * @param {Date} dateObject
     * @param {string} type 'utc' or 'gen'
     * @param {boolean} withMillis flag for with millisections or not
     * @description
     * 'withMillis' flag is supported from asn1 1.0.6.
     */
    this.formatDate = function (dateObject, type, withMillis) {
        var pad = this.zeroPadding;
        var d = this.localDateToUTC(dateObject);
        var year = String(d.getFullYear());
        if (type == 'utc')
            year = year.substr(2, 2);
        var month = pad(String(d.getMonth() + 1), 2);
        var day = pad(String(d.getDate()), 2);
        var hour = pad(String(d.getHours()), 2);
        var min = pad(String(d.getMinutes()), 2);
        var sec = pad(String(d.getSeconds()), 2);
        var s = year + month + day + hour + min + sec;
        if (withMillis === true) {
            var millis = d.getMilliseconds();
            if (millis != 0) {
                var sMillis = pad(String(millis), 3);
                sMillis = sMillis.replace(/[0]+$/, "");
                s = s + "." + sMillis;
            }
        }
        return s + "Z";
    };
    this.zeroPadding = function (s, len) {
        if (s.length >= len)
            return s;
        return new Array(len - s.length + 1).join('0') + s;
    };
    // --- PUBLIC METHODS --------------------
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @return {String} string value of this time object
     */
    this.getString = function () {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {String} newS value by a string to set such like "130430235959Z"
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(newS);
    };
    /**
     * set value by a Date object
     * @name setByDateValue
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {Integer} year year of date (ex. 2013)
     * @param {Integer} month month of date between 1 and 12 (ex. 12)
     * @param {Integer} day day of month
     * @param {Integer} hour hours of date
     * @param {Integer} min minutes of date
     * @param {Integer} sec seconds of date
     */
    this.setByDateValue = function (year, month, day, hour, min, sec) {
        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
        this.setByDate(dateObject);
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
// == END   DERAbstractTime ==================================================
// == BEGIN DERAbstractStructured ============================================
/**
 * base class for ASN.1 DER structured class
 * @name KJUR.asn1.DERAbstractStructured
 * @class base class for ASN.1 DER structured class
 * @property {Array} asn1Array internal array of ASN1Object
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractStructured = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    /**
     * set value by array of ASN1Object
     * @name setByASN1ObjectArray
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {array} asn1ObjectArray array of ASN1Object to set
     */
    this.setByASN1ObjectArray = function (asn1ObjectArray) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = asn1ObjectArray;
    };
    /**
     * append an ASN1Object to internal array
     * @name appendASN1Object
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {ASN1Object} asn1Object to add
     */
    this.appendASN1Object = function (asn1Object) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(asn1Object);
    };
    this.asn1Array = new Array();
    if (typeof params != "undefined") {
        if (typeof params['array'] != "undefined") {
            this.asn1Array = params['array'];
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);
// ********************************************************************
//  ASN.1 Object Classes
// ********************************************************************
// ********************************************************************
/**
 * class for ASN.1 DER Boolean
 * @name KJUR.asn1.DERBoolean
 * @class class for ASN.1 DER Boolean
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERBoolean = function () {
    KJUR.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    this.hTLV = "0101ff";
};
YAHOO.lang.extend(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Integer
 * @name KJUR.asn1.DERInteger
 * @class class for ASN.1 DER Integer
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERInteger = function (params) {
    KJUR.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function (bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function (intValue) {
        var bi = new BigInteger(String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     * @example
     * new KJUR.asn1.DERInteger(123);
     * new KJUR.asn1.DERInteger({'int': 123});
     * new KJUR.asn1.DERInteger({'hex': '1fad'});
     */
    this.setValueHex = function (newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['bigint'] != "undefined") {
            this.setByBigInteger(params['bigint']);
        }
        else if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        }
        else if (typeof params == "number") {
            this.setByInteger(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER encoded BitString primitive
 * @name KJUR.asn1.DERBitString
 * @class class for ASN.1 DER encoded BitString primitive
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>bin - specify binary string (ex. '10111')</li>
 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
 * <li>obj - specify {@link KJUR.asn1.ASN1Util.newObject}
 * argument for "BitString encapsulates" structure.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: 'obj' parameter have been supported since
 * asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).<br/>
 * @example
 * // default constructor
 * o = new KJUR.asn1.DERBitString();
 * // initialize with binary string
 * o = new KJUR.asn1.DERBitString({bin: "1011"});
 * // initialize with boolean array
 * o = new KJUR.asn1.DERBitString({array: [true,false,true,true]});
 * // initialize with hexadecimal string (04 is unused bits)
 * o = new KJUR.asn1.DEROctetString({hex: "04bac0"});
 * // initialize with ASN1Util.newObject argument for encapsulated
 * o = new KJUR.asn1.DERBitString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // BIT STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DERBitString = function (params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = "00" + o.getEncodedHex();
    }
    KJUR.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";
    /**
     * set ASN.1 value(V) by a hexadecimal string including unused bits
     * @name setHexValueIncludingUnusedBits
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} newHexStringIncludingUnusedBits
     */
    this.setHexValueIncludingUnusedBits = function (newHexStringIncludingUnusedBits) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = newHexStringIncludingUnusedBits;
    };
    /**
     * set ASN.1 value(V) by unused bit and hexadecimal string of value
     * @name setUnusedBitsAndHexValue
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {Integer} unusedBits
     * @param {String} hValue
     */
    this.setUnusedBitsAndHexValue = function (unusedBits, hValue) {
        if (unusedBits < 0 || 7 < unusedBits) {
            throw "unused bits shall be from 0 to 7: u = " + unusedBits;
        }
        var hUnusedBits = "0" + unusedBits;
        this.hTLV = null;
        this.isModified = true;
        this.hV = hUnusedBits + hValue;
    };
    /**
     * set ASN.1 DER BitString by binary string<br/>
     * @name setByBinaryString
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} binaryString binary value string (i.e. '10111')
     * @description
     * Its unused bits will be calculated automatically by length of
     * 'binaryValue'. <br/>
     * NOTE: Trailing zeros '0' will be ignored.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray("01011");
     */
    this.setByBinaryString = function (binaryString) {
        binaryString = binaryString.replace(/0+$/, '');
        var unusedBits = 8 - binaryString.length % 8;
        if (unusedBits == 8)
            unusedBits = 0;
        for (var i = 0; i <= unusedBits; i++) {
            binaryString += '0';
        }
        var h = '';
        for (var i = 0; i < binaryString.length - 1; i += 8) {
            var b = binaryString.substr(i, 8);
            var x = parseInt(b, 2).toString(16);
            if (x.length == 1)
                x = '0' + x;
            h += x;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = '0' + unusedBits + h;
    };
    /**
     * set ASN.1 TLV value(V) by an array of boolean<br/>
     * @name setByBooleanArray
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {array} booleanArray array of boolean (ex. [true, false, true])
     * @description
     * NOTE: Trailing falses will be ignored in the ASN.1 DER Object.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray([false, true, false, true, true]);
     */
    this.setByBooleanArray = function (booleanArray) {
        var s = '';
        for (var i = 0; i < booleanArray.length; i++) {
            if (booleanArray[i] == true) {
                s += '1';
            }
            else {
                s += '0';
            }
        }
        this.setByBinaryString(s);
    };
    /**
     * generate an array of falses with specified length<br/>
     * @name newFalseArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} nLength length of array to generate
     * @return {array} array of boolean falses
     * @description
     * This static method may be useful to initialize boolean array.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.newFalseArray(3) &rarr; [false, false, false]
     */
    this.newFalseArray = function (nLength) {
        var a = new Array(nLength);
        for (var i = 0; i < nLength; i++) {
            a[i] = false;
        }
        return a;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) {
            this.setHexValueIncludingUnusedBits(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setHexValueIncludingUnusedBits(params['hex']);
        }
        else if (typeof params['bin'] != "undefined") {
            this.setByBinaryString(params['bin']);
        }
        else if (typeof params['array'] != "undefined") {
            this.setByBooleanArray(params['array']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER OctetString<br/>
 * @name KJUR.asn1.DEROctetString
 * @class class for ASN.1 DER OctetString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * This class provides ASN.1 OctetString simple type.<br/>
 * Supported "params" attributes are:
 * <ul>
 * <li>str - to set a string as a value</li>
 * <li>hex - to set a hexadecimal string as a value</li>
 * <li>obj - to set a encapsulated ASN.1 value by JSON object
 * which is defined in {@link KJUR.asn1.ASN1Util.newObject}</li>
 * </ul>
 * NOTE: A parameter 'obj' have been supported
 * for "OCTET STRING, encapsulates" structure.
 * since asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).
 * @see KJUR.asn1.DERAbstractString - superclass
 * @example
 * // default constructor
 * o = new KJUR.asn1.DEROctetString();
 * // initialize with string
 * o = new KJUR.asn1.DEROctetString({str: "aaa"});
 * // initialize with hexadecimal string
 * o = new KJUR.asn1.DEROctetString({hex: "616161"});
 * // initialize with ASN1Util.newObject argument
 * o = new KJUR.asn1.DEROctetString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // OCTET STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DEROctetString = function (params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = o.getEncodedHex();
    }
    KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
    this.hT = "04";
};
YAHOO.lang.extend(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER Null
 * @name KJUR.asn1.DERNull
 * @class class for ASN.1 DER Null
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERNull = function () {
    KJUR.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
YAHOO.lang.extend(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER ObjectIdentifier
 * @name KJUR.asn1.DERObjectIdentifier
 * @class class for ASN.1 DER ObjectIdentifier
 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERObjectIdentifier = function (params) {
    var itox = function (i) {
        var h = i.toString(16);
        if (h.length == 1)
            h = '0' + h;
        return h;
    };
    var roidtox = function (roid) {
        var h = '';
        var bi = new BigInteger(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7)
            padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++)
            bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7)
                b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";
    /**
     * set value by a hexadecimal string
     * @name setValueHex
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} newHexString hexadecimal value of OID bytes
     */
    this.setValueHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    /**
     * set value by a OID string<br/>
     * @name setValueOidString
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidString OID string (ex. 2.5.4.13)
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueOidString("2.5.4.13");
     */
    this.setValueOidString = function (oidString) {
        if (!oidString.match(/^[0-9.]+$/)) {
            throw "malformed oid string: " + oidString;
        }
        var h = '';
        var a = oidString.split('.');
        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
        h += itox(i0);
        a.splice(0, 2);
        for (var i = 0; i < a.length; i++) {
            h += roidtox(a[i]);
        }
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = h;
    };
    /**
     * set value by a OID name
     * @name setValueName
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidName OID name (ex. 'serverAuth')
     * @since 1.0.1
     * @description
     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
     * Otherwise raise error.
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueName("serverAuth");
     */
    this.setValueName = function (oidName) {
        var oid = KJUR.asn1.x509.OID.name2oid(oidName);
        if (oid !== '') {
            this.setValueOidString(oid);
        }
        else {
            throw "DERObjectIdentifier oidName undefined: " + oidName;
        }
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (params !== undefined) {
        if (typeof params === "string") {
            if (params.match(/^[0-2].[0-9.]+$/)) {
                this.setValueOidString(params);
            }
            else {
                this.setValueName(params);
            }
        }
        else if (params.oid !== undefined) {
            this.setValueOidString(params.oid);
        }
        else if (params.hex !== undefined) {
            this.setValueHex(params.hex);
        }
        else if (params.name !== undefined) {
            this.setValueName(params.name);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Enumerated
 * @name KJUR.asn1.DEREnumerated
 * @class class for ASN.1 DER Enumerated
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * @example
 * new KJUR.asn1.DEREnumerated(123);
 * new KJUR.asn1.DEREnumerated({int: 123});
 * new KJUR.asn1.DEREnumerated({hex: '1fad'});
 */
KJUR.asn1.DEREnumerated = function (params) {
    KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = "0a";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function (bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function (intValue) {
        var bi = new BigInteger(String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     */
    this.setValueHex = function (newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        }
        else if (typeof params == "number") {
            this.setByInteger(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER UTF8String
 * @name KJUR.asn1.DERUTF8String
 * @class class for ASN.1 DER UTF8String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERUTF8String = function (params) {
    KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
    this.hT = "0c";
};
YAHOO.lang.extend(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER NumericString
 * @name KJUR.asn1.DERNumericString
 * @class class for ASN.1 DER NumericString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERNumericString = function (params) {
    KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
    this.hT = "12";
};
YAHOO.lang.extend(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER PrintableString
 * @name KJUR.asn1.DERPrintableString
 * @class class for ASN.1 DER PrintableString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERPrintableString = function (params) {
    KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
    this.hT = "13";
};
YAHOO.lang.extend(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER TeletexString
 * @name KJUR.asn1.DERTeletexString
 * @class class for ASN.1 DER TeletexString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERTeletexString = function (params) {
    KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
    this.hT = "14";
};
YAHOO.lang.extend(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER IA5String
 * @name KJUR.asn1.DERIA5String
 * @class class for ASN.1 DER IA5String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERIA5String = function (params) {
    KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
    this.hT = "16";
};
YAHOO.lang.extend(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER UTCTime
 * @name KJUR.asn1.DERUTCTime
 * @class class for ASN.1 DER UTCTime
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * <h4>EXAMPLES</h4>
 * @example
 * d1 = new KJUR.asn1.DERUTCTime();
 * d1.setString('130430125959Z');
 *
 * d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
 * d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
 * d4 = new KJUR.asn1.DERUTCTime('130430125959Z');
 */
KJUR.asn1.DERUTCTime = function (params) {
    KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
    this.hT = "17";
    /**
     * set value by a Date object<br/>
     * @name setByDate
     * @memberOf KJUR.asn1.DERUTCTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * o = new KJUR.asn1.DERUTCTime();
     * o.setByDate(new Date("2016/12/31"));
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
        if (typeof this.date == "undefined" && typeof this.s == "undefined") {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'utc');
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        }
        else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) {
            this.setString(params);
        }
        else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        }
        else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER GeneralizedTime
 * @name KJUR.asn1.DERGeneralizedTime
 * @class class for ASN.1 DER GeneralizedTime
 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
 * @property {Boolean} withMillis flag to show milliseconds or not
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * <li>millis - specify flag to show milliseconds (from 1.0.6)</li>
 * </ul>
 * NOTE1: 'params' can be omitted.
 * NOTE2: 'withMillis' property is supported from asn1 1.0.6.
 */
KJUR.asn1.DERGeneralizedTime = function (params) {
    KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
    this.hT = "18";
    this.withMillis = false;
    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERGeneralizedTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
     * o1 = new DERUTCTime();
     * o1.setByDate(date);
     *
     * date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'gen', this.withMillis);
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
        if (this.date === undefined && this.s === undefined) {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'gen', this.withMillis);
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        }
        else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) {
            this.setString(params);
        }
        else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        }
        else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
        if (params.millis === true) {
            this.withMillis = true;
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER Sequence
 * @name KJUR.asn1.DERSequence
 * @class class for ASN.1 DER Sequence
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERSequence = function (params) {
    KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
    this.hT = "30";
    this.getFreshValueHex = function () {
        var h = '';
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            h += asn1Obj.getEncodedHex();
        }
        this.hV = h;
        return this.hV;
    };
};
YAHOO.lang.extend(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER Set
 * @name KJUR.asn1.DERSet
 * @class class for ASN.1 DER Set
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * <li>sortflag - flag for sort (default: true). ASN.1 BER is not sorted in 'SET OF'.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: sortflag is supported since 1.0.5.
 */
KJUR.asn1.DERSet = function (params) {
    KJUR.asn1.DERSet.superclass.constructor.call(this, params);
    this.hT = "31";
    this.sortFlag = true; // item shall be sorted only in ASN.1 DER
    this.getFreshValueHex = function () {
        var a = new Array();
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            a.push(asn1Obj.getEncodedHex());
        }
        if (this.sortFlag == true)
            a.sort();
        this.hV = a.join('');
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params.sortflag != "undefined" &&
            params.sortflag == false)
            this.sortFlag = false;
    }
};
YAHOO.lang.extend(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER TaggedObject
 * @name KJUR.asn1.DERTaggedObject
 * @class class for ASN.1 DER TaggedObject
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
 * For example, if you find '[1]' tag in a ASN.1 dump,
 * 'tagNoHex' will be 'a1'.
 * <br/>
 * As for optional argument 'params' for constructor, you can specify *ANY* of
 * following properties:
 * <ul>
 * <li>explicit - specify true if this is explicit tag otherwise false
 *     (default is 'true').</li>
 * <li>tag - specify tag (default is 'a0' which means [0])</li>
 * <li>obj - specify ASN1Object which is tagged</li>
 * </ul>
 * @example
 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
 * hex = d2.getEncodedHex();
 */
KJUR.asn1.DERTaggedObject = function (params) {
    KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = "a0";
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;
    /**
     * set value by an ASN1Object
     * @name setString
     * @memberOf KJUR.asn1.DERTaggedObject#
     * @function
     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
     */
    this.setASN1Object = function (isExplicitFlag, tagNoHex, asn1Object) {
        this.hT = tagNoHex;
        this.isExplicit = isExplicitFlag;
        this.asn1Object = asn1Object;
        if (this.isExplicit) {
            this.hV = this.asn1Object.getEncodedHex();
            this.hTLV = null;
            this.isModified = true;
        }
        else {
            this.hV = null;
            this.hTLV = asn1Object.getEncodedHex();
            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
            this.isModified = false;
        }
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['tag'] != "undefined") {
            this.hT = params['tag'];
        }
        if (typeof params['explicit'] != "undefined") {
            this.isExplicit = params['explicit'];
        }
        if (typeof params['obj'] != "undefined") {
            this.asn1Object = params['obj'];
            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
 * This object is just a decorator for parsing the key parameter
 * @param {string|Object} key - The key in string format, or an object containing
 * the parameters needed to build a RSAKey object.
 * @constructor
 */
var JSEncryptRSAKey = /** @class */ (function (_super) {
    __extends$1(JSEncryptRSAKey, _super);
    function JSEncryptRSAKey(key) {
        var _this = _super.call(this) || this;
        // Call the super constructor.
        //  RSAKey.call(this);
        // If a key key was provided.
        if (key) {
            // If this is a string...
            if (typeof key === "string") {
                _this.parseKey(key);
            }
            else if (JSEncryptRSAKey.hasPrivateKeyProperty(key) ||
                JSEncryptRSAKey.hasPublicKeyProperty(key)) {
                // Set the values for the key.
                _this.parsePropertiesFrom(key);
            }
        }
        return _this;
    }
    /**
     * Method to parse a pem encoded string containing both a public or private key.
     * The method will translate the pem encoded string in a der encoded string and
     * will parse private key and public key parameters. This method accepts public key
     * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
     *
     * @todo Check how many rsa formats use the same format of pkcs #1.
     *
     * The format is defined as:
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * it's possible to examine the structure of the keys obtained from openssl using
     * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
     * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
     * @private
     */
    JSEncryptRSAKey.prototype.parseKey = function (pem) {
        try {
            var modulus = 0;
            var public_exponent = 0;
            var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
            var der = reHex.test(pem) ? Hex.decode(pem) : Base64.unarmor(pem);
            var asn1 = ASN1.decode(der);
            // Fixes a bug with OpenSSL 1.0+ private keys
            if (asn1.sub.length === 3) {
                asn1 = asn1.sub[2].sub[0];
            }
            if (asn1.sub.length === 9) {
                // Parse the private key.
                modulus = asn1.sub[1].getHexStringValue(); // bigint
                this.n = parseBigInt(modulus, 16);
                public_exponent = asn1.sub[2].getHexStringValue(); // int
                this.e = parseInt(public_exponent, 16);
                var private_exponent = asn1.sub[3].getHexStringValue(); // bigint
                this.d = parseBigInt(private_exponent, 16);
                var prime1 = asn1.sub[4].getHexStringValue(); // bigint
                this.p = parseBigInt(prime1, 16);
                var prime2 = asn1.sub[5].getHexStringValue(); // bigint
                this.q = parseBigInt(prime2, 16);
                var exponent1 = asn1.sub[6].getHexStringValue(); // bigint
                this.dmp1 = parseBigInt(exponent1, 16);
                var exponent2 = asn1.sub[7].getHexStringValue(); // bigint
                this.dmq1 = parseBigInt(exponent2, 16);
                var coefficient = asn1.sub[8].getHexStringValue(); // bigint
                this.coeff = parseBigInt(coefficient, 16);
            }
            else if (asn1.sub.length === 2) {
                if (asn1.sub[0].sub) {
                    // Parse ASN.1 SubjectPublicKeyInfo type as defined by X.509
                    var bit_string = asn1.sub[1];
                    var sequence = bit_string.sub[0];
                    modulus = sequence.sub[0].getHexStringValue();
                    this.n = parseBigInt(modulus, 16);
                    public_exponent = sequence.sub[1].getHexStringValue();
                    this.e = parseInt(public_exponent, 16);
                }
                else {
                    // Parse ASN.1 RSAPublicKey type as defined by PKCS #1
                    modulus = asn1.sub[0].getHexStringValue();
                    this.n = parseBigInt(modulus, 16);
                    public_exponent = asn1.sub[1].getHexStringValue();
                    this.e = parseInt(public_exponent, 16);
                }
            }
            else {
                return false;
            }
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa key.
     *
     * The translation follow the ASN.1 notation :
     * RSAPrivateKey ::= SEQUENCE {
     *   version           Version,
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER,  -- e
     *   privateExponent   INTEGER,  -- d
     *   prime1            INTEGER,  -- p
     *   prime2            INTEGER,  -- q
     *   exponent1         INTEGER,  -- d mod (p1)
     *   exponent2         INTEGER,  -- d mod (q-1)
     *   coefficient       INTEGER,  -- (inverse of q) mod p
     * }
     * @returns {string}  DER Encoded String representing the rsa private key
     * @private
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKey = function () {
        var options = {
            array: [
                new KJUR.asn1.DERInteger({ int: 0 }),
                new KJUR.asn1.DERInteger({ bigint: this.n }),
                new KJUR.asn1.DERInteger({ int: this.e }),
                new KJUR.asn1.DERInteger({ bigint: this.d }),
                new KJUR.asn1.DERInteger({ bigint: this.p }),
                new KJUR.asn1.DERInteger({ bigint: this.q }),
                new KJUR.asn1.DERInteger({ bigint: this.dmp1 }),
                new KJUR.asn1.DERInteger({ bigint: this.dmq1 }),
                new KJUR.asn1.DERInteger({ bigint: this.coeff }),
            ],
        };
        var seq = new KJUR.asn1.DERSequence(options);
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKeyB64 = function () {
        return hex2b64(this.getPrivateBaseKey());
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa public key.
     * The representation follow the ASN.1 notation :
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * @returns {string} DER Encoded String representing the rsa public key
     * @private
     */
    JSEncryptRSAKey.prototype.getPublicBaseKey = function () {
        var first_sequence = new KJUR.asn1.DERSequence({
            array: [
                new KJUR.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
                new KJUR.asn1.DERNull(),
            ],
        });
        var second_sequence = new KJUR.asn1.DERSequence({
            array: [
                new KJUR.asn1.DERInteger({ bigint: this.n }),
                new KJUR.asn1.DERInteger({ int: this.e }),
            ],
        });
        var bit_string = new KJUR.asn1.DERBitString({
            hex: "00" + second_sequence.getEncodedHex(),
        });
        var seq = new KJUR.asn1.DERSequence({
            array: [first_sequence, bit_string],
        });
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicBaseKeyB64 = function () {
        return hex2b64(this.getPublicBaseKey());
    };
    /**
     * wrap the string in block of width chars. The default value for rsa keys is 64
     * characters.
     * @param {string} str the pem encoded string without header and footer
     * @param {Number} [width=64] - the length the string has to be wrapped at
     * @returns {string}
     * @private
     */
    JSEncryptRSAKey.wordwrap = function (str, width) {
        width = width || 64;
        if (!str) {
            return str;
        }
        var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
        return str.match(RegExp(regex, "g")).join("\n");
    };
    /**
     * Retrieve the pem encoded private key
     * @returns {string} the pem encoded private key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateKey = function () {
        var key = "-----BEGIN RSA PRIVATE KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
        key += "-----END RSA PRIVATE KEY-----";
        return key;
    };
    /**
     * Retrieve the pem encoded public key
     * @returns {string} the pem encoded public key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicKey = function () {
        var key = "-----BEGIN PUBLIC KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPublicBaseKeyB64()) + "\n";
        key += "-----END PUBLIC KEY-----";
        return key;
    };
    /**
     * Check if the object contains the necessary parameters to populate the rsa modulus
     * and public exponent parameters.
     * @param {Object} [obj={}] - An object that may contain the two public key
     * parameters
     * @returns {boolean} true if the object contains both the modulus and the public exponent
     * properties (n and e)
     * @todo check for types of n and e. N should be a parseable bigInt object, E should
     * be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPublicKeyProperty = function (obj) {
        obj = obj || {};
        return obj.hasOwnProperty("n") && obj.hasOwnProperty("e");
    };
    /**
     * Check if the object contains ALL the parameters of an RSA key.
     * @param {Object} [obj={}] - An object that may contain nine rsa key
     * parameters
     * @returns {boolean} true if the object contains all the parameters needed
     * @todo check for types of the parameters all the parameters but the public exponent
     * should be parseable bigint objects, the public exponent should be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPrivateKeyProperty = function (obj) {
        obj = obj || {};
        return (obj.hasOwnProperty("n") &&
            obj.hasOwnProperty("e") &&
            obj.hasOwnProperty("d") &&
            obj.hasOwnProperty("p") &&
            obj.hasOwnProperty("q") &&
            obj.hasOwnProperty("dmp1") &&
            obj.hasOwnProperty("dmq1") &&
            obj.hasOwnProperty("coeff"));
    };
    /**
     * Parse the properties of obj in the current rsa object. Obj should AT LEAST
     * include the modulus and public exponent (n, e) parameters.
     * @param {Object} obj - the object containing rsa parameters
     * @private
     */
    JSEncryptRSAKey.prototype.parsePropertiesFrom = function (obj) {
        this.n = obj.n;
        this.e = obj.e;
        if (obj.hasOwnProperty("d")) {
            this.d = obj.d;
            this.p = obj.p;
            this.q = obj.q;
            this.dmp1 = obj.dmp1;
            this.dmq1 = obj.dmq1;
            this.coeff = obj.coeff;
        }
    };
    return JSEncryptRSAKey;
}(RSAKey));

var _a;
var version$1 = typeof process !== 'undefined'
    ? (_a = process.env) === null || _a === void 0 ? void 0 : _a.npm_package_version
    : undefined;
/**
 *
 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
 * possible parameters are:
 * - default_key_size        {number}  default: 1024 the key size in bit
 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
 * - log                     {boolean} default: false whether log warn/error or not
 * @constructor
 */
var JSEncrypt = /** @class */ (function () {
    function JSEncrypt(options) {
        if (options === void 0) { options = {}; }
        options = options || {};
        this.default_key_size = options.default_key_size
            ? parseInt(options.default_key_size, 10)
            : 1024;
        this.default_public_exponent = options.default_public_exponent || "010001"; // 65537 default openssl public exponent for rsa key type
        this.log = options.log || false;
        // The private and public key.
        this.key = null;
    }
    /**
     * Method to set the rsa key parameter (one method is enough to set both the public
     * and the private key, since the private key contains the public key paramenters)
     * Log a warning if logs are enabled
     * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
     * @public
     */
    JSEncrypt.prototype.setKey = function (key) {
        if (this.log && this.key) {
            console.warn("A key was already set, overriding existing.");
        }
        this.key = new JSEncryptRSAKey(key);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPrivateKey = function (privkey) {
        // Create the key.
        this.setKey(privkey);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPublicKey = function (pubkey) {
        // Sets the public key.
        this.setKey(pubkey);
    };
    /**
     * Proxy method for RSAKey object's decrypt, decrypt the string using the private
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str base64 encoded crypted string to decrypt
     * @return {string} the decrypted string
     * @public
     */
    JSEncrypt.prototype.decrypt = function (str) {
        // Return the decrypted string.
        try {
            return this.getKey().decrypt(b64tohex(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's encrypt, encrypt the string using the public
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str the string to encrypt
     * @return {string} the encrypted string encoded in base64
     * @public
     */
    JSEncrypt.prototype.encrypt = function (str) {
        // Return the encrypted string.
        try {
            return hex2b64(this.getKey().encrypt(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's sign.
     * @param {string} str the string to sign
     * @param {function} digestMethod hash method
     * @param {string} digestName the name of the hash algorithm
     * @return {string} the signature encoded in base64
     * @public
     */
    JSEncrypt.prototype.sign = function (str, digestMethod, digestName) {
        // return the RSA signature of 'str' in 'hex' format.
        try {
            return hex2b64(this.getKey().sign(str, digestMethod, digestName));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's verify.
     * @param {string} str the string to verify
     * @param {string} signature the signature encoded in base64 to compare the string to
     * @param {function} digestMethod hash method
     * @return {boolean} whether the data and signature match
     * @public
     */
    JSEncrypt.prototype.verify = function (str, signature, digestMethod) {
        // Return the decrypted 'digest' of the signature.
        try {
            return this.getKey().verify(str, b64tohex(signature), digestMethod);
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
     * will be created and returned
     * @param {callback} [cb] the callback to be called if we want the key to be generated
     * in an async fashion
     * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
     * @public
     */
    JSEncrypt.prototype.getKey = function (cb) {
        // Only create new if it does not exist.
        if (!this.key) {
            // Get a new private key.
            this.key = new JSEncryptRSAKey();
            if (cb && {}.toString.call(cb) === "[object Function]") {
                this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
                return;
            }
            // Generate the key.
            this.key.generate(this.default_key_size, this.default_public_exponent);
        }
        return this.key;
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateKey();
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateBaseKeyB64();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicKey();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicBaseKeyB64();
    };
    JSEncrypt.version = version$1;
    return JSEncrypt;
}());

// A class to manage token for CodemaoAuth and business parties.
var CodemaoToken = /** @class */ (function () {
    function CodemaoToken() {
        this.request = new CodemaoRequest({
            public_headers: __assign({ 'Product-Code': getAuthConfig().product_code, Platform: getAuthConfig().platform }, PUBLIC_HEADERS),
        });
    }
    CodemaoToken.prototype.dispatch_request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request.dispatch_request(options)];
            });
        });
    };
    // Get the full access token -- 'type access-token'
    CodemaoToken.prototype.get_complete_access_token = function () {
        var token_type = get_cookie(get_cookie_name('token_type'));
        var access_token = get_cookie(get_cookie_name('access'));
        if (is_cookie_exist(token_type) && is_cookie_exist(access_token)) {
            return token_type + " " + access_token;
        }
        else {
            // Clear the previous access & type cookie.
            var domain = getConfig().domain;
            clear_cookie(get_cookie_name('access'), domain);
            clear_cookie(get_cookie_name('token_type'), domain);
            throw new CodemaoError({
                error_code: ERROR_TYPE.NO_TOKEN,
                message: 'NO Token(cookie might have been expired). Please login.',
            });
        }
    };
    // Get local access token which stored in cookie.
    CodemaoToken.prototype.get_access = function (authorization) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.check();
                        switch (_a) {
                            case 'ACCESS_EXIST': return [3 /*break*/, 1];
                            case 'REFRESH_EXIST': return [3 /*break*/, 2];
                            case 'NO_TOKEN': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 7];
                    case 1: 
                    // Get the access token directly.
                    return [2 /*return*/, this.get_complete_access_token()];
                    case 2: 
                    // Refresh firstly, then get access token.
                    return [4 /*yield*/, this.refresh()];
                    case 3:
                        // Refresh firstly, then get access token.
                        _b.sent();
                        return [2 /*return*/, this.get_complete_access_token()];
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.convert_cookie_to_token(authorization)];
                    case 5:
                        res = _b.sent();
                        this.set(res.data);
                        return [2 /*return*/, this.get_complete_access_token()];
                    case 6:
                        err_1 = _b.sent();
                        // Case 2: no token and no cookie or get cookie_invalid
                        this.clear();
                        throw new CodemaoError({
                            error_code: ERROR_TYPE.NO_TOKEN,
                            message: 'NO Token. Please login.',
                        });
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CodemaoToken.prototype.convert_cookie_to_token = function (authorization) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: TIGER_TOKEN_API.GET_TOKEN_FROM_OLD_COOKIE,
                        method: 'post',
                        headers: authorization
                            ? {
                                Authorization: "Bearer " + authorization,
                            }
                            : {},
                    })];
            });
        });
    };
    // Get local refresh token which stored in cookie.
    CodemaoToken.prototype.get_refresh = function () {
        if (getInitParams().auth_version) {
            if (this.check() === 'NO_TOKEN') {
                throw new CodemaoError({
                    error_code: ERROR_TYPE.NO_TOKEN,
                    message: 'NO Token. Please login.',
                });
            }
        }
        return get_cookie(get_cookie_name('refresh'));
    };
    // Pass the token to cookie.
    // Every time after auth.login_xxx() & refresh().
    CodemaoToken.prototype.set = function (token) {
        var access = token.access, refresh = token.refresh;
        var domain = getConfig().domain;
        // Set access token to cookie.
        if (access && access.token && access.type && access.expires_in) {
            set_cookie({
                name: get_cookie_name('access'),
                value: access.token,
                domain: domain,
                max_age: access.expires_in,
            });
            // Set token type to cookie.
            set_cookie({
                name: get_cookie_name('token_type'),
                value: access.type,
                domain: domain,
                max_age: access.expires_in,
            });
        }
        else {
            console.warn('Unexpected access token response from back-end: ', access);
        }
        // Check if refresh_token exists.
        // Set it to cookie if it exists.
        if (refresh) {
            if (!refresh.token || !refresh.expires_in) {
                console.warn('Unexpected refresh token response from back-end: ', refresh);
            }
            set_cookie({
                name: get_cookie_name('refresh'),
                value: refresh.token,
                domain: domain,
                max_age: refresh.expires_in,
            });
        }
    };
    // Refresh token from back-end.
    CodemaoToken.prototype.refresh_token = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        method: 'put',
                        url: TIGER_TOKEN_API.REFRESH_TOKEN,
                        data: {
                            refresh_token: this.get_refresh(),
                        },
                    })];
            });
        });
    };
    // Refresh token from back-end and pass it to cookie.
    CodemaoToken.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token_res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.refresh_token()];
                    case 1:
                        token_res = _a.sent();
                        this.set(token_res.data);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        // Clear cookie when refresh_token is invalid.
                        if (err_2.error_code === ERROR_TYPE.REFRESH_TOKEN_INVALID) {
                            this.clear();
                        }
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Check if it's necessary to refresh token.
    CodemaoToken.prototype.check = function () {
        // access_token is not expired
        if (is_cookie_exist(get_cookie(get_cookie_name('access'))) &&
            is_cookie_exist(get_cookie(get_cookie_name('token_type')))) {
            return 'ACCESS_EXIST';
        }
        // access_token expired, refresh_token is not expired.
        if (is_cookie_exist(get_cookie(get_cookie_name('refresh')))) {
            return 'REFRESH_EXIST';
        }
        // both of them are expired.
        // or,
        // someone tries to request the api without login.
        return 'NO_TOKEN';
    };
    // Clear local token through setting cookie.
    CodemaoToken.prototype.clear = function () {
        var domain = getConfig().domain;
        clear_cookie(get_cookie_name('access'), domain);
        clear_cookie(get_cookie_name('token_type'), domain);
        clear_cookie(get_cookie_name('refresh'), domain);
    };
    return CodemaoToken;
}());
function retry_when_token_err(retries, fn) {
    return __awaiter(this, void 0, void 0, function () {
        var result, err_3, error_code, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 2:
                    err_3 = _a.sent();
                    error_code = err_3.error_code;
                    if (!(error_code === ERROR_TYPE.TOKEN_INVALID && retries > 1)) return [3 /*break*/, 4];
                    token = new CodemaoToken();
                    return [4 /*yield*/, token.refresh()];
                case 3:
                    _a.sent();
                    return [2 /*return*/, retry_when_token_err(retries - 1, fn)];
                case 4: throw err_3;
                case 5: return [2 /*return*/];
            }
        });
    });
}

var _instance;
function init(params) {
    if (!params.appid)
        params.appid = '';
    initParamsValidateHelper(params);
    setAuthConfig(params);
    if (['pid', 'appid', 'product_code', 'platform'].every(function (param) {
        return hasProperty(param, getAuthConfig());
    })) {
        _instance = new CodemaoAuth();
        return _instance;
    }
    else {
        throw new Error('Auth init fail.Check init params.');
    }
}
/**
 * @function 根据断言判断是否合并header更新信息
 * @param originalHeader         required 被merge header
 * @param assertion              断言
 * @param specifiedNewHeader     更多指定信息
 */
var mergeHeaderConf = function (originalHeader, assertion, specifiedNewHeader) {
    return assertion !== false
        ? __assign(__assign(__assign({}, originalHeader), { 'X-Captcha-Id': getAuthConfig().appid || '' }), specifiedNewHeader) : originalHeader;
};
// TODO hi,buddys！后续希望大家不要再使用英文写注释了。
/**
 *
 * en: Returns the CodemaoAuth object. You must initialize the CodemaoAuth object
 * with iris.auth.init() before calling this method.
 *
 * zh-cn: 使用前须先通过iris.auth.init实例一个CodemaoAuth对象
 *
 * @export
 * @returns
 */
function get_auth_instance() {
    // 没有实例
    if (!_instance) {
        throw new CodemaoError({
            message: 'Iris SDK error: Please run init() correctly, before get_auth_instance().',
        });
    }
    return _instance;
}
var retries_when_got_token_err = 2;
var CodemaoAuth = /** @class */ (function () {
    function CodemaoAuth() {
        var _a;
        this.request = new CodemaoRequest({
            public_headers: __assign(__assign({ 'Product-Code': getAuthConfig().product_code, pid: getAuthConfig().pid, Platform: getAuthConfig().platform }, PUBLIC_HEADERS), (_a = getInitParams()) === null || _a === void 0 ? void 0 : _a.custom_headers),
        });
        this.token = new CodemaoToken();
    }
    /**
     * Dispatch a request with options.
     *
     * @param options
     * @returns {Promise<{}>}
     */
    CodemaoAuth.prototype.dispatch_request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(options.with_token && getInitParams().auth_version)) return [3 /*break*/, 2];
                        options.headers = options.headers || {};
                        // eslint-disable-next-line require-atomic-updates
                        _a = options.headers;
                        _b = 'Authorization';
                        return [4 /*yield*/, this.token.get_access()];
                    case 1:
                        // eslint-disable-next-line require-atomic-updates
                        _a[_b] = _c.sent();
                        return [2 /*return*/, retry_when_token_err(retries_when_got_token_err, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, this.request.dispatch_request(options)];
                            }); }); })];
                    case 2: return [2 /*return*/, this.request.dispatch_request(options)];
                }
            });
        });
    };
    /**
     * @function     发送邮箱注册验证码
     * @param email  待注册邮箱
     * @param ticket 凭证
     */
    CodemaoAuth.prototype.email_register_send_captcha = function (email, ticket) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                validate_email_address(email);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SEND_EMAIL_REGISTERATION_CAPTCHA,
                        method: 'post',
                        data: {
                            email: email,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * @function        验证邮箱注册验证码
     * @param  email    待注册邮箱
     * @param  captcha  邮箱注册验证码
     */
    CodemaoAuth.prototype.validate_email_register_captcha = function (email, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                validate_email_address(email);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.VERIFY_EMAIL_REGISTERATION_CAPTCHA,
                        method: 'post',
                        data: {
                            email: email,
                            captcha: captcha,
                        },
                    })];
            });
        });
    };
    /**
     * @function 邮箱注册账号
     * @param    request_body {captchaTicket: string, password: string, rePassword: string}  待注册邮箱
     */
    CodemaoAuth.prototype.register_email = function (register_params, pid) {
        return __awaiter(this, void 0, void 0, function () {
            var captchaTicket, password, rePassword;
            return __generator(this, function (_a) {
                captchaTicket = register_params.captchaTicket, password = register_params.password, rePassword = register_params.rePassword;
                check_password(password);
                check_password(rePassword);
                check_if_pwd_equals_confirmed_pwd(password, rePassword);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REGISTER_BY_EMAIL,
                        method: 'post',
                        data: {
                            captchaTicket: captchaTicket,
                            password: password,
                            rePassword: rePassword,
                            pid: pid,
                        },
                    })];
            });
        });
    };
    /**
     * @function   获取所有协议列表
     */
    CodemaoAuth.prototype.get_agreements = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.GET_AGREEMENTS,
                        method: 'get',
                    })];
            });
        });
    };
    /**
     * @function   获取需签署的协议列表
     */
    CodemaoAuth.prototype.get_agreements_need_sign = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.GET_AGREEMENTS_NEED_SIGN,
                        method: 'get',
                    })];
            });
        });
    };
    /**
     * @function   签署协议
     */
    CodemaoAuth.prototype.sign_agreements = function (agreement_ids, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SIGN_AGREEMENTS,
                        method: 'post',
                        data: {
                            agreement_ids: agreement_ids,
                            pid: pid,
                        },
                    })];
            });
        });
    };
    /**
     * @function  查询最新协议-免登录开放接口
     * @param     codeList 协议code集合
     * @param     pid      业务方pid
     */
    CodemaoAuth.prototype.find_latest_protocol_list = function (codeList, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.FIND_LATEST_PROTOCOL_LIST,
                        method: 'post',
                        data: {
                            codeList: codeList,
                            pid: pid,
                        },
                    })];
            });
        });
    };
    /**
     * @function  请求语音验证码
     * @param     phone_number 手机号码
     * @param     type         类型
     * @param     ticket       图形验证码ticket
     */
    CodemaoAuth.prototype.send_voice_captcha = function (captcha_params, ticket, oauth_ticket) {
        return __awaiter(this, void 0, void 0, function () {
            var phone_number, type, register_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phone_number = captcha_params.phone_number, type = captcha_params.type;
                        check_phone_number(phone_number);
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.VOICE_CAPTCHA,
                                method: 'post',
                                data: {
                                    phone_number: phone_number,
                                    type: type.toUpperCase(),
                                    oauth_ticket: oauth_ticket,
                                },
                                headers: mergeHeaderConf({
                                    'X-Captcha-Ticket': ticket,
                                }),
                            })];
                    case 1:
                        register_res = _a.sent();
                        if (register_res.status === 200) {
                            this.token.set(register_res.data.auth.token);
                        }
                        return [2 /*return*/, register_res];
                }
            });
        });
    };
    /**
     * @function  请求语音验证码 (加密)
     * @param     cipherPhone 手机号码
     * @param     type         类型
     * @param     ticket       图形验证码ticket
     */
    CodemaoAuth.prototype.send_voice_captcha_encrypt = function (captcha_params, ticket, oauth_ticket) {
        return __awaiter(this, void 0, void 0, function () {
            var cipherPhone, type, register_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cipherPhone = captcha_params.cipherPhone, type = captcha_params.type;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.VOICE_CAPTCHA,
                                method: 'post',
                                data: {
                                    cipherPhone: cipherPhone,
                                    type: type.toUpperCase(),
                                    oauth_ticket: oauth_ticket,
                                },
                                headers: mergeHeaderConf({
                                    'X-Captcha-Ticket': ticket,
                                }),
                            })];
                    case 1:
                        register_res = _a.sent();
                        if (register_res.status === 200) {
                            this.token.set(register_res.data.auth.token);
                        }
                        return [2 /*return*/, register_res];
                }
            });
        });
    };
    /**
     * 发送手机号码注册验证码
     *
     * @param phone_number
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.register_send_captcha = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REGISTER_SEND_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 发送手机号码注册验证码(加密)
     *
     * @param cipherPhone
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.register_send_captcha_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REGISTER_SEND_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 手机号码注册
     *
     * @param options
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.register = function (options, specific_pid) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, register_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // TODO: 该方法主要校验存在性，check_register_options已做，不需要
                        check_input_existence(options, [
                            'phone_number',
                            'captcha',
                            'password',
                            'agreement_ids',
                        ]);
                        check_register_options(options);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.REGISTER,
                                method: 'post',
                                data: __assign(__assign({}, options), { pid: pid }),
                            })];
                    case 1:
                        register_res = _a.sent();
                        if (register_res.status === 200) {
                            this.token.set(register_res.data.auth.token);
                        }
                        return [2 /*return*/, register_res];
                }
            });
        });
    };
    /**
     * 手机号码注册 (加密)
     *
     * @param options
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.register_encrypt = function (options, specific_pid) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, register_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // TODO: 该方法主要校验存在性，check_register_options已做，不需要
                        check_input_existence(options, [
                            'cipherPhone',
                            'captcha',
                            'password',
                            'agreement_ids',
                        ]);
                        check_register_encrypt_options(options);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.REGISTER,
                                method: 'post',
                                data: __assign(__assign({}, options), { pid: pid }),
                            })];
                    case 1:
                        register_res = _a.sent();
                        if (register_res.status === 200) {
                            this.token.set(register_res.data.auth.token);
                        }
                        return [2 /*return*/, register_res];
                }
            });
        });
    };
    /**
     * 发送登录验证码
     *
     * @param phone_number
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.login_captcha = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.LOGIN_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 发送登录验证码 （加密）
     *
     * @param cipherPhone
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.login_captcha_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.LOGIN_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 手机登录
     *
     * @param phone_number
     * @param captcha
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.login_phone = function (phone_number, captcha, specific_pid, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        check_phone_number(phone_number);
                        check_captcha(captcha);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_PHONE,
                                method: 'post',
                                data: {
                                    phone_number: phone_number,
                                    captcha: captcha,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 手机登录 （加密）
     *
     * @param cipherPhone
     * @param captcha
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.login_phone_encrypt = function (cipherPhone, captcha, specific_pid, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        check_captcha(captcha);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_PHONE,
                                method: 'post',
                                data: {
                                    cipherPhone: cipherPhone,
                                    captcha: captcha,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 账号登录
     *
     * @param identity
     * @param password
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.login_account = function (identity, password, specific_pid, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_ACCOUNT,
                                method: 'post',
                                data: {
                                    identity: identity,
                                    password: password,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 账号登录(加密)
     *
     * @param identity
     * @param password
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.login_account_encrypt = function (cipherIdentity, password, specific_pid, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_ACCOUNT,
                                method: 'post',
                                data: {
                                    cipherIdentity: cipherIdentity,
                                    password: password,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 微信网页端登录
     *
     * @param code
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     * @param appid 可选,不传默认开放平台网页应用登录, 也可传编程猫下各公众号appid，需联系后端账号负责人配置
     */
    CodemaoAuth.prototype.login_wechat = function (code, agreement_ids, specific_pid, appid) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_WECHAT,
                                method: 'post',
                                data: {
                                    code: code,
                                    pid: pid,
                                    appid: appid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200 && login_res.data.auth) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * @function QQ网页端登录
     * @param code
     * @param specific_pid 可选参数，以特定的pid进行这次请求
     */
    CodemaoAuth.prototype.login_qq = function (code, agreement_ids, specific_pid) {
        return __awaiter(this, void 0, void 0, function () {
            var pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_QQ,
                                method: 'post',
                                data: {
                                    code: code,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200 && login_res.data.auth) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 发送第三方绑定手机验证码
     *
     * @param {string} phone_number - 手机号码
     * @param {string} oauth_ticket - 身份凭证
     * @param {Headers} [headers] - 请求头信息
     * @returns
     */
    CodemaoAuth.prototype.bind_phone_for_third_party = function (phone_number, oauth_ticket, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_FOR_THIRD_PARTY,
                        method: 'post',
                        headers: headers,
                        data: {
                            phone_number: phone_number,
                            oauth_ticket: oauth_ticket,
                        },
                    })];
            });
        });
    };
    /**
     * 发送第三方绑定手机验证码 (加密)
     *
     * @param {string} cipherPhone - 手机号码
     * @param {string} oauth_ticket - 身份凭证
     * @param {Headers} [headers] - 请求头信息
     * @returns
     */
    CodemaoAuth.prototype.bind_phone_for_third_party_encrypt = function (cipherPhone, oauth_ticket, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_FOR_THIRD_PARTY,
                        method: 'post',
                        headers: headers,
                        data: {
                            cipherPhone: cipherPhone,
                            oauth_ticket: oauth_ticket,
                        },
                    })];
            });
        });
    };
    /**
     * 第三方登录（激活）
     *
     * @param {string} oauth_ticket - 身份凭证
     * @param {string} [captcha] - 登录验证码
     * @param {number[]} [agreement_ids] - 签署的协议 ID 组成的数组，默认[-1]
     * @param {Headers} [headers] - 请求头信息
     * @returns
     */
    CodemaoAuth.prototype.create_user_for_third_party = function (oauth_ticket, captcha, agreement_ids, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (captcha) {
                            check_captcha(captcha);
                        }
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.CREATE_USER_FOR_THIRD_PARTY,
                                method: 'post',
                                headers: headers,
                                data: captcha
                                    ? {
                                        oauth_ticket: oauth_ticket,
                                        captcha: captcha,
                                        agreement_ids: agreement_ids || [-1],
                                    }
                                    : {
                                        oauth_ticket: oauth_ticket,
                                        agreement_ids: agreement_ids || [-1],
                                    },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 退出登录
     *
     */
    CodemaoAuth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dispatch_request({
                            url: Api.LOGOUT,
                            method: 'post',
                            data: {
                                refresh_token: this.token.get_refresh(),
                            },
                            with_token: true,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res) {
                            this.token.clear();
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 发送绑定手机验证码
     *
     * @param phone_number
     * @param pid
     */
    CodemaoAuth.prototype.bind_phone_captcha = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 发送绑定手机验证码(加密)
     *
     * @param phone_number
     * @param pid
     */
    CodemaoAuth.prototype.bind_phone_captcha_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 绑定手机
     *
     * @param phone_number
     * @param captcha
     */
    CodemaoAuth.prototype.bind_phone = function (phone_number, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE,
                        method: 'patch',
                        data: {
                            phone_number: phone_number,
                            captcha: captcha,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 绑定手机 (加密)
     *
     * @param phone_number
     * @param captcha
     */
    CodemaoAuth.prototype.bind_phone_encrypt = function (cipherPhone, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE,
                        method: 'patch',
                        data: {
                            cipherPhone: cipherPhone,
                            captcha: captcha,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 检测输入手机是否当前绑定手机
     *
     * @param phone_number
     */
    CodemaoAuth.prototype.bind_phone_check = function (phone_number) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_CHECK,
                        method: 'get',
                        params: {
                            phone_number: phone_number,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 检测输入手机是否当前绑定手机 （加密）
     *
     * @param cipherPhone
     */
    CodemaoAuth.prototype.bind_phone_check_encrypt = function (cipherPhone) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_PHONE_CHECK,
                        method: 'get',
                        params: {
                            cipherPhone: cipherPhone,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 发送更新绑定手机的验证码
     *
     * @param phone_number
     * @param old_phone_number
     * @param pid
     */
    CodemaoAuth.prototype.rebind_phone_captcha = function (phone_number, old_phone_number, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                check_phone_number(old_phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REBIND_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            old_phone_number: old_phone_number,
                            pid: pid,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 发送更新绑定手机的验证码(加密)
     *
     * @param cipherPhone
     * @param oldCipherPhone
     * @param pid
     */
    CodemaoAuth.prototype.rebind_phone_captcha_encrypt = function (cipherPhone, oldCipherPhone, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REBIND_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            oldCipherPhone: oldCipherPhone,
                            pid: pid,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 更新绑定手机
     *
     * @param phone_number
     * @param captcha
     */
    CodemaoAuth.prototype.rebind_phone = function (phone_number, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REBIND_PHONE,
                        method: 'patch',
                        data: {
                            phone_number: phone_number,
                            captcha: captcha,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 更新绑定手机 （加密）
     *
     * @param cipherPhone
     * @param captcha
     */
    CodemaoAuth.prototype.rebind_phone_encrypt = function (cipherPhone, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.REBIND_PHONE,
                        method: 'patch',
                        data: {
                            cipherPhone: cipherPhone,
                            captcha: captcha,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 发送重置密码的验证码
     *
     * @param phone_number
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.reset_pwd_captcha = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.RESET_PWD_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 发送重置密码的验证码 （加密）
     *
     * @param cipherPhone
     * @param ticket
     * @param pid
     */
    CodemaoAuth.prototype.reset_pwd_captcha_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.RESET_PWD_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 检测并重置密码ticket
     *
     * @param phone_number
     * @param captcha
     */
    CodemaoAuth.prototype.reset_pwd_token = function (phone_number, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.RESET_PWD_TOKEN,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            captcha: captcha,
                        },
                    })];
            });
        });
    };
    /**
     * 检测并重置密码ticket (加密)
     *
     * @param cipherPhone
     * @param captcha
     */
    CodemaoAuth.prototype.reset_pwd_token_encrypt = function (cipherPhone, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.RESET_PWD_TOKEN,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            captcha: captcha,
                        },
                    })];
            });
        });
    };
    /**
     * 重置密码
     *
     * @param ticket
     * @param pwd
     * @param pwd_confirm
     */
    CodemaoAuth.prototype.reset_pwd = function (ticket, pwd, pwd_confirm) {
        return __awaiter(this, void 0, void 0, function () {
            var request_options;
            return __generator(this, function (_a) {
                check_password(pwd);
                check_password(pwd_confirm);
                check_if_pwd_equals_confirmed_pwd(pwd, pwd_confirm);
                request_options = {
                    url: Api.RESET_PWD,
                    method: 'patch',
                    data: {
                        ticket: ticket,
                        password: pwd,
                        confirm_password: pwd_confirm,
                    },
                };
                return [2 /*return*/, this.dispatch_request(request_options)];
            });
        });
    };
    /**
     * 通用验证码之发送验证码
     *
     * @param {string} phone_number
     * @param {string} ticket
     * @param {string} pid
     */
    CodemaoAuth.prototype.send_universal_captcha = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SEND_UNIVERSAL_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 通用验证码之发送验证码 （加密）
     *
     * @param {string} cipherPhone
     * @param {string} ticket
     * @param {string} pid
     */
    CodemaoAuth.prototype.send_universal_captcha_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SEND_UNIVERSAL_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 通用验证码之校验验证码
     *
     * @param {string} phone_number
     * @param {string} captcha
     */
    CodemaoAuth.prototype.verify_universal_captcha = function (phone_number, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.VERIFY_UNIVERSAL_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            captcha: captcha,
                        },
                    })];
            });
        });
    };
    /**
     * 通用验证码之校验验证码
     *
     * @param {string} cipherPhone
     * @param {string} captcha
     */
    CodemaoAuth.prototype.verify_universal_captcha_encrypt = function (cipherPhone, captcha) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_captcha(captcha);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.VERIFY_UNIVERSAL_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            captcha: captcha,
                        },
                    })];
            });
        });
    };
    /**
     * 发送登录验证码(静默注册版本)
     *
     * @param {string} phone_number
     * @param {string} ticket
     * @param {string} pid
     */
    CodemaoAuth.prototype.login_captcha_silence = function (phone_number, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.LOGIN_CAPTCHA_SILENCE,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 发送登录验证码(静默注册版本)
     *
     * @param {string} phone_number
     * @param {string} ticket
     * @param {string} pid
     */
    CodemaoAuth.prototype.login_captcha_silence_encrypt = function (cipherPhone, ticket, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.LOGIN_CAPTCHA_SILENCE,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        headers: mergeHeaderConf({
                            'X-Captcha-Ticket': ticket,
                        }),
                    })];
            });
        });
    };
    /**
     * 手机登录(静默注册版)
     *
     * @param {string} phone_number
     * @param {string} captcha
     * @param {string} specific_pid 特定的pid
     */
    // public async login_phone_silence(phone_number: any, captcha: any, specific_pid: any): Promise<SilenceLoginResponse>;
    // public async login_phone_silence(
    //   login_info: {
    //     phone_number: string;
    //     captcha: string;
    //     agreement_ids?: number[];
    //   },
    //   specific_pid?: string,
    // ): Promise<SilenceLoginResponse>;
    CodemaoAuth.prototype.login_phone_silence = function (first_param, second_param, third_param, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var phone_number, captcha, 
            // agreement_ids = undefined,
            specific_pid, pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phone_number = '', captcha = '', specific_pid = '';
                        if (typeof first_param === 'string') {
                            phone_number = first_param || '';
                            captcha = second_param || '';
                            specific_pid = third_param || '';
                        }
                        if (typeof first_param === 'object') {
                            phone_number = (first_param === null || first_param === void 0 ? void 0 : first_param.phone_number) || '';
                            captcha = (first_param === null || first_param === void 0 ? void 0 : first_param.captcha) || '';
                            // agreement_ids = first_param?.agreement_ids || undefined;
                            agreement_ids = first_param === null || first_param === void 0 ? void 0 : first_param.agreement_ids;
                            specific_pid = second_param || '';
                        }
                        check_phone_number(phone_number);
                        check_captcha(captcha);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_PHONE_SILENCE,
                                method: 'post',
                                data: {
                                    phone_number: phone_number,
                                    captcha: captcha,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    CodemaoAuth.prototype.login_phone_silence_encrypt = function (first_param, second_param, third_param, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var cipherPhone, captcha, 
            // agreement_ids = undefined,
            specific_pid, pid, login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cipherPhone = '', captcha = '', specific_pid = '';
                        if (typeof first_param === 'string') {
                            cipherPhone = first_param || '';
                            captcha = second_param || '';
                            specific_pid = third_param || '';
                        }
                        if (typeof first_param === 'object') {
                            cipherPhone = (first_param === null || first_param === void 0 ? void 0 : first_param.cipherPhone) || '';
                            captcha = (first_param === null || first_param === void 0 ? void 0 : first_param.captcha) || '';
                            // agreement_ids = first_param?.agreement_ids || undefined;
                            agreement_ids = first_param === null || first_param === void 0 ? void 0 : first_param.agreement_ids;
                            specific_pid = second_param || '';
                        }
                        check_captcha(captcha);
                        pid = specific_pid || getAuthConfig().pid;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.LOGIN_PHONE_SILENCE,
                                method: 'post',
                                data: {
                                    cipherPhone: cipherPhone,
                                    captcha: captcha,
                                    pid: pid,
                                    agreement_ids: agreement_ids || [-1],
                                },
                            })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    CodemaoAuth.prototype.get_access_token = function (authorization) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.token.get_access(authorization)];
            });
        });
    };
    CodemaoAuth.prototype.request_with_token = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var token_options;
            return __generator(this, function (_a) {
                token_options = {
                    with_token: true,
                    without_base_url: true,
                };
                return [2 /*return*/, this.dispatch_request(Object.assign(options, token_options))];
            });
        });
    };
    /**
     * 设置用户名
     *
     * @param username
     */
    CodemaoAuth.prototype.set_username = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_username(username);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SET_USERNAME,
                        method: 'patch',
                        data: {
                            username: username,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 设置初始密码
     *
     * @param pwd
     * @param pwd_confirm
     */
    CodemaoAuth.prototype.init_password = function (pwd, pwd_confirm) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_password(pwd);
                check_password(pwd_confirm);
                check_if_pwd_equals_confirmed_pwd(pwd, pwd_confirm);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.INIT_PASSWORD,
                        method: 'patch',
                        data: {
                            password: pwd,
                            confirm_password: pwd_confirm,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 更新密码（通过提供旧密码）
     *
     * @param old_pwd
     * @param new_pwd
     * @param new_pwd_confirm
     */
    CodemaoAuth.prototype.change_pwd_by_old = function (old_pwd, new_pwd, new_pwd_confirm) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // U.check_password(old_pwd);
                        check_password(new_pwd);
                        check_password(new_pwd_confirm);
                        check_if_pwd_equals_confirmed_pwd(new_pwd, new_pwd_confirm);
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.CHANGE_PWD_BY_OLD,
                                method: 'patch',
                                data: {
                                    old_password: old_pwd,
                                    password: new_pwd,
                                    confirm_password: new_pwd_confirm,
                                },
                                with_token: true,
                            })];
                    case 1:
                        res = _a.sent();
                        if (res) {
                            this.token.clear();
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 发送更新密码的验证码
     *
     * @param phone_number
     * @param pid
     */
    CodemaoAuth.prototype.change_pwd_by_phone_captcha = function (phone_number, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                check_phone_number(phone_number);
                return [2 /*return*/, this.dispatch_request({
                        url: Api.CHNAGE_PWD_BY_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            phone_number: phone_number,
                            pid: pid,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 发送更新密码的验证码（加密）
     *
     * @param phone_number
     * @param pid
     */
    CodemaoAuth.prototype.change_pwd_by_phone_captcha_encrypt = function (cipherPhone, pid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.CHNAGE_PWD_BY_PHONE_CAPTCHA,
                        method: 'post',
                        data: {
                            cipherPhone: cipherPhone,
                            pid: pid,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 更新密码（通过手机）
     *
     * @param phone_number
     * @param captcha
     * @param pwd
     */
    CodemaoAuth.prototype.change_pwd_by_phone = function (phone_number, captcha, pwd) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        check_phone_number(phone_number);
                        check_captcha(captcha);
                        check_password(pwd);
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.CHANGE_PWD_BY_PHONE,
                                method: 'patch',
                                data: {
                                    phone_number: phone_number,
                                    captcha: captcha,
                                    password: pwd,
                                },
                                with_token: true,
                            })];
                    case 1:
                        res = _a.sent();
                        if (res) {
                            this.token.clear();
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 更新密码（通过手机）加密
     *
     * @param cipherPhone
     * @param captcha
     * @param pwd
     */
    CodemaoAuth.prototype.change_pwd_by_phone_encrypt = function (cipherPhone, captcha, pwd) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        check_captcha(captcha);
                        check_password(pwd);
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.CHANGE_PWD_BY_PHONE,
                                method: 'patch',
                                data: {
                                    cipherPhone: cipherPhone,
                                    captcha: captcha,
                                    password: pwd,
                                },
                                with_token: true,
                            })];
                    case 1:
                        res = _a.sent();
                        if (res) {
                            this.token.clear();
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 更新用户信息
     *
     * @param profile
     */
    CodemaoAuth.prototype.set_profile = function (profile) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (profile) {
                    check_input_existence(profile, [
                        'nickname',
                        'avatar_url',
                        'fullname',
                        'birthday',
                        'sex',
                        'qq',
                        'description',
                        'grade',
                    ]);
                    check_profile(profile);
                }
                return [2 /*return*/, this.dispatch_request({
                        url: Api.SET_PROFILE,
                        method: 'patch',
                        data: __assign({}, profile),
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 第三方服务绑定状态
     *
     */
    CodemaoAuth.prototype.check_bind_for_third_party = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.CHECK_BIND_FOR_THIRD_PARTY,
                        method: 'get',
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 绑定微信
     *
     * @param code 第三方授权后会在回调地址携带code的参数
     * @param appid 可选,不传默认开放平台网页应用登录, 也可传编程猫下各公众号appid，需联系后端账号负责人配置
     */
    CodemaoAuth.prototype.bind_wechat = function (code, appid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_WECHAT,
                        method: 'post',
                        data: {
                            code: code,
                            appid: appid,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 解绑微信
     *
     */
    CodemaoAuth.prototype.unbind_wechat = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.UNBIND_WECHAT,
                        method: 'patch',
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 绑定QQ
     *
     */
    CodemaoAuth.prototype.bind_qq = function (code, pid, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.BIND_QQ,
                        method: 'post',
                        data: {
                            code: code,
                            agreement_ids: agreement_ids,
                        },
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 解绑QQ
     *
     */
    CodemaoAuth.prototype.unbind_qq = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.UNBIND_QQ,
                        method: 'patch',
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 获取基本用户信息
     *
     */
    CodemaoAuth.prototype.get_profile = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.GET_PROFILE,
                        method: 'get',
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 获取主账号信息（私密信息）
     */
    CodemaoAuth.prototype.get_auth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.GET_AUTH,
                        method: 'get',
                        with_token: true,
                    })];
            });
        });
    };
    /**
     * 极验账号登录
     *
     * @param {string} identity 用户的标识，支持传用户名，手机号，email
     * @param {string} password 登录密码
     * @param {string} pid 产品对外id
     * @param {string} auth_version Auth版本的标识，用于兼容
     * @param {string} ticket
     */
    CodemaoAuth.prototype.login_account_ticket = function (identity, password, pid, ticket, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dispatch_request({
                            url: Api.LOGIN_ACCOUNT_TICKET,
                            method: 'post',
                            data: {
                                identity: identity,
                                password: password,
                                pid: pid,
                                agreement_ids: agreement_ids || [-1],
                            },
                            headers: mergeHeaderConf({
                                'X-Captcha-Ticket': ticket,
                            }),
                        })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    /**
     * 极验账号登录(加密版)
     *
     * @param {string} cipherIdentity 用户的标识，支持传用户名，手机号，email
     * @param {string} password 登录密码
     * @param {string} pid 产品对外id
     * @param {string} auth_version Auth版本的标识，用于兼容
     * @param {string} ticket
     */
    CodemaoAuth.prototype.login_account_ticket_encrypt = function (cipherIdentity, password, pid, ticket, agreement_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var login_res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dispatch_request({
                            url: Api.LOGIN_ACCOUNT_TICKET,
                            method: 'post',
                            data: {
                                cipherIdentity: cipherIdentity,
                                password: password,
                                pid: pid,
                                agreement_ids: agreement_ids || [-1],
                            },
                            headers: mergeHeaderConf({
                                'X-Captcha-Ticket': ticket,
                            }),
                        })];
                    case 1:
                        login_res = _a.sent();
                        if (login_res.status === 200) {
                            this.token.set(login_res.data.auth.token);
                        }
                        return [2 /*return*/, login_res];
                }
            });
        });
    };
    CodemaoAuth.prototype.get_grade_list = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.dispatch_request({
                        url: Api.GET_GRADE_LIST,
                        method: 'get',
                    })];
            });
        });
    };
    /**
     * RSA 加密信息
     *
     * @param {string} field 需要加密的信息
     */
    CodemaoAuth.prototype.rsa_encrypt_field = function (identity) {
        return __awaiter(this, void 0, void 0, function () {
            var result, res, publicKey, encryptor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = identity;
                        return [4 /*yield*/, this.dispatch_request({
                                url: Api.GET_PUBLIC_KEY,
                                method: 'get',
                            })];
                    case 1:
                        res = _a.sent();
                        if (res.status === 200 && res.data.publicKey) {
                            publicKey = res.data.publicKey;
                            encryptor = new JSEncrypt();
                            encryptor.setPublicKey(publicKey); // 设置公钥
                            result = encryptor.encrypt(identity) || ''; // 对内容进行加密
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return CodemaoAuth;
}());

var auth = /*#__PURE__*/Object.freeze({
__proto__: null,
init: init,
get_auth_instance: get_auth_instance,
CodemaoAuth: CodemaoAuth
});

var getFingerPrint = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var getHash = function () {
                    if (typeof Fingerprint2 !== 'undefined') {
                        Fingerprint2.get(function (components) {
                            var values = components.map(function (component) { return component.value; });
                            resolve(Fingerprint2.x64hash128(values.join(''), 31));
                        });
                    }
                    else {
                        resolve('');
                    }
                };
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(getHash);
                }
                else {
                    setTimeout(getHash, 500);
                }
            })];
    });
}); };

var BasicCaptcha = /** @class */ (function () {
    function BasicCaptcha(opt) {
        this.options = opt;
    }
    return BasicCaptcha;
}());

var captchaResourceUrls = {
    FINGER_PRINT_2: 'https://static.codemao.cn/iris/fingerprint2.min.js',
    // 极验
    GEETEST: 'https://static.codemao.cn/arch/gt.js',
    // 腾讯
    TENCENT: 'https://turing.captcha.qcloud.com/TCaptcha.js',
    // 数美
    NEXTDATA: 'https://static.codemao.cn/arch/smcp.min.js',
    // 数美（连接新加机房）
    // NEXTDATA_ABROAD: 'https://static.codemao.cn/arch/smcp.min.js',
    // 网易
    NETEASE: 'https://static.codemao.cn/arch/netease-load.min.js',
    // 阿里云
    ALIYUN: 'https://g.alicdn.com/AWSC/AWSC/awsc.js',
};
var fallbackParamsMaker = function (reminder, errorObject) {
    return {
        message: reminder,
        error: errorObject,
    };
};

var defaultGeetestInitOptions = {
    product: 'bind',
    width: '300px',
};
var GeetestCaptcha = /** @class */ (function (_super) {
    __extends(GeetestCaptcha, _super);
    function GeetestCaptcha(options) {
        var _this = _super.call(this, options) || this;
        _this.product_id = options.product_id || '';
        _this.dom_id = options.dom_id;
        _this.success_callback = options.success_callback;
        _this.init_options = options.init_options;
        _this.fail_callback = options.fail_callback;
        _this.close_callback = options.close_callback;
        return _this;
    }
    GeetestCaptcha.prototype.get_init_params = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.GET_GEETEST_PARAMS,
                        method: 'post',
                        data: {
                            appid: this.product_id,
                        },
                    })];
            });
        });
    };
    GeetestCaptcha.prototype.init_geetest = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, retry(3, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, this.get_init_params()];
                        }); }); })];
                    case 1:
                        params = _a.sent();
                        data = params.data;
                        return [2 /*return*/, new Promise(function (resolve) {
                                initGeetest(__assign({ gt: data.gt, challenge: data.challenge, offline: !data.success, new_captcha: data.new_captcha }, options), function (captcha_obj) {
                                    captcha_obj
                                        .onReady(function () {
                                        resolve(captcha_obj);
                                    })
                                        .onSuccess(function () { return __awaiter(_this, void 0, void 0, function () {
                                        var ticket_res, error_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, this.get_ticket()];
                                                case 1:
                                                    ticket_res = _a.sent();
                                                    this.success_callback(ticket_res.data.ticket, this.product_id);
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    error_1 = _a.sent();
                                                    this.fail_callback && this.fail_callback(error_1);
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); })
                                        .onError(function () {
                                        if (_this.fail_callback) {
                                            _this.fail_callback();
                                        }
                                        throw new Error('Got error in Geetest captcha.');
                                    })
                                        .onClose(function () {
                                        if (!_this.captcha_obj.getValidate() && _this.close_callback) {
                                            _this.close_callback();
                                        }
                                    });
                                });
                            })];
                }
            });
        });
    };
    GeetestCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var init_options, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        init_options = this.init_options || defaultGeetestInitOptions;
                        return [4 /*yield*/, load_script(captchaResourceUrls.GEETEST, 'geetest-captcha')];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.init_geetest(init_options)];
                    case 2:
                        _a.captcha_obj = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeetestCaptcha.prototype.show = function () {
        // Show the captcha.
        if (this.init_options && this.init_options.product !== 'bind') {
            this.captcha_obj.appendTo("#" + this.dom_id);
            // When product is 'bind', it need to use verify() to show the captcha.
            return;
        }
        else {
            this.captcha_obj.verify();
        }
    };
    GeetestCaptcha.prototype.get_ticket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                result = this.captcha_obj.getValidate();
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.CHECK_AND_GET_GEETEST_TICKET,
                        method: 'post',
                        data: {
                            geetest_challenge: result.geetest_challenge,
                            geetest_validate: result.geetest_validate,
                            geetest_seccode: result.geetest_seccode,
                            appid: this.product_id,
                        },
                    })];
            });
        });
    };
    GeetestCaptcha.create = function (create_options, extra) {
        var dom_id = create_options.dom_id, success_callback = create_options.success_callback, fail_callback = create_options.fail_callback, close_callback = create_options.close_callback, specified_appid = create_options.product_id, init_options = create_options.init_options;
        return new GeetestCaptcha({
            product_id: specified_appid || extra.appid,
            dom_id: dom_id,
            success_callback: success_callback,
            fail_callback: fail_callback,
            close_callback: close_callback,
            init_options: init_options,
        });
    };
    return GeetestCaptcha;
}(BasicCaptcha));

// 数美文档 📖 https://help.ishumei.com/docs/tw/captcha/WEB
var defaultSMInitOptions = {
    product: 'popup',
    width: 300,
};
var SMCaptcha = /** @class */ (function (_super) {
    __extends(SMCaptcha, _super);
    function SMCaptcha(opts) {
        var _this = _super.call(this, opts) || this;
        _this.instance = new Object();
        _this.options = opts;
        _this.instance = new Object();
        return _this;
    }
    SMCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof initSMCaptcha === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, load_script(captchaResourceUrls.NEXTDATA, 'SM_GT')];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        // TODO: 需要校验dom_id等与产品模式的关系？
                        _a = this;
                        return [4 /*yield*/, this.init_smCaptcha()];
                    case 3:
                        // TODO: 需要校验dom_id等与产品模式的关系？
                        _a.instance = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SMCaptcha.prototype.init_smCaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, dom_id, success_callback, fail_callback, close_callback, init_options;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.options, dom_id = _a.dom_id, success_callback = _a.success_callback, fail_callback = _a.fail_callback, close_callback = _a.close_callback, init_options = _a.init_options;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        initSMCaptcha(__assign(__assign(__assign({ appendTo: dom_id && "#" + dom_id, appid: _this.options.product_id }, defaultSMInitOptions), init_options), { organization: 'sXoTexBWs1dfyzt8eTev' }), function (instance) {
                            if (!instance) {
                                throw new Error('shumei captcha init failed message: can not get instance');
                            }
                            instance.onReady(function () {
                                resolve(instance);
                            });
                            instance.onSuccess(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                var ticket_res, error_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!data.pass) return [3 /*break*/, 5];
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this.get_ticket()];
                                        case 2:
                                            ticket_res = (_a.sent());
                                            success_callback === null || success_callback === void 0 ? void 0 : success_callback(ticket_res.data.ticket, this.options.product_id || '');
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_1 = _a.sent();
                                            fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(fallbackParamsMaker('success_callback triggerd fatal error', error_1));
                                            return [3 /*break*/, 4];
                                        case 4: return [3 /*break*/, 6];
                                        case 5:
                                            fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(fallbackParamsMaker('incorrect captcha checking', data));
                                            _a.label = 6;
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); });
                            instance.onError(function (errType, errMsg) {
                                var errorObj = fallbackParamsMaker('some error occurred', {
                                    errType: errType,
                                    errMsg: errMsg,
                                });
                                fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(errorObj);
                                reject(errorObj);
                            });
                            instance.onClose(function () {
                                close_callback === null || close_callback === void 0 ? void 0 : close_callback();
                            });
                        });
                    })];
            });
        });
    };
    SMCaptcha.prototype.show = function () {
        var init_options = this.options.init_options;
        if (this.options &&
            ['embed', 'float'].includes((init_options === null || init_options === void 0 ? void 0 : init_options.product) || '')) {
            this.instance.appendTo("#" + this.options.dom_id);
            return;
        }
        this.instance.verify();
    };
    SMCaptcha.prototype.get_ticket = function (rid) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                result = this.instance.getValidate();
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.CHECK_AND_GET_NEXTDATA_TICKET,
                        method: 'post',
                        data: {
                            rid: result.rid,
                            appid: this.options.product_id,
                        },
                    })];
            });
        });
    };
    SMCaptcha.create = function (create_options, extra) {
        var dom_id = create_options.dom_id, success_callback = create_options.success_callback, fail_callback = create_options.fail_callback, close_callback = create_options.close_callback, init_options = create_options.init_options, specified_appid = create_options.product_id;
        return new SMCaptcha({
            product_id: specified_appid || extra.appid,
            dom_id: dom_id,
            success_callback: success_callback,
            fail_callback: fail_callback,
            close_callback: close_callback,
            init_options: init_options,
        });
    };
    return SMCaptcha;
}(BasicCaptcha));

// 腾讯是智能模式，所以不需要初始化默认值
var defaultTencentInitOptions = {};
var CmTencentCaptcha = /** @class */ (function (_super) {
    __extends(CmTencentCaptcha, _super);
    function CmTencentCaptcha(options) {
        var _this = _super.call(this, options) || this;
        _this.product_id = options.product_id || '';
        _this.dom_id = options.dom_id;
        _this.success_callback = options.success_callback;
        _this.fail_callback = options.fail_callback;
        _this.close_callback = options.close_callback;
        _this.request = new CodemaoRequest();
        return _this;
    }
    CmTencentCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof TencentCaptcha === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, load_script(captchaResourceUrls.TENCENT, 'TENCENT_GT')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.initTencentCaptcha(this.dom_id)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CmTencentCaptcha.prototype.initTencentCaptcha = function (dom_id) {
        return __awaiter(this, void 0, void 0, function () {
            var tencentCaptchaCallback;
            var _this = this;
            return __generator(this, function (_a) {
                tencentCaptchaCallback = function (res) { return __awaiter(_this, void 0, void 0, function () {
                    var ticket_res, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (res == null) {
                                    return [2 /*return*/];
                                }
                                if (!(res.ret === 0)) return [3 /*break*/, 5];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.get_ticket(res.ticket, res.randstr)];
                            case 2:
                                ticket_res = _a.sent();
                                this.success_callback(ticket_res.data.ticket, this.product_id);
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                this.fail_callback && this.fail_callback(error_1);
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                if (res.ret === 1) {
                                    if (this.fail_callback) {
                                        this.fail_callback();
                                    }
                                }
                                else if (res.ret === 2) {
                                    if (this.close_callback) {
                                        this.close_callback();
                                    }
                                }
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); };
                if (dom_id) {
                    this.captcha_obj = new TencentCaptcha(document.getElementById(dom_id), this.product_id, tencentCaptchaCallback, defaultTencentInitOptions);
                }
                else {
                    this.captcha_obj = new TencentCaptcha(this.product_id, tencentCaptchaCallback, defaultTencentInitOptions);
                }
                return [2 /*return*/];
            });
        });
    };
    CmTencentCaptcha.prototype.show = function () {
        this.captcha_obj.show();
    };
    CmTencentCaptcha.prototype.get_ticket = function (ticket, randstr) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.CHECK_AND_GET_TENCENT_TICKET,
                        method: 'post',
                        data: {
                            appid: this.product_id,
                            tencentTicket: ticket,
                            randomStr: randstr,
                        },
                    })];
            });
        });
    };
    CmTencentCaptcha.create = function (create_options, extra) {
        var dom_id = create_options.dom_id, success_callback = create_options.success_callback, fail_callback = create_options.fail_callback, close_callback = create_options.close_callback, specified_appid = create_options.product_id;
        return new CmTencentCaptcha({
            product_id: specified_appid || extra.appid,
            dom_id: dom_id,
            success_callback: success_callback,
            fail_callback: fail_callback,
            close_callback: close_callback,
        });
    };
    return CmTencentCaptcha;
}(BasicCaptcha));

// 网易文档 📖 https://support.dun.163.com/documents/15588062143475712?docId=294963579379175424&locale=zh-CN
var defaultNeteaseInitOptions = {
    mode: 'popup',
    width: 300,
};
var WrapperId = simpleHash('mask');
var InnerId = simpleHash('inner');
var NeteaseCaptcha = /** @class */ (function (_super) {
    __extends(NeteaseCaptcha, _super);
    function NeteaseCaptcha(opts) {
        var _this = _super.call(this, opts) || this;
        _this.instance = new Object();
        _this.options = opts;
        _this.instance = new Object();
        // 网易验证码使用popup模式必须要传入一个domNode，且根据它进行定位
        // 所以如果没有传入dom_id则需要为用户创建一个..
        var that = _this;
        (function () {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var offset;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            offset = 0 -
                                (((_b = (_a = that.options) === null || _a === void 0 ? void 0 : _a.init_options) === null || _b === void 0 ? void 0 : _b.width) || defaultNeteaseInitOptions.width) /
                                    2;
                            if (!(!that.options.dom_id && !document.getElementById(WrapperId))) return [3 /*break*/, 2];
                            return [4 /*yield*/, appendDomNode('div', {
                                    id: WrapperId,
                                    innerHTML: "<div style=\"position: absolute; width: 2px; height: 2px; left: 50%; top: 50%; transform: translate(-50%, -50%); margin: " + offset + "px 0 0 " + offset + "px\" id=\"" + InnerId + "\"/>",
                                }, "position: fixed;\n          left: 0px;\n          top: 0px;\n          height: 100vh;\n          width: 100vw;\n          background: rgba(0, 0, 0, .5);\n          z-index: 999;")];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        })();
        return _this;
    }
    NeteaseCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof initNECaptcha === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, load_script(captchaResourceUrls.NETEASE, 'NETEASE_GT')];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.init_NECaptcha()];
                    case 3:
                        _a.instance = _b.sent();
                        this.show();
                        return [2 /*return*/];
                }
            });
        });
    };
    NeteaseCaptcha.prototype.init_NECaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, dom_id, success_callback, fail_callback, close_callback, init_options;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.options, dom_id = _a.dom_id, success_callback = _a.success_callback, fail_callback = _a.fail_callback, close_callback = _a.close_callback, init_options = _a.init_options;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        initNECaptcha(__assign(__assign(__assign({ captchaId: _this.options.product_id, element: dom_id ? "#" + dom_id : "#" + InnerId, appendTo: dom_id ? "#" + dom_id : "#" + InnerId }, defaultNeteaseInitOptions), init_options), { onVerify: function (err, data) { return __awaiter(_this, void 0, void 0, function () {
                                var ticket_res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!err) return [3 /*break*/, 1];
                                            fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(fallbackParamsMaker('incorrect captcha checking', err));
                                            return [3 /*break*/, 3];
                                        case 1: return [4 /*yield*/, this.get_ticket(data.validate)];
                                        case 2:
                                            ticket_res = (_a.sent());
                                            success_callback === null || success_callback === void 0 ? void 0 : success_callback(ticket_res.data.ticket, this.options.product_id || '');
                                            this.clearMask();
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }, onError: function (err) {
                                fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(fallbackParamsMaker('fatal error occurred', err));
                            }, onClose: function () {
                                close_callback === null || close_callback === void 0 ? void 0 : close_callback();
                                _this.clearMask();
                            } }), function (instance) {
                            resolve(instance);
                        }, function (err) {
                            var errorObj = fallbackParamsMaker('some error occurred', err);
                            fail_callback === null || fail_callback === void 0 ? void 0 : fail_callback(errorObj);
                            reject(errorObj);
                        });
                    })];
            });
        });
    };
    NeteaseCaptcha.prototype.show = function () {
        this.instance.popUp();
    };
    NeteaseCaptcha.prototype.clearMask = function () {
        var mask = document.getElementById(WrapperId);
        mask &&
            setTimeout(function () {
                document.body.removeChild(mask);
            }, 600);
    };
    NeteaseCaptcha.prototype.get_ticket = function (validate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.CHECK_AND_GET_NETEASE_TICKET,
                        method: 'post',
                        data: {
                            validate: validate,
                            appid: this.options.product_id,
                        },
                    })];
            });
        });
    };
    NeteaseCaptcha.create = function (create_options, extra) {
        var dom_id = create_options.dom_id, success_callback = create_options.success_callback, fail_callback = create_options.fail_callback, close_callback = create_options.close_callback, init_options = create_options.init_options, specified_appid = create_options.product_id;
        return new NeteaseCaptcha({
            product_id: specified_appid || extra.appid,
            dom_id: dom_id,
            success_callback: success_callback,
            fail_callback: fail_callback,
            close_callback: close_callback,
            init_options: init_options,
        });
    };
    return NeteaseCaptcha;
}(BasicCaptcha));

var aliyun_config = {
    appkey: 'FFFF00000000017E8E25',
    scene: 'nc_login_h5',
};
var aliyun_captcha_dom_id = 'aliyun_captcha_dom_id';
var aliyun_captcha_dom_wrapper_id = 'aliyun_captcha_dom_wrapper_id';
var aliyun_captcha_dom_close_id = "aliyun_captcha_dom_close_id";
var AliyunCaptcha = /** @class */ (function (_super) {
    __extends(AliyunCaptcha, _super);
    function AliyunCaptcha(options) {
        var _this = _super.call(this, options) || this;
        _this.handleOnCancel = function () {
            _this.close_callback && _this.close_callback();
            _this.clearMask();
        };
        // 滑块验证
        _this.initNCCaptcha = function (config) {
            AWSC.use('nc', function (state, module) {
                // 初始化
                window.nc = module.init(__assign(__assign({}, config), { renderTo: aliyun_captcha_dom_id, 
                    // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                    success: function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var ticketData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.get_ticket(data)];
                                case 1:
                                    ticketData = _a.sent();
                                    if (ticketData.status === 200) {
                                        this === null || this === void 0 ? void 0 : this.success_callback(ticketData.data.ticket, ticketData.data.appid);
                                        this === null || this === void 0 ? void 0 : this.clearMask();
                                    }
                                    else {
                                        this.fail_callback && this.fail_callback(ticketData);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 
                    // 滑动验证失败时触发该回调参数。
                    fail: function (failCode) {
                        _this.fail_callback && _this.fail_callback(failCode);
                        throw new Error('验证失败');
                    }, 
                    // 验证码加载出现异常时触发该回调参数。
                    error: function (errorCode) {
                        _this.fail_callback && _this.fail_callback(errorCode);
                        throw new Error('验证异常');
                    } }));
            });
        };
        _this.product_id = options.product_id || '';
        _this.dom_id = options.dom_id;
        _this.success_callback = options.success_callback;
        _this.fail_callback = options.fail_callback;
        _this.close_callback = options.close_callback;
        _this.request = new CodemaoRequest();
        return _this;
    }
    AliyunCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof AWSC === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, load_script(captchaResourceUrls.ALIYUN, 'ALIYUN_GT')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.initAliyunCaptcha()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AliyunCaptcha.prototype.initAliyunCaptcha = function () {
        return __awaiter(this, void 0, void 0, function () {
            var aliyunCloseBtn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!document.getElementById(aliyun_captcha_dom_id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, appendDomNode('div', {
                                id: aliyun_captcha_dom_wrapper_id,
                                innerHTML: "\n            <div\n              style=\"position: absolute; display: flex; flex-direction: column; padding-top: 20px; justify-content: flex-start; align-items: center; width: 400px; height: 130px; background-color: #fff; left: 50%; top: 50%; transform: translate(-50%, -50%);\"\n            >\n              <div style=\"font-size: 20px\">\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u9A8C\u8BC1</div>\n              <div\n                style=\"display: flex; justify-content: center; align-items: center; bottom: 20px\"\n                id=\"" + aliyun_captcha_dom_id + "\"\n              >\n              </div>\n              <div id=\"" + aliyun_captcha_dom_close_id + "\" style=\"cursor: pointer; color: blue; position: absolute; top: 20px; right: 20px\">\u5173\u95ED</div>\n            </div>\n          ",
                            }, "position: fixed;\n        left: 0px;\n        top: 0px;\n        height: 100vh;\n        width: 100vw;\n        background: rgba(0, 0, 0, .5);\n        z-index: 999;")];
                    case 1:
                        _a.sent();
                        aliyunCloseBtn = document.getElementById(aliyun_captcha_dom_close_id);
                        aliyunCloseBtn === null || aliyunCloseBtn === void 0 ? void 0 : aliyunCloseBtn.addEventListener('click', this.handleOnCancel);
                        _a.label = 2;
                    case 2:
                        return [2 /*return*/];
                }
            });
        });
    };
    AliyunCaptcha.prototype.clearMask = function () {
        var mask = document.getElementById(aliyun_captcha_dom_wrapper_id);
        mask &&
            setTimeout(function () {
                document.body.removeChild(mask);
            }, 600);
    };
    AliyunCaptcha.prototype.show = function () {
        this.initNCCaptcha(aliyun_config);
    };
    AliyunCaptcha.prototype.get_ticket = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, PlatformApi.dispatch_request({
                        url: PLATFORM_CAPTCHA_API.CHECK_AND_GET_ALIYUN_TICKET,
                        method: 'post',
                        data: __assign({ appKey: aliyun_config.appkey, scene: aliyun_config.scene }, params),
                    })];
            });
        });
    };
    AliyunCaptcha.create = function (create_options, extra) {
        var dom_id = create_options.dom_id, success_callback = create_options.success_callback, fail_callback = create_options.fail_callback, close_callback = create_options.close_callback, specified_appid = create_options.product_id;
        return new AliyunCaptcha({
            product_id: specified_appid || extra.appid,
            dom_id: dom_id,
            success_callback: success_callback,
            fail_callback: fail_callback,
            close_callback: close_callback,
        });
    };
    return AliyunCaptcha;
}(BasicCaptcha));

// TODO 错误处理
var CodemaoCaptcha = /** @class */ (function () {
    function CodemaoCaptcha(options) {
        this.pid = options.pid;
    }
    // 从服务端确定用哪个验证码服务商
    CodemaoCaptcha.prototype.get_rule_from_server = function (identity, scene) {
        if (scene === void 0) { scene = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var deviceId, timestamp, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, load_script(captchaResourceUrls.FINGER_PRINT_2, 'finger-print', 10)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, getFingerPrint()];
                    case 2:
                        deviceId = _a.sent();
                        timestamp = "" + new Date().getTime() / 1000;
                        return [4 /*yield*/, PlatformApi.dispatch_request({
                                url: PLATFORM_CAPTCHA_API.GET_RULE,
                                method: 'post',
                                data: {
                                    identity: identity,
                                    scene: scene,
                                    pid: getInitParams().pid || this.pid,
                                    deviceId: deviceId,
                                    timestamp: parseInt(timestamp, 10),
                                },
                            })];
                    case 3:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    CodemaoCaptcha.prototype.get_captcha = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var identity, _b, scene, success_callback, fail_callback, res, rule, appid, ticket, disableCaptcha;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        identity = options.identity, _b = options.scene, scene = _b === void 0 ? '' : _b, success_callback = options.success_callback, fail_callback = options.fail_callback;
                        return [4 /*yield*/, this.get_rule_from_server(identity, scene)];
                    case 1:
                        res = _c.sent();
                        // TODO: single if ?
                        if (res) {
                            rule = res.rule, appid = res.appid, ticket = res.ticket;
                            if (Object.keys(captchaResourceUrls).includes(rule)) {
                                // TODO: single if x2 ?
                                if (appid) {
                                    // 根据策略执行对应的算法
                                    return [2 /*return*/, (_a = strategyTargetSelector(rule)) === null || _a === void 0 ? void 0 : _a.create(options, { appid: appid })];
                                }
                            }
                            else {
                                disableCaptcha = new DisableCaptcha(ticket, success_callback, fail_callback);
                                return [2 /*return*/, disableCaptcha];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CodemaoCaptcha;
}());
var DisableCaptcha = /** @class */ (function () {
    function DisableCaptcha(ticket, success_callback, fail_callback) {
        this.ticket = ticket;
        this.success_callback = success_callback;
        this.fail_callback = fail_callback;
    }
    DisableCaptcha.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('DisableCaptcha init');
                return [2 /*return*/];
            });
        });
    };
    DisableCaptcha.prototype.show = function () {
        if (this.ticket) {
            this.success_callback(this.ticket, '');
        }
        else {
            if (this.fail_callback) {
                this.fail_callback();
            }
        }
    };
    return DisableCaptcha;
}());
// 策略分配
var strategyTargetSelector = function (contextKeyWhoNamedRuleByBackend) {
    switch (contextKeyWhoNamedRuleByBackend) {
        case 'GEETEST':
            return GeetestCaptcha;
        case 'TENCENT':
            return CmTencentCaptcha;
        case 'NETEASE':
            return NeteaseCaptcha;
        case 'NEXTDATA':
            return SMCaptcha;
        case 'ALIYUN':
            return AliyunCaptcha;
        case 'DEFAULT':
            return DisableCaptcha;
    }
};

var index = /*#__PURE__*/Object.freeze({
__proto__: null,
GeetestCaptcha: GeetestCaptcha,
SMCaptcha: SMCaptcha,
CmTencentCaptcha: CmTencentCaptcha,
NeteaseCaptcha: NeteaseCaptcha,
CodemaoCaptcha: CodemaoCaptcha,
DisableCaptcha: DisableCaptcha
});

function init$1(options) {
    var env = options.env, domain = options.domain, _a = options.auth_version, _b = options.pid, _c = options.client_id, requestTimeout = options.requestTimeout, host = options.host;
    if (env) {
        if (configs[env]) {
            setConfig(configs[env]);
            if (host) {
                var config = getConfig();
                config.host = host;
            }
        }
        else {
            console.warn("Unknown env \"" + env + "\", config has been set to default value.");
        }
    }
    if (domain !== undefined) {
        var config = getConfig();
        config.domain = domain;
    }
    setInitParams(options);
}

export { api as CodemaoApi, CodemaoError, CodemaoRequest, ERROR_TYPE as ERROR, utils as U, auth, index as captcha, init$1 as init };
